import {
  LitElement,
  html,
  css,
} from "https://cdn.jsdelivr.net/gh/lit/dist@3/core/lit-core.min.js";

// Preview Parameters Configuration
const PREVIEW_OPTIONS = {
  GOLD_CIRCLE: {
    id: "gold-circle",
    name: "Gold Circle",
    type: "circle",
    material: "gold",
    shape: "circle",
    color: "#f4dda5",
  },
  SILVER_CIRCLE: {
    id: "silver-circle",
    name: "Silver Circle",
    type: "circle",
    material: "silver",
    shape: "circle",
    color: "#e1e1e1",
  },
  GOLD_OVAL: {
    id: "gold-oval",
    name: "Gold Oval",
    type: "oval",
    material: "gold",
    shape: "oval",
  },
  SILVER_OVAL: {
    id: "silver-oval",
    name: "Silver Oval",
    type: "oval",
    material: "silver",
    shape: "oval",
  },
  GOLD_RECTANGLE: {
    id: "gold-rectangle",
    name: "Gold Rectangle",
    type: "rectangle",
    material: "gold",
    shape: "rectangle",
    color: "#f4dda5",
  },
  SILVER_RECTANGLE: {
    id: "silver-rectangle",
    name: "Silver Rectangle",
    type: "rectangle",
    material: "silver",
    shape: "rectangle",
    color: "#e1e1e1",
  },
  BIRTHSTONE: {
    id: "birthstone",
    name: "Birthstone",
    type: "birthstone",
    material: null,
    shape: null, // No circle/oval
  },
};

// Intercept minus button clicks for bundle items
// When user clicks minus on a bundle item, remove the entire bundle instead
document.addEventListener(
  "click",
  function (e) {
    const clickedElement = e.target;

    // Check if clicked element is the minus button
    const isMinusButton =
      clickedElement.closest(".js-qty__adjust--minus") ||
      clickedElement.classList?.contains("js-qty__adjust--minus");

    if (isMinusButton) {
      const minusButton =
        clickedElement.closest(".js-qty__adjust--minus") || clickedElement;
      const quantitySelector = minusButton.closest("quantity-selector");
      const cartItem = minusButton.closest(".cart__item");

      if (quantitySelector && cartItem) {
        const itemKey = quantitySelector.getAttribute("key");
        const input = quantitySelector.querySelector(".js-qty__num");
        const currentQty = parseInt(input?.value || 1);

        // If quantity is 1 (will go to 0), check if it's a bundle
        if (currentQty === 1) {
          // Get bundle ID from cart
          fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((cart) => {
              const item = cart.items.find((i) => i.key === itemKey);
              if (item && item.properties && item.properties._BundleId) {
                const bundleId = item.properties._BundleId;

                // Prevent the default quantity change
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                // Remove the entire bundle
                if (
                  window.removeBundle &&
                  typeof window.removeBundle === "function"
                ) {
                  window.removeBundle(bundleId);
                }
              }
            })
            .catch((err) => {

            });
        }
      }
    }
  },
  true
); // Use capture phase to catch it early

// Also handle clicks on the remove link (backup)
document.addEventListener(
  "click",
  function (e) {
    const clickedElement = e.target;

    // Check for remove bundle link
    const removeLink = clickedElement.closest(".remove-bundle-link");
    const cartItemRemove = clickedElement.closest(".cart__item-remove");
    const linkWithBundleId = cartItemRemove?.querySelector("[data-bundle-id]");
    const hasBundleId = clickedElement.getAttribute?.("data-bundle-id");

    const targetLink =
      removeLink || linkWithBundleId || (hasBundleId ? clickedElement : null);

    if (targetLink) {
      e.preventDefault();
      e.stopPropagation();

      const bundleId = targetLink.getAttribute("data-bundle-id");

      if (
        bundleId &&
        window.removeBundle &&
        typeof window.removeBundle === "function"
      ) {
        window.removeBundle(bundleId);
      }
    }
  },
  true
);

// Global function to remove a bundle from the cart
// Defined here to avoid touching legacy theme files
// This is a simpler, more direct approach that should work reliably
window.removeBundle = function (bundleId) {
  if (!bundleId) {

    return;
  }

  // Convert bundleId to string for consistent comparison
  const targetBundleId = String(bundleId).trim();

  // Simple approach: fetch cart, find all items with matching _BundleId, remove them all
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then((cart) => {
      // Collect all item keys that match this bundle
      const itemKeysToRemove = [];

      cart.items.forEach((item) => {
        // Check properties - Shopify cart.js returns properties as an object
        if (item.properties && item.properties._BundleId) {
          const itemBundleId = String(item.properties._BundleId).trim();

          if (itemBundleId === targetBundleId) {
            itemKeysToRemove.push(item.key);
          }
        }
      });

      if (itemKeysToRemove.length === 0) {
        window.location.reload();
        return;
      }

      // Remove items one at a time, fetching fresh cart after each removal
      // This ensures we always have valid item keys
      function removeBundleItemsRecursive() {
        return fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((cart) => {
            // Find remaining bundle items with fresh keys
            const remainingItems = cart.items.filter((item) => {
              if (item.properties && item.properties._BundleId) {
                const itemBundleId = String(item.properties._BundleId).trim();
                return itemBundleId === targetBundleId;
              }
              return false;
            });

            if (remainingItems.length === 0) {
              // Trigger cart refresh events
              document.dispatchEvent(new CustomEvent("cart:build"));
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              // Reload to ensure UI is in sync
              setTimeout(() => window.location.reload(), 300);
              return;
            }

            // Remove the first remaining item
            const itemToRemove = remainingItems[0];

            return fetch(window.Shopify.routes.root + "cart/change.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
              },
              body: JSON.stringify({
                id: itemToRemove.key,
                quantity: 0,
              }),
            })
              .then(async (response) => {
                if (!response.ok) {
                  // Continue anyway - might already be removed
                } else {
                  try {
                    await response.json();
                  } catch (e) {
                    // Empty cart response is okay
                  }
                }

                // Wait a bit for cart to update, then continue with next item
                return new Promise((resolve) => {
                  setTimeout(() => {
                    removeBundleItemsRecursive().then(resolve);
                  }, 200);
                });
              })
              .catch((err) => {
                // Continue with next item
                return new Promise((resolve) => {
                  setTimeout(() => {
                    removeBundleItemsRecursive().then(resolve);
                  }, 200);
                });
              });
          });
      }

      // Start recursive removal
      return removeBundleItemsRecursive();
    })
    .catch((error) => {

      // Don't show alert if items were actually removed - just reload
      // Check cart first to see if removal succeeded
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((cart) => {
          const hasBundleItems = cart.items.some(
            (item) =>
              item.properties &&
              item.properties._BundleId &&
              String(item.properties._BundleId).trim() ===
                String(bundleId).trim()
          );

          if (!hasBundleItems) {
            window.location.reload();
          } else {

            alert("Failed to remove bundle. Please try again.");
            window.location.reload();
          }
        })
        .catch(() => {
          // If we can't check, just reload
          window.location.reload();
        });
    });
};

export class CustomizerApp extends LitElement {
  // Disable shadow DOM - render directly to light DOM
  createRenderRoot() {
    return this;
  }

  static styles = css`
    :host {
      display: block;
      margin: 1rem 0;
      font-family: inherit;
    }
    .lit-container {
      padding: 1rem;
      border: 1px dashed #000;
      background-color: #f9f9f9;
      text-align: center;
    }
    button {
      margin-top: 0.5rem;
      cursor: pointer;
    }
    .btn--customize {
      background-color: #241918;
      color: #fff;
      width: 100% !important;
      transition: all 0.3s ease;
    }
      .btn--customize:hover {
      background-color: #d5a8ac;
      color: #fff;
      }
  `;

  static properties = {
    count: { type: Number },
    cssComponents: { type: String, attribute: "css-components" },
    cssCustom: { type: String, attribute: "css-custom" },
    cssOverrides: { type: String, attribute: "css-overrides" },
    addonData: { type: String, attribute: "addon-data" }, // Keep as string, parse manually
    selectedOption1: { type: String, attribute: "selected-option-1" },
    selectedOption2: { type: String, attribute: "selected-option-2" },
    selectedOption3: { type: String, attribute: "selected-option-3" },
    selectedVariantId: { type: String, attribute: "selected-variant-id" },
    selectedVariantPrice: { type: Number, attribute: "selected-variant-price" },
    productTitle: { type: String, attribute: "product-title" },
    productType: { type: String, attribute: "product-type" },
    productImage: { type: String, attribute: "product-image" },
    variantImage: { type: String, attribute: "variant-image" },
    blankBirthstonePendantGold: { type: String, attribute: "blank-birthstone-pendant-gold" },
    blankBirthstonePendantSilver: { type: String, attribute: "blank-birthstone-pendant-silver" },
    blankBirthstoneCharmGold: { type: String, attribute: "blank-birthstone-charm-gold" },
    isOpen: { type: Boolean, state: true },
    tabs: { type: Array, state: true }, // Array of objects: { id: uniqueId, type: 'addon', variantId: 123, productTitle: '...', variantTitle: '...', price: 100, selectedPreview: 'gold-circle', selectedSymbol: {...}, customizations: [...], customizationType: '...' }
    activeTab: { type: Number, state: true }, // Index of active tab (0 = main, 1+ = addon tabs, -1 = add new)
    isAddingToCart: { type: Boolean, state: true },
    typeFilter: { type: String, state: true }, // Current type filter for options grid (null = all)
    specialRequestEnabled: { type: Boolean, state: true }, // Toggle for special request
    specialRequestMessage: { type: String, state: true }, // Special request message text
    proofEmail: { type: String, state: true }, // Email for proof (Birth Flower Bouquet)
    giftWrapEnable: { type: Boolean, attribute: "gift-wrap-enable" },
    giftWrapProductId: { type: String, attribute: "gift-wrap-product-id" },
    giftWrapLabel: { type: String, attribute: "gift-wrap-label" },
    personalizeButtonText: { type: String, attribute: "personalize-button-text" },
    giftWrapEnabled: { type: Boolean, state: true }, // Toggle for gift wrap
  };

  constructor() {
    super();
    this.count = 0;
    this.cssComponents = "";
    this.cssCustom = "";
    this.cssOverrides = "";
    this.addonData = "";
    this.selectedOption1 = "";
    this.selectedOption2 = "";
    this.selectedOption3 = "";
    this.selectedVariantId = "";
    this.selectedVariantPrice = 0;
    this.productTitle = "";
    this.productType = "";
    this.productImage = "";
    this.variantImage = "";
    this.blankBirthstonePendantGold = "";
    this.blankBirthstonePendantSilver = "";
    this.blankBirthstoneCharmGold = "";
    this.isOpen = false;
    this.tabs = []; // Array of addon tabs (main is handled separately)
    this.activeTab = 0; // 0 = main, 1+ = addon tabs, -1 = add new
    this.isAddingToCart = false;
    this.typeFilter = null; // null = show all types
    this.initialAddonsInitialized = false; // Track if initial addons have been set up
    this.selections = {}; // Store selections for main and addon previews
    this._overlayElement = null; // Portal overlay element
    this._hoveredOption = null; // Track hovered option
    this.specialRequestEnabled = false; // Special request toggle state
    this.specialRequestMessage = ''; // Special request message
    this.proofEmail = ''; // Email for proof (Birth Flower Bouquet)
    this.giftWrapEnable = false;
    this.giftWrapProductId = '';
    this.giftWrapLabel = 'Add gift wrap';
    this.giftWrapEnabled = false; // Gift wrap toggle state
    this._giftWrapPrice = 0; // Cached gift wrap product price
    this._giftWrapAvailable = true; // Cached gift wrap availability
    this._mainManualText = ""; // Manual text for main product Initial/Name input
    this._injectStyles();
  }

  /**
   * Track customizer events for analytics (Clarity, Google Analytics, etc.)
   * @param {string} eventName - Name of the event
   * @param {object} eventData - Additional event data
   */
  _trackEvent(eventName, eventData = {}) {
    // Microsoft Clarity tracking
    if (window.clarity) {
      window.clarity('event', eventName, eventData);
    }
    
    // Google Analytics 4 tracking (if available)
    if (window.gtag) {
      window.gtag('event', eventName, {
        event_category: 'Customizer',
        ...eventData
      });
    }
    
    // Custom event dispatch for other analytics tools
    window.dispatchEvent(new CustomEvent('customizer:event', {
      detail: {
        event: eventName,
        data: eventData,
        productTitle: this.productTitle,
        variantId: this.selectedVariantId
      }
    }));
  }

  _injectStyles() {
    if (document.getElementById("customizer-drawer-styles")) return;

    const style = document.createElement("style");
    style.id = "customizer-drawer-styles";
    style.textContent = `
            .customizer-modal-overlay,
            customizer-app .customizer-modal-overlay {
                position: fixed !important;
                top: 0 !important;
                left: 0 !important;
                right: 0 !important;
                bottom: 0 !important;
                width: 100vw !important;
                height: 100vh !important;
                background: rgba(0, 0, 0, 0.5) !important;
                z-index: 2147483647 !important;
                opacity: 0 !important;
                visibility: hidden !important;
                pointer-events: none !important;
                transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s, visibility 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s !important;
                backdrop-filter: blur(0px) !important;
                margin: 0 !important;
                padding: 0 !important;
            }
                .smaller-text {
                font-size: 16px !important;}
            .customizer-modal-overlay.is-open,
            customizer-app .customizer-modal-overlay.is-open {
                opacity: 1 !important;
                visibility: visible !important;
                pointer-events: auto !important;
            }
            .customizer__modal-content,
            customizer-app .customizer__modal-content {
                width: 31.5rem !important;
                max-width: 31.5rem !important;
                background: white !important;
                font-size: 14px !important;
                line-height: 1.4 !important;
                color: #333 !important;
                position: fixed !important;
                top: 0 !important;
                right: -100% !important;
                height: 100vh !important;
                max-height: 100vh !important;
                overflow: hidden !important;
                transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s !important;
                box-shadow: -2px 0 20px rgba(0, 0, 0, 0.2) !important;
                z-index: 2147483647 !important;
                will-change: right !important;
                transform: translateZ(0) !important;
                margin: 0 !important;
                display: flex !important;
                flex-direction: column !important;
            }
            .customizer__content-scrollable,
            customizer-app .customizer__content-scrollable {
                flex: 1 !important;
                overflow-y: auto !important;
                padding-bottom: 1rem !important;
            }
            .customizer__actions,
            customizer-app .customizer__actions {
                position: sticky !important;
                bottom: 0 !important;
                background: white !important;
                padding: 1rem !important;
                z-index: 10 !important;
                flex-shrink: 0 !important;
            }
            .customizer-modal-overlay.is-open .customizer__modal-content,
            customizer-app .customizer-modal-overlay.is-open .customizer__modal-content {
                right: 0 !important;
            }
            @media (max-width: 768px) {
                .customizer__modal-content,
                customizer-app .customizer__modal-content {
                    width: 100% !important;
                    max-width: 100vw !important;
                }
                
                .customizer__content-scrollable,
                customizer-app .customizer__content-scrollable {
                    -webkit-overflow-scrolling: touch !important;
                    padding-bottom: 1.5rem !important;
                }
                
                .customizer__header,
                customizer-app .customizer__header {
                    padding: 0.75rem 1rem !important;
                    font-size: 16px !important;
                    min-height: 48px !important;
                }
                
                .customizer__actions,
                customizer-app .customizer__actions {
                    padding: 1rem !important;
                    border-top: 1px solid #eee !important;
                }
            }
        `;
    document.head.appendChild(style);
  }

  // Parse addon data from attribute
  _parseAddonData() {
    if (!this.addonData) {
      return [];
    }

    if (typeof this.addonData === "string") {
      try {
        const parsed = JSON.parse(this.addonData);
        return parsed;
      } catch (e) {

        return [];
      }
    }

    return Array.isArray(this.addonData) ? this.addonData : [];
  }

  _increment() {
    this.count++;
  }

  _reset() {
    // Reset all customizer state
    // Preserve gift wrap and special request toggles when adding/removing items
    const preservedGiftWrapEnabled = this.giftWrapEnabled;
    const preservedSpecialRequestEnabled = this.specialRequestEnabled;
    const preservedSpecialRequestMessage = this.specialRequestMessage;
    
    this.tabs = [];
    this.activeTab = 0;
    this.typeFilter = null;
    this.selections = {};
    this._hoveredOption = null;
    this.isAddingToCart = false;
    this._mainManualText = ""; // Reset main product manual text
    
    // Reset initialization flag so default addons will be re-initialized when modal opens
    this.initialAddonsInitialized = false;
    
    // Restore preserved values
    this.giftWrapEnabled = preservedGiftWrapEnabled;
    this.specialRequestEnabled = preservedSpecialRequestEnabled;
    this.specialRequestMessage = preservedSpecialRequestMessage;
    
    // Note: Don't reset _giftWrapPrice as it's fetched from product
    // Update UI if overlay is still in DOM (though it should be closed)
    if (this._overlayElement) {
      this._updateOverlayContent();
    }

  }

  _closeModal() {
    // Helper to explicitly close modal and restore scroll
    this.isOpen = false;
    // Use removeProperty for more effective removal
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow-x');
    document.body.style.removeProperty('overflow-y');
    // Also remove lock-scroll class that might be set by other components
    document.documentElement.classList.remove('lock-scroll');
    if (this._overlayElement) {
      this._overlayElement.classList.remove("is-open");
    }
    // Force a reflow to ensure the style is applied
    void document.body.offsetHeight;
  }

  _toggleModal() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      document.body.style.overflow = "hidden";
      this._ensureOverlayPortal();
      // Track customizer opened
      this._trackEvent('customizer_opened', {
        productTitle: this.productTitle,
        variantId: this.selectedVariantId,
        hasAddons: this.tabs && this.tabs.length > 0
      });
    } else {
      this._closeModal();
      // Track customizer closed
      this._trackEvent('customizer_closed', {
        productTitle: this.productTitle,
        variantId: this.selectedVariantId,
        tabsCount: this.tabs ? this.tabs.length : 0,
        hasMainSelection: !!this.selections?.main
      });
    }
  }

  _ensureOverlayPortal() {
    // Create overlay element if it doesn't exist, but keep it in DOM always
    if (!this._overlayElement) {
      this._overlayElement = document.createElement("div");
      this._overlayElement.className = "customizer-modal-overlay";
      this._overlayElement.setAttribute("data-customizer-portal", "true");
      document.body.appendChild(this._overlayElement);
      
      // Setup custom length listener if not already set up
      if (!this._customLengthListenerSetup) {
        this._setupCustomLengthListener();
        this._customLengthListenerSetup = true;
      }
    }

    // Initialize all addons if this is the first time opening
    if (this.isOpen && !this.initialAddonsInitialized) {
      this._initializeAllAddons();
      // Force update after initialization
      this.requestUpdate();
    } else if (this.isOpen && this.initialAddonsInitialized && this.tabs && this.tabs.length > 0) {
      // If customizer was already initialized but is reopening, update addon variants
      // in case the finish changed while the customizer was closed
      this._updateAddonVariantsForFinish();
    }

    // Update overlay content
    this._updateOverlayContent();

    // Add is-open class after content is set, using a tiny delay to ensure DOM is ready
    setTimeout(() => {
      if (this._overlayElement && this.isOpen) {
        this._overlayElement.classList.add("is-open");
      }
    }, 0);
  }

  _getAllVariantOptions() {
    // Get all variant options dynamically from the variant picker
    const variantPicker = document.querySelector('block-variant-picker');
    if (!variantPicker) return [];
    
    const options = [];
    const optionWrappers = variantPicker.querySelectorAll('.variant-wrapper, .variant-button-wrap');
    
    optionWrappers.forEach((wrapper) => {
      // Get the option name from the label - try multiple selectors
      let optionName = '';
      const label = wrapper.querySelector('label:not(.visually-hidden), legend');
      if (label) {
        // Get text content but exclude any child elements like icons or tooltips
        const labelClone = label.cloneNode(true);
        // Remove tooltip triggers and other non-text elements
        labelClone.querySelectorAll('.variant__label-info, [data-tooltip], .visually-hidden').forEach(el => el.remove());
        optionName = labelClone.textContent?.trim() || '';
      }
      
      // If no label found, try to get from data-handle attribute
      if (!optionName) {
        const dataHandle = wrapper.querySelector('[data-handle]')?.getAttribute('data-handle');
        if (dataHandle) {
          // Convert handle to readable name (e.g., "chain-style" -> "Chain Style")
          optionName = dataHandle.split('-').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' ');
        }
      }
      
      // Get the selected value
      let selectedValue = null;
      const select = wrapper.querySelector('select');
      if (select && select.value) {
        selectedValue = select.value;
      } else {
        const checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
        if (checkedRadio && checkedRadio.value) {
          selectedValue = checkedRadio.value;
        }
      }
      
      // Only add if we have both name and value, and it's not a default/title option
      if (optionName && selectedValue && 
          optionName.toLowerCase() !== 'default' && 
          optionName.toLowerCase() !== 'title') {
        options.push({
          name: optionName,
          value: selectedValue,
          handle: wrapper.querySelector('[data-handle]')?.getAttribute('data-handle') || ''
        });
      }
    });
    
    return options;
  }

  _renderProductHeaderHTML() {
    const totalPrice = this._calculateTotal();
    const formattedPrice = (totalPrice / 100).toFixed(2);
    const basePrice = (this.selectedVariantPrice / 100).toFixed(2);
    const imageUrl = this.variantImage || this.productImage || "";

    // Get all variant options dynamically
    const allOptions = this._getAllVariantOptions();
    
    // Build variant info string dynamically
    const variantInfo = [];
    
    // Check for custom option values (Size, Length)
    const customOptionInputs = document.querySelectorAll('input[data-custom-option-input]');
    const customOptionValues = new Map();
    customOptionInputs.forEach(input => {
      if (input.value) {
        const optionName = input.dataset.optionName || '';
        const value = parseFloat(input.value);
        if (!isNaN(value) && value >= 10 && value <= 30) {
          customOptionValues.set(optionName.toLowerCase(), input.value);
        }
      }
    });
    
    // Process each option - format: "Option Name: Value" or just "Value" for cleaner display
    allOptions.forEach((option) => {
      const optionNameLower = option.name.toLowerCase();
      const valueLower = option.value.toLowerCase();
      
      // Check if this is a Size or Length option with "other" (English) or "autre" (French) selected
      if ((optionNameLower.includes('length') || optionNameLower.includes('longueur') || optionNameLower === 'size' || optionNameLower === 'taille') && 
          (valueLower.includes('other') || valueLower.includes('autre')) && 
          customOptionValues.has(optionNameLower)) {
        // For Size/Length with custom value, show: "Size: Other (15)" or "Length: Other (15)"
        const customValue = customOptionValues.get(optionNameLower);
        variantInfo.push(`${option.name}: ${option.value} (${customValue})`);
      } else {
        // For other options, show: "Option Name: Value"
        variantInfo.push(`${option.name}: ${option.value}`);
      }
    });
    
    // Fallback to selectedOption1/2/3 if dynamic detection fails
    if (variantInfo.length === 0) {
      if (this.selectedOption1)
        variantInfo.push(`Finish: ${this.selectedOption1}`);
      if (this.selectedOption2) {
        const option2Lower = this.selectedOption2.toLowerCase();
        if ((option2Lower.includes('other') || option2Lower.includes('autre')) && customLengthValue) {
          variantInfo.push(`Length: ${this.selectedOption2} (${customLengthValue})`);
        } else {
          variantInfo.push(`Length: ${this.selectedOption2}`);
        }
      }
      if (this.selectedOption3) variantInfo.push(`${this.selectedOption3}`);
    }

    return `
            <div class="customizer__product-header">
                ${
                  imageUrl
                    ? `
                    <div class="customizer__product-image">
                        <img src="${imageUrl}" alt="${
                        this.productTitle || "Product"
                      }" loading="lazy">
                    </div>
                `
                    : ""
                }
                <div class="customizer__product-info">
                    <h3 class="h4 product-single__title">${
                      this.productTitle || "Product"
                    }</h3>
                    ${
                      variantInfo.length > 0
                        ? `
                        <div class="customizer__product-variants">
                            ${variantInfo.join(" • ")}
                        </div>
                    `
                        : ""
                    }
                    <div class="customizer__product-price">
                        ${
                          this.tabs.length > 0
                            ? `
                            <div class="customizer__price-breakdown">
                                Base: $${basePrice}${this.tabs
                                .filter((tab) => !tab.isInitial) // Only show price for non-initial addons
                                .map(
                                  (tab, index) =>
                                    ` • Addon ${index + 1}: $${(
                                      tab.price / 100
                                    ).toFixed(2)}`
                                )
                                .join("")}
                            </div>
                        `
                            : ""
                        }
                        <div class="block-price__regular product__price smaller-text">$${formattedPrice}</div>
                    </div>
                </div>
            </div>
        `;
  }

  _setupCustomLengthListener() {
    // Listen for changes to custom option inputs (Size, Length) and update header
    const handleCustomOptionChange = (e) => {
      if (e.target && e.target.hasAttribute('data-custom-option-input')) {
        // Update the overlay content to reflect the new custom value
        if (this._overlayElement && this.isOpen) {
          this._updateOverlayContent();
        }
      }
    };
    
    document.addEventListener('input', handleCustomOptionChange);
    document.addEventListener('blur', handleCustomOptionChange, true);
    
    // Also listen for variant changes to update header with all options
    document.addEventListener('change', (e) => {
      const target = e.target;
      // Check if variant option changed
      if (target.closest('block-variant-picker') || 
          target.hasAttribute('data-variant-input') ||
          (target.type === 'radio' && target.closest('.variant-button-wrap')) ||
          (target.tagName === 'SELECT' && target.closest('.variant-wrapper'))) {
        // Update the overlay content to reflect new variant options
        if (this._overlayElement && this.isOpen) {
          // Small delay to ensure variant picker has updated
          setTimeout(() => {
            this._updateOverlayContent();
          }, 50);
        }
      }
    });
  }

  _handleManualTextInput(inputElement, previewId, isMain, typeFilterLower) {
    // Safety check - ensure this is called on the component instance
    // If called incorrectly, try to get the correct instance from window
    let instance = this;
    if (!instance || !instance.tabs || typeof instance.requestUpdate !== 'function') {
      if (window.customizerApp) {
        instance = window.customizerApp;
      } else {

        return;
      }
    }
    
    // Ensure _mainManualText is initialized
    if (typeof instance._mainManualText === 'undefined') {
      instance._mainManualText = "";
    }
    
    const value = inputElement.value;
    
    // Store the value
    if (isMain) {
      instance._mainManualText = value;
    } else {
      const tab = instance.tabs.find(t => `preview-${t.id}` === previewId);
      if (tab) {
        tab.manualText = value;
      }
    }
    
    // Update counter
    const counter = inputElement.nextElementSibling;
    if (counter && counter.classList.contains('manual-counter')) {
      const isInitial = typeFilterLower === "initial" || typeFilterLower === "initials";
      counter.textContent = isInitial ? value.length + '/1' : value.length + '/10';
    }
    
    // Ensure first font is selected if needed (for Initial/Name types)
    if (isMain && value && value.trim()) {
      instance._ensureFirstFontSelected(true);
    } else if (!isMain && value && value.trim()) {
      // For addon tabs, find the tab and ensure font is selected
      const tab = instance.tabs.find(t => `preview-${t.id}` === previewId);
      if (tab) {
        instance._ensureFirstFontSelectedForTab(tab);
      }
    }
    
    // Update preview in real-time - use double requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        instance._updatePreviewForManualText(previewId, isMain);
        // Trigger validation check to update Add to Cart button state
        if (instance.isOpen && instance._overlayElement) {
          // Force a full re-render to update button state
          instance.requestUpdate();
          // Small delay to ensure state is updated before re-rendering overlay
          setTimeout(() => {
            instance._updateOverlayContent();
            // Also manually update button disabled state
            const addCartButton = instance._overlayElement?.querySelector('.customizer__add-cart');
            if (addCartButton) {
              const hasAllSelections = instance._hasAllSelections();
              if (hasAllSelections) {
                addCartButton.removeAttribute('disabled');
              } else {
                addCartButton.setAttribute('disabled', 'disabled');
              }
            }
          }, 50);
        }
      });
    });
    }

  _updatePreviewForManualText(previewId, isMain) {
    // Helper method to update preview when font style changes or manual text is typed
    const manualText = isMain ? this._mainManualText : this.tabs.find(t => `preview-${t.id}` === previewId)?.manualText;
    const textValue = (manualText || '').trim();
    
    // Normalize previewId - handle both "main" and "preview-{id}" formats
    let normalizedPreviewId = previewId;
    if (isMain && previewId !== "main") {
      normalizedPreviewId = "main";
    } else if (!isMain && !previewId.startsWith("preview-")) {
      const tab = this.tabs.find(t => `preview-${t.id}` === previewId);
      if (tab) {
        normalizedPreviewId = `preview-${tab.id}`;
      }
    }
    
    // Try multiple selector patterns to find the preview
    let previewCircle = document.querySelector(`[data-preview-id='${normalizedPreviewId}']`);
    if (!previewCircle) {
      // Try without quotes
      previewCircle = document.querySelector(`[data-preview-id=${normalizedPreviewId}]`);
    }
    if (!previewCircle) {
      // Try with escaped quotes
      previewCircle = document.querySelector(`[data-preview-id="${normalizedPreviewId}"]`);
    }
    
    if (!previewCircle) {

      // Fallback: trigger a full update
      if (this.isOpen && this._overlayElement) {
        setTimeout(() => {
          this._updateOverlayContent();
        }, 100);
      }
      return;
    }
    
    const previewImage = previewCircle.querySelector('.preview-image');
    if (!previewImage) {

      // Fallback: trigger a full update
      if (this.isOpen && this._overlayElement) {
        setTimeout(() => {
          this._updateOverlayContent();
        }, 100);
      }
      return;
    }
    
    // If no text, clear the preview or show placeholder
    if (!textValue) {
      previewImage.innerHTML = '';
      return;
    }
    
    const selection = isMain ? this.selections?.main : this.tabs.find(t => `preview-${t.id}` === normalizedPreviewId)?.selectedSymbol;
    const selectedFont = selection?.name || selection?.fontFamily || '';
    
    const letter = textValue.charAt(0).toUpperCase();

    // If we have a font selected, try to find the matching letter image
    if (selectedFont) {
      let allOptions = [];
      if (isMain && this._mainFontOptions && this._mainFontOptions[this.typeFilter]) {
        allOptions = this._mainFontOptions[this.typeFilter];
      } else if (!isMain) {
        const tab = this.tabs.find(t => `preview-${t.id}` === normalizedPreviewId);
        if (tab && tab._originalFontOptions) {
          allOptions = tab._originalFontOptions;
        }
      }

      if (allOptions.length > 0) {
        const letterOption = allOptions.find(opt => {
          const optName = (opt.name || '').toLowerCase().trim();
          const fontType = selectedFont.toLowerCase().trim();
          const expectedPattern = `${fontType} ${letter.toLowerCase()}`;
          const matches = optName === expectedPattern;
          if (matches) {

          }
          return matches;
        });
        
        if (letterOption && letterOption.image) {
          let imgUrl = letterOption.image;
          if (imgUrl.startsWith('//')) imgUrl = 'https:' + imgUrl;
          else if (imgUrl.startsWith('/')) {
            const domain = window.Shopify?.shop || window.location.hostname;
            imgUrl = window.location.protocol + '//' + domain + imgUrl;
          } else if (!imgUrl.startsWith('http')) {
            const domain = window.Shopify?.shop || window.location.hostname;
            imgUrl = window.location.protocol + '//' + domain + '/' + imgUrl;
          }

          previewImage.innerHTML = `<img src="${imgUrl}" alt="${letter}" style="max-width: 80%; max-height: 80%; object-fit: contain; display: block; margin: 0 auto;">`;
          return;
        } else {

        }
      } else {

      }
    } else {

    }
    
    // Fallback: show text if no font selected or no matching image found

    previewImage.innerHTML = `<span class="preview-text" style="font-size: 2rem; display: block;">${letter}</span>`;
  }

  _updateOverlayContent() {
    if (!this._overlayElement) return;

    // Preserve scroll position before updating
    const scrollableContent = this._overlayElement.querySelector('.customizer__content-scrollable');
    const preservedScrollTop = scrollableContent?.scrollTop || 0;

    // Preserve textarea value and focus state before updating
    const textarea = this._overlayElement.querySelector('.customizer__special-request-textarea');
    const wasTextareaFocused = document.activeElement === textarea;
    const textareaSelectionStart = textarea?.selectionStart || 0;
    const textareaSelectionEnd = textarea?.selectionEnd || 0;
    const preservedTextareaValue = textarea?.value || this.specialRequestMessage || '';
    
    // Preserve email input value and focus state before updating
    const emailInput = this._overlayElement.querySelector('.customizer__proof-email-input');
    const wasEmailFocused = document.activeElement === emailInput;
    const emailSelectionStart = emailInput?.selectionStart || 0;
    const emailSelectionEnd = emailInput?.selectionEnd || 0;
    const preservedEmailValue = emailInput?.value || this.proofEmail || '';
    
    // Preserve manual text input values before updating
    const manualInputs = this._overlayElement.querySelectorAll('input[id^="manual-text-input-"]');
    const preservedManualTexts = {};
    manualInputs.forEach(input => {
      const previewId = input.id.replace('manual-text-input-', '');
      preservedManualTexts[previewId] = input.value;
      // Also update the stored value
      if (previewId === 'main') {
        this._mainManualText = input.value;
      } else {
        const tab = this.tabs.find(t => `preview-${t.id}` === previewId);
        if (tab) {
          tab.manualText = input.value;
        }
      }
    });

    const totalPrice = this._calculateTotal();
    const formattedPrice = (totalPrice / 100).toFixed(2);
    const activePreviewId = this._getActivePreviewId();

    // Preserve is-open class if it exists
    const wasOpen = this._overlayElement.classList.contains("is-open");

    // Ensure base class is set
    this._overlayElement.className = "customizer-modal-overlay";

    // Create content using innerHTML (since we're outside Lit's render)
    this._overlayElement.innerHTML = `
            <div class="customizer__modal-content">
                <button type="button" class="modal__close">&times;</button>
                <div class="customizer__content-scrollable">
                    <!-- Product Header -->
                    ${this._renderProductHeaderHTML()}
                    
                    <!-- Preview Circles -->
                    <div class="customizer__previews">
                        ${
                          // Only show main preview if there are no initial (default) addons
                          !this.tabs.some(tab => tab.isInitial)
                            ? this._renderPreviewCircleHTML(
                                "main",
                                activePreviewId === "main"
                              )
                            : ""
                        }
                        ${this.tabs
                          .map((tab) =>
                            this._renderPreviewCircleHTML(
                              `preview-${tab.id}`,
                              activePreviewId === `preview-${tab.id}`
                            )
                          )
                          .join("")}
                        ${
                          this.activeTab !== -1 && !this._isFamilyBirthFlowerBouquet()
                            ? `
                            <button type="button" class="preview-circle add-preview">
                                <span>+</span>
                            </button>
                        `
                            : ""
                        }
                    </div>

                    <!-- Type Tabs -->
                    ${this._renderTypeTabsHTML()}

                    <!-- Type Label and Selected/Hovered Option Display -->
                    ${
                      this.activeTab !== -1
                        ? this._renderTypeOptionDisplayHTML()
                        : ""
                    }

                    <!-- Options Grid -->
                    <div class="customizer__options">
                        ${
                          this.activeTab === -1
                            ? this._renderAddAddonViewHTML()
                            : this._renderOptionsGridHTML()
                        }
                    </div>

                    <!-- Toggles - Under main content -->
                    <div class="customizer__toggles" style="padding: 1rem 1rem 0.5rem; border-top: 1px solid #eee; margin-top: 1rem;">
                        ${
                          this._isBirthFlowerBouquet()
                            ? `
                        <!-- Proof Email Field (Birth Flower Bouquet) -->
                        <div class="customizer__proof-email" style="margin-bottom: 1rem;">
                            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #221a18;">
                                ${this._getTranslation('proof_email_label', 'Email for proof')} <span style="color: #d32f2f;">*</span>
                            </label>
                            <input 
                                type="email" 
                                class="customizer__proof-email-input"
                                placeholder="${this._getTranslation('proof_email_placeholder', 'Enter your email address')}"
                                value="${this.proofEmail || ''}"
                                style="width: 100%; padding: 0.75rem; border: 1px solid #ccc; border-radius: 4px; font-size: 14px;"
                            />
                            <div class="customizer__proof-email-error" style="display: none; color: #d32f2f; font-size: 0.875rem; margin-top: 0.25rem;"></div>
                        </div>
                        `
                            : ''
                        }
                        <!-- Special Request Toggle -->
                        <div class="customizer__special-request" style="margin-bottom: 0;">
                            <label class="customizer__toggle-wrapper">
                                <input 
                                    type="checkbox" 
                                    class="customizer__special-request-toggle"
                                    ${this.specialRequestEnabled ? 'checked' : ''}
                                />
                                <span class="customizer__toggle-switch">
                                    <span class="customizer__toggle-slider"></span>
                                </span>
                                <span>${this._getTranslation('special_request', 'Special request?')}</span>
                            </label>
                            <div class="customizer__special-request-input${this.specialRequestEnabled ? ' is-visible' : ''}">
                                <textarea 
                                    class="customizer__special-request-textarea"
                                    placeholder="Enter your special request or message..."
                                    rows="3"
                                >${this.specialRequestMessage || ''}</textarea>
                            </div>
                        </div>
                        ${
                          this.giftWrapEnable
                            ? `
                        <!-- Gift Wrap Toggle -->
                        <div class="customizer__gift-wrap" style="margin-bottom: 0;">
                            <label class="customizer__toggle-wrapper">
                                <input 
                                    type="checkbox" 
                                    class="customizer__gift-wrap-toggle"
                                    ${this.giftWrapEnabled ? 'checked' : ''}
                                />
                                <span class="customizer__toggle-switch">
                                    <span class="customizer__toggle-slider"></span>
                                </span>
                                <span>${this.giftWrapLabel || 'Add gift wrap'}${this._giftWrapPrice ? ` (+$${((this._giftWrapPrice || 0) / 100).toFixed(2)})` : ''}</span>
                            </label>
                        </div>
                        `
                            : ''
                        }
                    </div>
                </div>

                <!-- Actions - Sticky at bottom -->
                <div class="customizer__actions">
                    <button type="button" class="customizer__add-cart" ${
                      this.isAddingToCart || !this._hasAllSelections()
                        ? "disabled"
                        : ""
                    }>
                        <span class="btn-text">${this._getTranslation('add_to_cart', 'Add to cart')}</span> • <span class="btn-price">$${formattedPrice}</span>
                    </button>
                </div>
            </div>
        `;

    // Restore is-open class if it was there before
    if (wasOpen) {
      this._overlayElement.classList.add("is-open");
    }

    // Attach event listeners
    this._attachOverlayListeners();
    this._setupSpecialRequestListeners();
    this._setupProofEmailListeners();
    
    // Note: The is-visible class is now added directly in the HTML template above
    // to prevent animation on re-render. Only animate when toggling via user interaction.
    
    // Restore textarea value and focus if it was focused before
    if (preservedTextareaValue && preservedTextareaValue !== this.specialRequestMessage) {
      this.specialRequestMessage = preservedTextareaValue;
    }
    const newTextarea = this._overlayElement.querySelector('.customizer__special-request-textarea');
    if (newTextarea) {
      newTextarea.value = this.specialRequestMessage || '';
      if (wasTextareaFocused) {
        // Restore focus and cursor position
        requestAnimationFrame(() => {
          newTextarea.focus();
          if (newTextarea.setSelectionRange) {
            newTextarea.setSelectionRange(textareaSelectionStart, textareaSelectionEnd);
          }
        });
      }
    }
    
    // Restore email input value and focus if it was focused before
    if (preservedEmailValue && preservedEmailValue !== this.proofEmail) {
      this.proofEmail = preservedEmailValue;
    }
    const newEmailInput = this._overlayElement.querySelector('.customizer__proof-email-input');
    if (newEmailInput) {
      newEmailInput.value = this.proofEmail || '';
      if (wasEmailFocused) {
        // Restore focus and cursor position
        requestAnimationFrame(() => {
          newEmailInput.focus();
          if (newEmailInput.setSelectionRange) {
            newEmailInput.setSelectionRange(emailSelectionStart, emailSelectionEnd);
          }
        });
      }
    }
    
    // Restore manual text input values and focus
    if (Object.keys(preservedManualTexts).length > 0) {
      requestAnimationFrame(() => {
        Object.keys(preservedManualTexts).forEach(previewId => {
          // Use getElementById which doesn't require escaping special characters
          const inputId = `manual-text-input-${previewId}`;
          const input = document.getElementById(inputId);
          if (input && this._overlayElement && this._overlayElement.contains(input)) {
            const wasFocused = document.activeElement?.id === inputId;
            const selectionStart = document.activeElement?.selectionStart || 0;
            const selectionEnd = document.activeElement?.selectionEnd || 0;
            input.value = preservedManualTexts[previewId];
            if (wasFocused) {
              input.focus();
              if (input.setSelectionRange) {
                input.setSelectionRange(selectionStart, selectionEnd);
              }
            }
          }
        });
      });
    }

    // Restore scroll position after content is rendered
    if (preservedScrollTop > 0) {
      requestAnimationFrame(() => {
        const newScrollableContent = this._overlayElement.querySelector('.customizer__content-scrollable');
        if (newScrollableContent) {
          newScrollableContent.scrollTop = preservedScrollTop;
        }
      });
    }
  }

  _setupSpecialRequestListeners() {
    if (!this._overlayElement) return;
    
    // Use event delegation for textarea input - this persists even when content is re-rendered
    const handleTextareaInput = (e) => {
      if (e.target && e.target.classList.contains('customizer__special-request-textarea')) {
        this.specialRequestMessage = e.target.value;
      }
    };
    
    // Remove old listener if it exists
    if (this._textareaInputHandler) {
      this._overlayElement.removeEventListener('input', this._textareaInputHandler);
    }
    
    this._textareaInputHandler = handleTextareaInput;
    this._overlayElement.addEventListener('input', this._textareaInputHandler, true);
  }

  _setupProofEmailListeners() {
    if (!this._overlayElement) return;
    
    // Use event delegation for email input - this persists even when content is re-rendered
    // Similar to special request - just update state, don't trigger re-renders
    const handleEmailInput = (e) => {
      if (e.target && e.target.classList.contains('customizer__proof-email-input')) {
        this.proofEmail = e.target.value;
        // Clear error message when user types
        const errorElement = e.target.closest('.customizer__proof-email')?.querySelector('.customizer__proof-email-error');
        if (errorElement) {
          errorElement.style.display = 'none';
          errorElement.textContent = '';
        }
        // Clear error border when user types
        e.target.style.borderColor = '#ccc';
        // Update button disabled state directly without re-rendering overlay
        // Check if email is valid (but don't show errors while typing)
        const email = (this.proofEmail || '').trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = email && emailRegex.test(email);
        
        // Check other selections (but skip email validation to avoid showing errors while typing)
        const hasOtherSelections = this._hasAllSelectionsExceptEmail();
        
        const addToCartButton = this._overlayElement.querySelector('.customizer__add-cart');
        if (addToCartButton) {
          if (hasOtherSelections && isEmailValid) {
            addToCartButton.removeAttribute('disabled');
          } else {
            addToCartButton.setAttribute('disabled', '');
          }
        }
      }
    };
    
    // Remove old listener if it exists
    if (this._emailInputHandler) {
      this._overlayElement.removeEventListener('input', this._emailInputHandler);
      this._overlayElement.removeEventListener('blur', this._emailInputHandler);
    }
    
    this._emailInputHandler = handleEmailInput;
    this._overlayElement.addEventListener('input', this._emailInputHandler, true);
    this._overlayElement.addEventListener('blur', this._emailInputHandler, true);
    
    // Restore email value if it exists
    const emailInput = this._overlayElement.querySelector('.customizer__proof-email-input');
    if (emailInput && this.proofEmail) {
      emailInput.value = this.proofEmail;
    }
  }

  _hasAllSelectionsExceptEmail() {
    // Check all selections except email validation (to avoid showing errors while typing)
    // This is a simplified version that skips email validation
    const hasInitialAddons = this.tabs.some(tab => tab.isInitial);
    const typeFilterLower = (this.typeFilter || "").toLowerCase();
    const isInitialOrName = typeFilterLower === "initial" || typeFilterLower === "initials" || typeFilterLower === "name";
    const mainSelection = this.selections?.main;
    
    if (isInitialOrName && !hasInitialAddons) {
      const manualText = this._mainManualText || "";
      if (!manualText || !manualText.trim()) {
        return false;
      }
      this._ensureFirstFontSelected(true);
    } else if (!hasInitialAddons) {
      if (!mainSelection) {
        return false;
      }
      if (Array.isArray(mainSelection)) {
        if (mainSelection.length === 0) {
          return false;
        }
      } else if (!mainSelection.name) {
        return false;
      }
    }

    // Check addon tabs
    if (this.tabs.length > 0) {
      for (const tab of this.tabs) {
        const tabCustomizationType = (tab?.customizationType || "").toLowerCase();
        const isTabInitialOrName = tabCustomizationType === "initial" || tabCustomizationType === "initials" || tabCustomizationType === "name";
        
        if (isTabInitialOrName) {
          const manualText = tab.manualText || "";
          if (!manualText || !manualText.trim()) {
            return false;
          }
          if (!tab.selectedSymbol || !tab.selectedSymbol.name) {
            this._ensureFirstFontSelectedForTab(tab);
            if (!tab.selectedSymbol || !tab.selectedSymbol.name) {
              // Still allow it
            }
          }
          continue;
        }
        
        if (!tab.selectedSymbol) {
          return false;
        }
        if (Array.isArray(tab.selectedSymbol)) {
          if (tab.selectedSymbol.length === 0) {
            return false;
          }
        } else if (!tab.selectedSymbol.name) {
          return false;
        }
      }
    }

    return true;
  }

  _getTranslation(key, fallback) {
    // Get translation from global customizerTranslations object (set in Liquid template)
    const translations = window.customizerTranslations || {};
    if (translations[key]) {
      return translations[key];
    }
    return fallback;
  }

  _attachOverlayListeners() {
    if (!this._overlayElement) return;

    // Remove old listener if it exists
    if (this._overlayClickHandler) {
      this._overlayElement.removeEventListener(
        "click",
        this._overlayClickHandler
      );
    }

    // Use event delegation - single listener for all clicks
    this._overlayClickHandler = (e) => {
      const target = e.target;

      // Overlay background click to close
      if (target === this._overlayElement) {
        this._toggleModal();
        return;
      }

      // Stop propagation on content clicks
      if (target.closest(".customizer__modal-content")) {
        e.stopPropagation();
      }

      // Close button
      if (target.closest(".modal__close")) {
        this._toggleModal();
        return;
      }

      // Gift wrap toggle
      const giftWrapToggle = target.closest('.customizer__gift-wrap')?.querySelector('.customizer__gift-wrap-toggle');
      if (giftWrapToggle && (target === giftWrapToggle || target.closest('.customizer__toggle-wrapper') || target.closest('.customizer__toggle-switch'))) {
        // Use requestAnimationFrame to ensure smooth toggle animation
        requestAnimationFrame(() => {
          this.giftWrapEnabled = giftWrapToggle.checked;
          // Update only price display, not full overlay (prevents losing focus/state)
          this._updatePriceDisplay();
        });
        return;
      }

      // Special request toggle
      const specialRequestToggle = target.closest('.customizer__special-request')?.querySelector('.customizer__special-request-toggle');
      if (specialRequestToggle && (target === specialRequestToggle || target.closest('.customizer__toggle-wrapper') || target.closest('.customizer__toggle-switch'))) {
        // Use requestAnimationFrame to ensure smooth animation
        requestAnimationFrame(() => {
          this.specialRequestEnabled = specialRequestToggle.checked;
          // Toggle the class directly on the input container for smooth animation
          const inputContainer = target.closest('.customizer__special-request')?.querySelector('.customizer__special-request-input');
          if (inputContainer) {
            // Force a reflow to ensure the transition works in both directions
            // This reads the current state, forcing the browser to recognize it
            void inputContainer.offsetHeight;
            
            if (this.specialRequestEnabled) {
              inputContainer.classList.add('is-visible');
            } else {
              // Remove the class to trigger close animation
              inputContainer.classList.remove('is-visible');
            }
          }
          // Don't call _updateOverlayContent() here - it would cause the toggle to "spazz out"
          // The class toggle above handles the visual state, and the state is already updated
        });
        return;
      }

      // Add to cart button
      if (target.closest(".customizer__add-cart")) {
        // Track add to cart attempt
        this._trackEvent('customizer_add_to_cart_clicked', {
          productTitle: this.productTitle,
          variantId: this.selectedVariantId,
          tabsCount: this.tabs ? this.tabs.length : 0,
          hasMainSelection: !!this.selections?.main,
          hasSpecialRequest: this.specialRequestEnabled && this.specialRequestMessage,
          hasGiftWrap: this.giftWrapEnabled,
          totalPrice: this._calculateTotal()
        });
        this._addToCart();
        return;
      }

      // Add preview button (disabled for Family Birth Flower Bouquet)
      if (target.closest(".add-preview")) {
        if (!this._isFamilyBirthFlowerBouquet()) {
          const parsedAddons = this._parseAddonData();
          
          // If there's only one addon, automatically add it and skip the selection step
          if (parsedAddons && parsedAddons.length === 1) {
            const product = parsedAddons[0];
            if (product && product.variants && product.variants.length > 0) {
              // Get the main product's finish to prefer matching variants
              const currentOption = this.selectedOption1
                ? this.selectedOption1.toLowerCase()
                : "";
              
              // Try to find a variant that matches the finish, but fall back to any available variant
              let selectedVariant = null;
              
              if (currentOption) {
                // First try to find a variant matching the finish
                selectedVariant = product.variants.find(
                  (v) =>
                    v.option1 &&
                    v.option1.toLowerCase() === currentOption &&
                    v.available
                );
              }
              
              // If no matching variant found, use the first available variant
              if (!selectedVariant) {
                selectedVariant = product.variants.find(v => v.available);
              }
              
              // If still no variant, use the first variant (even if not available)
              if (!selectedVariant) {
                selectedVariant = product.variants[0];
              }
              
              if (selectedVariant) {
                this._addAddonTab(product, selectedVariant);
              }
            }
          } else {
            // Show addon selection view for multiple addons
            this.activeTab = -1; // -1 = show add new view
            this.requestUpdate();
            if (this.isOpen && this._overlayElement) {
              this._updateOverlayContent();
            }
          }
        }
        return;
      }

      // Remove flower from Family Birth Flower Bouquet
      if (target.closest(".family-bouquet-flower-remove")) {
        e.stopPropagation();
        e.preventDefault();
        const removeButton = target.closest(".family-bouquet-flower-remove");
        const flowerIndex = parseInt(removeButton.getAttribute("data-flower-index"), 10);
        const previewContainer = target.closest(".customizer__family-bouquet-preview");
        const previewId = previewContainer ? previewContainer.getAttribute("data-preview-id") : "main";
        
        if (previewId === "main") {
          // Remove from main selection
          if (this.selections && this.selections.main && Array.isArray(this.selections.main)) {
            this.selections.main.splice(flowerIndex, 1);
            // Force update
            this.requestUpdate();
            if (this.isOpen && this._overlayElement) {
              this._updateOverlayContent();
            }
          }
        } else {
          // Remove from addon tab
          const tab = this.tabs.find((t) => `preview-${t.id}` === previewId);
          if (tab && tab.selectedSymbol && Array.isArray(tab.selectedSymbol)) {
            tab.selectedSymbol.splice(flowerIndex, 1);
            // Force update
            this.requestUpdate();
            if (this.isOpen && this._overlayElement) {
              this._updateOverlayContent();
            }
          }
        }
        return;
      }

      // Remove preview buttons - CHECK THIS BEFORE preview circles
      if (target.closest(".preview-remove")) {
        e.stopPropagation();
        e.preventDefault();
        // Check for both preview-circle and preview-birthstone-image
        const previewContainer = target.closest(".preview-circle") || target.closest(".preview-birthstone-image");
        if (previewContainer) {
          const previewId = previewContainer.getAttribute("data-preview-id");
          if (previewId && previewId !== "main") {
            const tab = this.tabs.find((t) => `preview-${t.id}` === previewId);
            if (tab && !tab.isInitial) {
              // Only allow removing non-initial tabs
              this._removeTab(this.tabs.findIndex((t) => t.id === tab.id));
            }
          }
        }
        return;
      }

      // Family Birth Flower Bouquet preview (don't treat as clickable preview circle)
      if (target.closest(".customizer__family-bouquet-preview")) {
        // Allow clicking on the preview area but don't change active state
        return;
      }

      // Preview circles and birthstone images
      const previewContainer = target.closest(".preview-circle[data-preview-id]") || target.closest(".preview-birthstone-image[data-preview-id]");
      if (previewContainer) {
        const previewId = previewContainer.getAttribute("data-preview-id");
        this._switchPreview(previewId);
        return;
      }

      // Option clicks
      const option = target.closest(".option");
      if (option) {
        const optionData = {
          id:
            option.getAttribute("data-id") || option.getAttribute("data-name"),
          name: option.getAttribute("data-name"),
          image: option.getAttribute("data-image"),
          type: option.getAttribute("data-type"),
        };
        this._selectOption(optionData);
        return;
      }

      // Type tab clicks
      const typeTab = target.closest(".type-tab");
      if (typeTab) {
        const type = typeTab.textContent.trim();
        this.typeFilter = type;
        this.requestUpdate();
        return;
      }

      // Cancel addon selection (go back)
      if (target.closest(".customizer__cancel-addon")) {
        e.preventDefault();
        e.stopPropagation();
        // Go back to the last active tab (or main if no tabs)
        if (this.tabs.length > 0) {
          // Go to the last tab
          this.activeTab = this.tabs.length;
        } else {
          // Go back to main
          this.activeTab = 0;
        }
        this.requestUpdate();
        if (this.isOpen && this._overlayElement) {
          this._updateOverlayContent();
        }
        return;
      }

      // Add addon product clicks
      const addonItem = target.closest("[data-product-id][data-variant-id]");
      if (addonItem) {
        const productId = addonItem.getAttribute("data-product-id");
        const variantId = addonItem.getAttribute("data-variant-id");
        const parsedAddons = this._parseAddonData();
        const product = parsedAddons.find((p) => p.id.toString() === productId);
        if (product) {
          const variant = product.variants.find(
            (v) => v.id.toString() === variantId
          );
          if (variant) {
            this._addAddonTab(product, variant);
          }
        }
        return;
      }
    };

    // Attach single delegated listener for clicks
    this._overlayElement.addEventListener("click", this._overlayClickHandler);

    // Attach mouseenter/mouseleave handlers for hover effects
    if (this._overlayMouseHandler) {
      this._overlayElement.removeEventListener(
        "mouseenter",
        this._overlayMouseHandler
      );
      this._overlayElement.removeEventListener(
        "mouseleave",
        this._overlayMouseHandler
      );
    }

    this._overlayMouseHandler = (e) => {
      const target = e.target;
      const option = target.closest(".option");

      if (e.type === "mouseenter" && option) {
        const optionData = {
          id:
            option.getAttribute("data-id") || option.getAttribute("data-name"),
          name: option.getAttribute("data-name"),
          image: option.getAttribute("data-image"),
          type: option.getAttribute("data-type"),
        };
        this._hoveredOption = optionData;
        this._updateTypeOptionDisplay();
      } else if (e.type === "mouseleave" && option) {
        this._hoveredOption = null;
        this._updateTypeOptionDisplay();
      }
    };

    this._overlayElement.addEventListener(
      "mouseenter",
      this._overlayMouseHandler,
      true
    );
    this._overlayElement.addEventListener(
      "mouseleave",
      this._overlayMouseHandler,
      true
    );
  }

  _updateTypeOptionDisplay() {
    if (!this._overlayElement) return;

    const displayElement = this._overlayElement.querySelector(
      ".customizer__type-option-display"
    );
    if (!displayElement) return;

    const activePreviewId = this._getActivePreviewId();
    const selection = this._getSelectionForPreview(activePreviewId);
    const displayOption = this._hoveredOption || selection;
    const typeLabel = this.typeFilter || "All Types";
    
    // Handle multiple selections for Family Birth Flower Bouquet
    let optionName = "";
    if (this._hoveredOption) {
      optionName = this._hoveredOption.name || "";
    } else if (selection) {
      if (Array.isArray(selection)) {
        optionName = selection.map((sel) => sel.name).join(", ");
      } else {
        optionName = selection.name || "";
      }
    }

    displayElement.innerHTML = `<b>${typeLabel}</b> ${optionName}`;
  }

  _isBabyBloomPreviewString(s) {
    if (s == null || s === "") return false;
    const t = String(s)
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    return t.includes("bloom") && (t.includes("baby") || t.includes("bebe"));
  }

  _isMainProductBracelet() {
    const pt = this.productType;
    if (pt == null || String(pt).trim() === "") return false;
    return String(pt).toLowerCase().includes("bracelet");
  }

  _getShapeFromType(typeName) {
    if (!typeName) return null;
    const typeLower = typeName.toLowerCase();
    // Bloom Birth Flower → vertical oval chip
    if (typeLower.includes("bloom") && typeLower.includes("flower")) {
      return "oval";
    }
    // Baby Bloom → oval unless main product type is bracelet (compact round bloom chip)
    if (this._isBabyBloomPreviewString(typeName)) {
      return this._isMainProductBracelet() ? "bloom-circle" : "oval";
    }
    return "circle";
  }

  _isFamilyBirthFlowerBouquet() {
    return this._checkIfFamilyBirthFlowerBouquet(this.productTitle);
  }

  _checkIfFamilyBirthFlowerBouquet(text) {
    if (!text) return false;
    const textLower = String(text).toLowerCase();
    
    // Check for English version
    if (textLower.includes("family birth flower bouquet") || 
        textLower.includes("family-birth-flower-bouquet")) {
      return true;
    }
    // Check for French version: "Bouquet de fleurs de naissance familial"
    if (textLower.includes("bouquet de fleurs de naissance familial") ||
        textLower.includes("bouquet-de-fleurs-de-naissance-familial")) {
      return true;
    }
    // Also check for partial matches in French
    if (textLower.includes("bouquet") && 
        textLower.includes("fleurs") && 
        textLower.includes("naissance") && 
        textLower.includes("familial")) {
      return true;
    }
    return false;
  }

  _isBirthFlowerBouquet() {
    // Use the existing _isFamilyBirthFlowerBouquet method
    return this._isFamilyBirthFlowerBouquet();
  }

  _getTypeClassFromType(typeName) {
    if (!typeName) return "";
    // Create a CSS-safe class name from the type
    return `type-${typeName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")}`;
  }

  _renderPreviewCircleHTML(previewId, isActive) {
    const previewIdStr = String(previewId);
    const isMain = previewIdStr === "main";
    let previewData = null;

    if (isMain) {
      const previewType = this._getCurrentPreview();
      const selection = this._getSelectionForPreview("main");
      previewData = { id: "main", type: previewType, selection };
    } else {
      const tab = this.tabs.find((t) => {
        const tabPreviewId = `preview-${t.id}`;
        return tabPreviewId === previewIdStr;
      });
      if (tab) {
        const selection = tab.selectedSymbol;
        previewData = {
          id: previewIdStr,
          type: tab.selectedPreview,
          selection,
          tab,
        };
      }
    }

    if (!previewData) return "";

    const selection = previewData.selection;
    let previewType = isMain ? this._getCurrentPreview() : previewData.type;
    
    // For Bloom Birth Flower, ensure we use oval preview (not circle)
    // Get customization type to check if it's Bloom Birth Flower
    let customizationTypeForPreview = null;
    if (isMain) {
      customizationTypeForPreview = this.typeFilter || (selection && selection.type);
    } else if (previewData.tab) {
      customizationTypeForPreview = previewData.tab.customizationType || (selection && selection.type);
    }
    
    if (customizationTypeForPreview === "Bloom Birth Flower") {
      const finishNormalized = this._normalizeFinish(this.selectedOption1);
      if (finishNormalized === "gold") {
        previewType = PREVIEW_OPTIONS.GOLD_OVAL.id;
      } else if (finishNormalized === "silver") {
        previewType = PREVIEW_OPTIONS.SILVER_OVAL.id;
      } else {
        previewType = PREVIEW_OPTIONS.GOLD_OVAL.id;
      }
    } else if (this._isBabyBloomPreviewString(customizationTypeForPreview)) {
      const finishNormalized = this._normalizeFinish(this.selectedOption1);
      if (this._isMainProductBracelet()) {
        if (finishNormalized === "gold") {
          previewType = PREVIEW_OPTIONS.GOLD_CIRCLE.id;
        } else if (finishNormalized === "silver") {
          previewType = PREVIEW_OPTIONS.SILVER_CIRCLE.id;
        } else {
          previewType = PREVIEW_OPTIONS.GOLD_CIRCLE.id;
        }
      } else {
        if (finishNormalized === "gold") {
          previewType = PREVIEW_OPTIONS.GOLD_OVAL.id;
        } else if (finishNormalized === "silver") {
          previewType = PREVIEW_OPTIONS.SILVER_OVAL.id;
        } else {
          previewType = PREVIEW_OPTIONS.GOLD_OVAL.id;
        }
      }
    }
    
    const preview =
      Object.values(PREVIEW_OPTIONS).find((opt) => opt.id === previewType) ||
      PREVIEW_OPTIONS.GOLD_CIRCLE;

    // For addon previews, get the image that matches the main product's finish
    let displayImageForFinish = null;
    if (!isMain && previewData.tab && selection) {

      displayImageForFinish = this._getMatchingFinishImage(selection, previewData.tab.customizations);

    }
    
    // For main preview, get the image that matches the main product's finish (same logic as addon)
    if (isMain && selection) {
      const allCustomizations = window.allCustomizationsMetaobjects || [];

      displayImageForFinish = this._getMatchingFinishImage(selection, allCustomizations);

    }

    // Get type from selection or tab
    let customizationType = null;
    if (isMain) {
      // For main product, try selection first, then typeFilter, then first available option
      if (selection && selection.type) {
        customizationType = selection.type;
      } else if (this.typeFilter) {
        customizationType = this.typeFilter;
      } else {
        // Get type from first available option by calling the same logic used in _getAvailableOptions
        const parsedAddons = this._parseAddonData();
        const allAddonCustomizations = [];
        
        if (parsedAddons && Array.isArray(parsedAddons)) {
          parsedAddons.forEach((product) => {
            if (product.customizer && product.customizer.customizations && Array.isArray(product.customizer.customizations)) {
              product.customizer.customizations.forEach((c) => {
                allAddonCustomizations.push({
                  id: c.id || `customization-${c.name}`,
                  name: c.name || "",
                  image: c.image || "",
                  type: c.type || product.customizer.type || "",
                });
              });
            }
          });
        }
        
        // Remove duplicates
        const uniqueCustomizations = [];
        const seen = new Set();
        allAddonCustomizations.forEach((c) => {
          const key = `${c.id || ""}-${c.name || ""}`;
          if (!seen.has(key)) {
            seen.add(key);
            uniqueCustomizations.push(c);
          }
        });
        
        if (uniqueCustomizations.length > 0 && uniqueCustomizations[0].type) {
          customizationType = uniqueCustomizations[0].type;
        }
      }
    } else if (previewData.tab) {
      customizationType =
        previewData.tab.customizationType || (selection && selection.type);
    }

    // Get material and shape classes from preview
    const materialClass = preview.material ? `preview-${preview.material}` : "";

    // Check if this is a tag addon product (for addon tabs only)
    // Check if product title contains "Tag" (case-insensitive)
    let isTagProduct = false;
    if (!isMain && previewData.tab) {
      const productTitle = (previewData.tab.productTitle || "").toLowerCase();
      isTagProduct = productTitle.includes("tag");
    }

    // Get shape from tag check first, then from type, fallback to preview shape
    let typeBasedShape = null;
    if (isTagProduct) {
      typeBasedShape = "rectangle";
    } else {
      typeBasedShape = this._getShapeFromType(customizationType);
    }
    
    if (
      (preview.id === PREVIEW_OPTIONS.GOLD_OVAL.id ||
        preview.id === PREVIEW_OPTIONS.SILVER_OVAL.id) &&
      !typeBasedShape
    ) {
      typeBasedShape = "oval";
    }
    
    const shapeClass = typeBasedShape
      ? `preview-${typeBasedShape}`
      : preview.shape
      ? `preview-${preview.shape}`
      : "";

    // Get type-based class
    const typeClass = this._getTypeClassFromType(customizationType);

    // Check if selection is an array (multiple selections) - need this early for hasNoSelection check
    const isMultipleSelection = Array.isArray(selection);
    const selectionCount = isMultipleSelection ? selection.length : 0;
    let firstSelection = isMultipleSelection && selection.length > 0 ? selection[0] : selection;

    // Get color for preview based on finish and shape
    let previewColor = null;
    let isWhiteBlankOval = false;
    const actualShape = typeBasedShape || preview.shape;
    
    const isBloomBirthFlower = customizationType === "Bloom Birth Flower";
    const isBabyBloom = this._isBabyBloomPreviewString(customizationType);
    const isFamilyBouquet = this._isFamilyBirthFlowerBouquet() || 
                            (previewData.tab && (
                              (previewData.tab.productTitle && this._checkIfFamilyBirthFlowerBouquet(previewData.tab.productTitle)) ||
                              previewData.tab.customizationType === "Family Birth Flower Bouquet"
                            ));
    // For white blank oval check, just check if there's no selection at all
    const hasNoSelection = !selection || (isMultipleSelection && selection.length === 0) || (!firstSelection || !firstSelection.image);
    
    if (
      actualShape &&
      (actualShape === "circle" ||
        actualShape === "oval" ||
        actualShape === "bloom-circle" ||
        actualShape === "rectangle")
    ) {
      const finish = this._getMainProductFinishType();
      const shape = actualShape;

      if (
        (isBloomBirthFlower || isBabyBloom) &&
        !isFamilyBouquet &&
        hasNoSelection &&
        (shape === "oval" || shape === "bloom-circle")
      ) {
        previewColor = "#ffffff";
        isWhiteBlankOval = true;
      } else {
        const finishNormalized = this._normalizeFinish(finish);
        let previewOption = null;
        if (
          finishNormalized === "gold" &&
          (shape === "circle" || shape === "bloom-circle")
        ) {
          previewOption = PREVIEW_OPTIONS.GOLD_CIRCLE;
        } else if (
          finishNormalized === "silver" &&
          (shape === "circle" || shape === "bloom-circle")
        ) {
          previewOption = PREVIEW_OPTIONS.SILVER_CIRCLE;
        } else if (finishNormalized === "gold" && shape === "oval") {
          previewOption = PREVIEW_OPTIONS.GOLD_OVAL;
        } else if (finishNormalized === "silver" && shape === "oval") {
          previewOption = PREVIEW_OPTIONS.SILVER_OVAL;
        } else if (finishNormalized === "gold" && shape === "rectangle") {
          previewOption = PREVIEW_OPTIONS.GOLD_RECTANGLE;
        } else if (finishNormalized === "silver" && shape === "rectangle") {
          previewOption = PREVIEW_OPTIONS.SILVER_RECTANGLE;
        }
        
        if (previewOption && previewOption.color) {
          previewColor = previewOption.color;
        }
      }
    }
    
    // For addon previews, ALWAYS get the matching finish image and use it
    if (!isMain && previewData.tab && firstSelection) {
      // Get the image that matches the main product's finish
      const matchingImage = this._getMatchingFinishImage(firstSelection, previewData.tab.customizations);
      if (matchingImage) {
        firstSelection = { ...firstSelection, image: matchingImage };
      }
    }
    
    // For main preview, ALWAYS get the matching finish image and use it (same logic as addon)
    if (isMain && firstSelection) {
      const allCustomizations = window.allCustomizationsMetaobjects || [];
      const matchingImage = this._getMatchingFinishImage(firstSelection, allCustomizations);
      if (matchingImage) {
        firstSelection = { ...firstSelection, image: matchingImage };
      }
    }
    
    // Special rendering for Family Birth Flower Bouquet (both main and addon previews)
    const isFamilyBouquetMain = isMain && this._isFamilyBirthFlowerBouquet();
    const isFamilyBouquetAddon = !isMain && previewData.tab && (
      (previewData.tab.productTitle && this._checkIfFamilyBirthFlowerBouquet(previewData.tab.productTitle)) ||
      (previewData.tab.productHandle && this._checkIfFamilyBirthFlowerBouquet(previewData.tab.productHandle)) ||
      previewData.tab.customizationType === "Family Birth Flower Bouquet" ||
      (previewData.tab.customizations && previewData.tab.customizations.some((c) => c.type === "Family Birth Flower Bouquet"))
    );
    
    if (isFamilyBouquetMain || isFamilyBouquetAddon) {
      // Always render the family bouquet preview, even if empty
      // FORCE array format - always treat as array for Family Birth Flower Bouquet
      let selections = [];
      if (selection) {
        if (Array.isArray(selection)) {
          selections = selection;
        } else {
          selections = [selection];
        }
      }
      return `
        <div class="customizer__family-bouquet-preview ${isActive ? "active" : ""}" data-preview-id="${previewIdStr}">
          ${selections.length > 0 ? selections.map((sel, index) => `
            <div class="family-bouquet-flower" data-flower-index="${index}">
              <div class="family-bouquet-flower-image">
                ${sel.image ? `<img src="${sel.image}" alt="${sel.name || ''}">` : ''}
              </div>
              <button class="family-bouquet-flower-remove" data-flower-id="${sel.id || sel.name || ''}" data-flower-index="${index}">&times;</button>
            </div>
          `).join('') : `<div class="family-bouquet-empty">${this._getTranslation('select_flowers_below', 'Select flowers below')}</div>`}
        </div>
      `;
    }
    
    // Special rendering for Birthstone - just the image, no circle/oval
    const isBirthstone = customizationType && customizationType.toLowerCase().includes("birthstone");
    if (isBirthstone) {
      // For addon previews, always get the matching finish image
      let displaySelection = firstSelection;
      if (!isMain && previewData.tab && firstSelection) {
        const matchingImage = this._getMatchingFinishImage(firstSelection, previewData.tab.customizations);
        if (matchingImage) {
          displaySelection = { ...firstSelection, image: matchingImage };
        }
      }
      // For main preview, always get the matching finish image (same logic as addon)
      if (isMain && firstSelection) {
        const allCustomizations = window.allCustomizationsMetaobjects || [];
        const matchingImage = this._getMatchingFinishImage(firstSelection, allCustomizations);
        if (matchingImage) {
          displaySelection = { ...firstSelection, image: matchingImage };
        }
      }
      
      // Check if it's a birthstone pendant or charm
      const customizationTypeLower = customizationType ? customizationType.toLowerCase() : "";
      const isHeartBirthstone = customizationTypeLower.includes("heart");
      const isBirthstonePendant = customizationTypeLower.includes("pendant") && !isHeartBirthstone;
      const isBirthstoneCharm = (customizationTypeLower.includes("charm") || 
                                (customizationTypeLower.includes("birthstone") && !isBirthstonePendant)) && !isHeartBirthstone;
      
      // Get blank image for pendant and charm only (NOT heart birthstones)
      let blankImage = null;
      if ((isBirthstonePendant || isBirthstoneCharm) && (!displaySelection || !displaySelection.image)) {
        const finishNormalized = this._normalizeFinish(this.selectedOption1);
        if (isBirthstonePendant) {
          if (finishNormalized === "gold") {
            blankImage = this.blankBirthstonePendantGold;
          } else if (finishNormalized === "silver") {
            blankImage = this.blankBirthstonePendantSilver;
          }
        } else if (isBirthstoneCharm) {
          if (finishNormalized === "gold") {
            blankImage = this.blankBirthstoneCharmGold;
          } else if (finishNormalized === "silver") {
            blankImage = this.blankBirthstonePendantSilver;
          }
        }
      }
      
      // IF IT'S A HEART BIRTHSTONE, GET FIRST OPTION
      let firstOption = null;
      if (isHeartBirthstone && (!displaySelection || !displaySelection.image)) {
        let availableCustomizations = [];
        if (!isMain && previewData.tab && previewData.tab.customizations) {
          availableCustomizations = previewData.tab.customizations.filter(c => 
            c.type && c.type.toLowerCase() === customizationTypeLower
          );
        } else if (isMain) {
          const allCustomizations = window.allCustomizationsMetaobjects || [];
          availableCustomizations = allCustomizations.filter(c => 
            c.type && c.type.toLowerCase() === customizationTypeLower
          );
        }
        if (availableCustomizations.length > 0) {
          firstOption = availableCustomizations[0];
          if (!isMain && previewData.tab && previewData.tab.customizations) {
            const matchingImage = this._getMatchingFinishImage(firstOption, previewData.tab.customizations);
            if (matchingImage) {
              firstOption = { ...firstOption, image: matchingImage };
            }
          } else if (isMain) {
            const allCustomizations = window.allCustomizationsMetaobjects || [];
            const matchingImage = this._getMatchingFinishImage(firstOption, allCustomizations);
            if (matchingImage) {
              firstOption = { ...firstOption, image: matchingImage };
            }
          }
        }
      }
      
      return `
        <div class="preview-birthstone-image ${isMain ? "main-preview" : ""} ${isActive ? "active" : ""}" data-preview-id="${previewIdStr}">
          ${
            displaySelection && displaySelection.image
              ? `<img src="${displaySelection.image}" alt="${displaySelection.name || ''}">`
              : blankImage
              ? `<img src="${blankImage}" alt="Blank birthstone pendant">`
              : firstOption && firstOption.image
              ? `<img src="${firstOption.image}" alt="${firstOption.name || ''}">`
              : ""
          }
          ${
            isMultipleSelection && selectionCount > 1
              ? `<span class="preview-count-badge">${selectionCount}</span>`
              : ""
          }
          ${
            !isMain && previewData.tab && !previewData.tab.isInitial
              ? `<button class="preview-remove">&times;</button>`
              : ""
          }
        </div>
      `;
    }
    
    // Check if this is Initial/Name type and has manual text
    const tab = previewData.tab;
    const typeFilterLower = (this.typeFilter || "").toLowerCase();
    const tabCustomizationType = (tab?.customizationType || "").toLowerCase();
    const isInitialOrName = isMain ? (
      typeFilterLower === "initial" || 
      typeFilterLower === "initials" || 
      typeFilterLower === "name"
    ) : tab && (
      tabCustomizationType === "initial" ||
      tabCustomizationType === "initials" ||
      tabCustomizationType === "name"
    );
    const manualText = tab?.manualText || (isMain && this._mainManualText ? this._mainManualText : "");
    // Get selected font type (e.g., "Font 1", "Font 2") from selection
    const selectedFontType = selection?.name || selection?.fontFamily || "";

    // If we have a font type and manual text, find the specific letter image
    let displayImage = null;
    if (isInitialOrName && manualText && selectedFontType) {
      const letter = manualText.charAt(0).toUpperCase();
      
      // Get original options (before font type extraction)
      let allOptions = [];
      if (tab && tab._originalFontOptions) {
        allOptions = tab._originalFontOptions;
      } else if (tab && tab.customizations) {
        allOptions = tab.customizations;
      } else if (isMain && this._mainFontOptions && this._mainFontOptions[this.typeFilter]) {
        allOptions = this._mainFontOptions[this.typeFilter];
      }

      // Look for option like "Font 1 A" when fontType is "Font 1" and letter is "A"
      const letterOption = allOptions.find(opt => {
        const optName = (opt.name || "").toLowerCase().trim();
        const fontType = (selectedFontType || "").toLowerCase().trim();
        const letterLower = letter.toLowerCase();
        const matches = optName === `${fontType} ${letterLower}`;
        if (matches) {

        }
        return matches;
      });
      
      if (letterOption && letterOption.image) {
        displayImage = letterOption.image;
        // Fix image URL
        if (displayImage.startsWith("//")) {
          displayImage = `https:${displayImage}`;
        } else if (displayImage.startsWith("/")) {
          const shopDomain = window.Shopify?.shop || window.location.hostname;
          const protocol = window.location.protocol;
          displayImage = `${protocol}//${shopDomain}${displayImage}`;
        } else if (!displayImage.startsWith("http://") && !displayImage.startsWith("https://")) {
          const shopDomain = window.Shopify?.shop || window.location.hostname;
          const protocol = window.location.protocol;
          displayImage = `${protocol}//${shopDomain}/${displayImage}`;
        }

      } else {

      }
    } else {

    }
    
    return `
            <div class="preview-circle ${isMain ? "main-preview" : ""} ${
      isActive ? "active" : ""
    }" 
                 data-preview-id="${previewIdStr}">
                <div class="preview-image ${
                  preview.id === PREVIEW_OPTIONS.BIRTHSTONE.id
                    ? "birthstone-preview"
                    : ""
                } ${materialClass} ${shapeClass} ${typeClass}${
                    isBabyBloom ? " preview-baby-bloom" : ""
                  }"
                     ${previewColor ? (isWhiteBlankOval 
                       ? `style="background-color: ${previewColor}; border: 1px solid #e0e0e0;"` 
                       : `style="background-color: ${previewColor};"`) : ""}>
                    ${
                      isInitialOrName && manualText && displayImage
                        ? `<img src="${displayImage}" alt="${manualText}" style="max-width: 80%; max-height: 80%; object-fit: contain; display: block; margin: 0 auto;" >`
                        : isInitialOrName && manualText
                        ? `<span class="preview-text" style="font-size: 2rem; display: block;">${manualText}</span>`
                        : firstSelection && (firstSelection.image || displayImageForFinish)
                        ? `
                        <img src="${displayImageForFinish || firstSelection.image}" alt="${firstSelection.name}">
                    `
                        : preview.id === PREVIEW_OPTIONS.BIRTHSTONE.id
                        ? (() => {
                            // Check if it's a birthstone pendant or charm and get blank image
                            const tabCustomizationType = previewData.tab?.customizationType || "";
                            const customizationTypeLower = tabCustomizationType.toLowerCase();
                            const isHeartBirthstone = customizationTypeLower.includes("heart");
                            const isBirthstonePendant = (customizationTypeLower.includes("pendant") || 
                                                       (isMain && this.typeFilter && this.typeFilter.toLowerCase().includes("pendant"))) && !isHeartBirthstone;
                            const isBirthstoneCharm = (customizationTypeLower.includes("charm") || 
                                                      (customizationTypeLower.includes("birthstone") && !isBirthstonePendant)) && !isHeartBirthstone;
                            
                            // Get blank image for pendant and charm only (NOT heart birthstones)
                            let blankImage = null;
                            if ((isBirthstonePendant || isBirthstoneCharm) && (!firstSelection || !firstSelection.image)) {
                              const finishNormalized = this._normalizeFinish(this.selectedOption1);
                              if (isBirthstonePendant) {
                                if (finishNormalized === "gold") {
                                  blankImage = this.blankBirthstonePendantGold;
                                } else if (finishNormalized === "silver") {
                                  blankImage = this.blankBirthstonePendantSilver;
                                }
                              } else if (isBirthstoneCharm) {
                                if (finishNormalized === "gold") {
                                  blankImage = this.blankBirthstoneCharmGold;
                                } else if (finishNormalized === "silver") {
                                  blankImage = this.blankBirthstonePendantSilver;
                                }
                              }
                            }
                            
                            // IF IT'S A HEART BIRTHSTONE, GET FIRST OPTION
                            let firstOption = null;
                            if (isHeartBirthstone && (!firstSelection || !firstSelection.image)) {
                              let availableCustomizations = [];
                              if (!isMain && previewData.tab && previewData.tab.customizations) {
                                availableCustomizations = previewData.tab.customizations.filter(c => 
                                  c.type && c.type.toLowerCase() === customizationTypeLower
                                );
                              } else if (isMain) {
                                const allCustomizations = window.allCustomizationsMetaobjects || [];
                                availableCustomizations = allCustomizations.filter(c => 
                                  c.type && c.type.toLowerCase() === customizationTypeLower
                                );
                              }
                              if (availableCustomizations.length > 0) {
                                firstOption = availableCustomizations[0];
                                if (!isMain && previewData.tab && previewData.tab.customizations) {
                                  const matchingImage = this._getMatchingFinishImage(firstOption, previewData.tab.customizations);
                                  if (matchingImage) {
                                    firstOption = { ...firstOption, image: matchingImage };
                                  }
                                } else if (isMain) {
                                  const allCustomizations = window.allCustomizationsMetaobjects || [];
                                  const matchingImage = this._getMatchingFinishImage(firstOption, allCustomizations);
                                  if (matchingImage) {
                                    firstOption = { ...firstOption, image: matchingImage };
                                  }
                                }
                              }
                            }
                            
                            return blankImage 
                              ? `<img src="${blankImage}" alt="Blank birthstone ${isBirthstonePendant ? 'pendant' : 'charm'}">`
                              : firstOption && firstOption.image
                              ? `<img src="${firstOption.image}" alt="${firstOption.name || ''}">`
                              : "";
                          })()
                        : ""
                    }
                    ${
                      isMultipleSelection && selectionCount > 1
                        ? `
                        <span class="preview-count-badge">${selectionCount}</span>
                    `
                        : ""
                    }
                </div>
                ${
                  !isMain && previewData.tab && !previewData.tab.isInitial
                    ? `
                    <button class="preview-remove">&times;</button>
                `
                    : ""
                }
            </div>
        `;
  }

  _renderTypeTabsHTML() {
    const activePreviewId = this._getActivePreviewId();
    if (activePreviewId === "add-new") return "";

    const types = this._getAvailableTypes();
    if (!types || types.length === 0) return "";
    
    // Hide tabs wrapper if there's only one type (no need for tabs)
    if (types.length === 1) return "";

    if (!this.typeFilter && types.length > 0) {
      this.typeFilter = types[0];
    }

    return `
            <div class="customizer__type-tabs-wrapper">
                <div class="customizer__type-tabs">
                    ${types
                      .map((type) => {
                        const isActive = this.typeFilter === type;
                        return `
                            <button type="button" class="type-tab ${
                              isActive ? "active" : ""
                            }">
                                ${type}
                            </button>
                        `;
                      })
                      .join("")}
                </div>
            </div>
        `;
  }

  _renderTypeOptionDisplayHTML() {
    const activePreviewId = this._getActivePreviewId();
    const selection = this._getSelectionForPreview(activePreviewId);
    const displayOption = this._hoveredOption || selection;
    const typeLabel = this.typeFilter || "All Types";
    
    // Handle multiple selections for Family Birth Flower Bouquet
    let optionName = "";
    if (this._hoveredOption) {
      optionName = this._hoveredOption.name || "";
    } else if (selection) {
      if (Array.isArray(selection)) {
        optionName = selection.map((sel) => sel.name).join(", ");
      } else {
        optionName = selection.name || "";
      }
    }

    return `
            <div class="customizer__type-option-display">
                <b>${typeLabel}</b> ${optionName}
            </div>
        `;
  }

  _renderOptionsGridHTML() {
    const activePreviewId = this._getActivePreviewId();
    const selection = this._getSelectionForPreview(activePreviewId);
    let options = this._getFilteredOptions();
    
    // Get the active tab to check customizationType
    const isMain = activePreviewId === "main";
    const tab = !isMain ? this.tabs.find((t) => `preview-${t.id}` === activePreviewId) : null;
    
    // Check if we should show manual input for Initial/Name
    const typeFilterLower = (this.typeFilter || "").toLowerCase().trim();
    const tabCustomizationType = (tab?.customizationType || "").toLowerCase().trim();
    const showManual =
      typeFilterLower === "initial" || 
      typeFilterLower === "initials" || 
      typeFilterLower === "name" ||
      tabCustomizationType === "initial" ||
      tabCustomizationType === "initials" ||
      tabCustomizationType === "name";
    
    // For Initial/Name types, extract unique font types (Font 1, Font 2, etc.) from individual letters
    // Check if options have the pattern "Font X Y" (e.g., "Font 1 A", "Font 2 B")
    let hasFontPattern = false;
    if (options && options.length > 0) {
      const firstOpt = options[0];
      const name = (firstOpt?.name || "").trim();
      hasFontPattern = /^Font\s+\d+\s+[A-Z]$/i.test(name);
    }
    
    const isInitialType = typeFilterLower === "initial" || typeFilterLower === "initials" || typeFilterLower === "name";
    
    // ALWAYS extract font types if we detect the pattern - this groups Font 1 A, Font 1 B, etc. into just "Font 1"
    if ((hasFontPattern || isInitialType) && options && options.length > 0) {

      const fontTypesMap = new Map();
      const allOriginalOptions = [...options];
      
      allOriginalOptions.forEach((option) => {
        const name = (option.name || "").trim();
        let fontType = null;
        
        // Match "Font 1 A" -> "Font 1"
        let fontTypeMatch = name.match(/^(Font\s+\d+)\s+[A-Z]$/i);
        if (fontTypeMatch) {
          fontType = fontTypeMatch[1];
        } else {
          fontTypeMatch = name.match(/^(Font\s+\d+)[A-Z]$/i);
          if (fontTypeMatch) {
            fontType = fontTypeMatch[1];
          } else {
            fontTypeMatch = name.match(/^(Font\d+)\s+[A-Z]$/i);
            if (fontTypeMatch) {
              const numMatch = fontTypeMatch[1].match(/Font(\d+)/i);
              if (numMatch) {
                fontType = `Font ${numMatch[1]}`;
              }
            }
          }
        }
        
        if (fontType) {
          if (!fontTypesMap.has(fontType)) {
            const fontAOption = allOriginalOptions.find(opt => {
              const optName = (opt.name || "").toLowerCase().trim();
              return optName === `${fontType.toLowerCase()} a`;
            }) || option;
            
            fontTypesMap.set(fontType, {
              id: `font-type-${fontType.replace(/\s+/g, '-')}`,
              name: fontType,
              image: fontAOption.image || option.image || "",
              type: option.type || "Font",
              fontFamily: fontType,
            });
          }
        }
      });
      
      if (fontTypesMap.size > 0) {
        options = Array.from(fontTypesMap.values());
        // Store original options for preview lookup
        if (tab) {
          tab._originalFontOptions = allOriginalOptions;
        } else if (isMain) {
          if (!this._mainFontOptions) this._mainFontOptions = {};
          this._mainFontOptions[this.typeFilter] = allOriginalOptions;
        }
        
        // Auto-select first font style if no selection exists (only once)
        const currentSelection = isMain ? this.selections?.main : (tab?.selectedSymbol);
        if (!currentSelection && options.length > 0) {
          // Check if we've already tried to auto-select for this preview
          const autoSelectKey = isMain ? `_autoSelectedFont_main_${this.typeFilter}` : `_autoSelectedFont_tab_${tab?.id}`;
          if (!this[autoSelectKey]) {
            // Select the first font style option (instead of specifically "Font 1")
            const firstFontOption = options[0];
            if (firstFontOption) {
              this[autoSelectKey] = true; // Mark as attempted
              // Use setTimeout to avoid calling _selectOption during render
              setTimeout(() => {
                if (isMain) {
                  if (!this.selections) this.selections = {};
                  // Don't overwrite Family Birth Flower Bouquet array selections
                  if (this._isFamilyBirthFlowerBouquet() && Array.isArray(this.selections.main)) {
                    // Skip auto-select for Family Birth Flower Bouquet
                    return;
                  }
                  this.selections.main = {
                    id: firstFontOption.id,
                    image: firstFontOption.image,
                    name: firstFontOption.name,
                    value: firstFontOption.name,
                    type: firstFontOption.type,
                    fontFamily: firstFontOption.fontFamily || null,
                  };
                } else if (tab) {
                  tab.selectedSymbol = {
                    ...firstFontOption,
                    fontFamily: firstFontOption.fontFamily || null,
                  };
                }
                
                // If there's already manual text, update the preview immediately
                const manualText = isMain ? this._mainManualText : tab?.manualText;
                if (manualText && manualText.trim()) {
                  const previewId = isMain ? "main" : `preview-${tab.id}`;
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      this._updatePreviewForManualText(previewId, isMain);
                    });
                  });
                }
                
                this.requestUpdate();
                if (this.isOpen && this._overlayElement) {
                  this._updateOverlayContent();
                }
              }, 0);
            }
          }
        }
      }
    }

    if (!options || options.length === 0) {
      return `
                <div style="padding: 2rem; text-align: center; color: #999;">
                    <p>No customization options available.</p>
                </div>
            `;
    }

    return `
            <div class="options-grid">
                ${options
                  .map((option) => {
                    // Check if option is selected - handle both single and multiple selections
                    // For Family Birth Flower Bouquet, don't show selected state (no checkbox behavior)
                    let isSelected = false;
                    const isFamilyBouquet = this._isFamilyBirthFlowerBouquet();
                    if (!isFamilyBouquet && selection) {
                      if (Array.isArray(selection)) {
                        // Multiple selections - check if option is in the array
                        isSelected = selection.some(
                          (sel) => 
                            (sel.id && option.id && sel.id === option.id) ||
                            (sel.name && option.name && sel.name === option.name)
                        );
                      } else {
                        // Single selection
                        isSelected = 
                          (selection.id && option.id && selection.id === option.id) ||
                          (selection.name && option.name && selection.name === option.name);
                      }
                    }
                    
                    // Debug log for first option
                    if (options.indexOf(option) === 0) {
                      // Selection check for first option
                    }
                    let imageUrl = option.image || "";
                    if (imageUrl) {
                      if (imageUrl.startsWith("//")) {
                        imageUrl = `https:${imageUrl}`;
                      } else if (imageUrl.startsWith("/")) {
                        const shopDomain =
                          window.Shopify?.shop || window.location.hostname;
                        const protocol = window.location.protocol;
                        imageUrl = `${protocol}//${shopDomain}${imageUrl}`;
                      } else if (
                        !imageUrl.startsWith("http://") &&
                        !imageUrl.startsWith("https://")
                      ) {
                        const shopDomain =
                          window.Shopify?.shop || window.location.hostname;
                        const protocol = window.location.protocol;
                        imageUrl = `${protocol}//${shopDomain}/${imageUrl}`;
                      }
                    }
                    return `
                        <div class="option ${isSelected ? "selected" : ""}" 
                             data-id="${option.id}"
                             data-image="${imageUrl}"
                             data-name="${option.name}"
                             data-value="${option.name}"
                             data-type="${option.type}"
                             data-option-data='${JSON.stringify(option).replace(
                               /'/g,
                               "&#39;"
                             )}'>
                            ${
                              imageUrl
                                ? `
                                <img src="${imageUrl}" alt="${option.name}" width="50" height="50" 
                                     onerror="this.style.display='none';">
                            `
                                : `
                                <span>${
                                  option.name ? option.name.charAt(0) : ""
                                }</span>
                            `
                            }
                        </div>
                    `;
                  })
                  .join("")}
            </div>
            ${showManual ? `
                <div class="customizer__manual" style="margin-top: 1.5rem;">
                    <div class="manual-field">
                        <input
                            type="text"
                            id="manual-text-input-${activePreviewId}"
                            placeholder="${typeFilterLower === "initial" || typeFilterLower === "initials" ? "Enter letter" : "Name"}"
                            maxlength="${typeFilterLower === "initial" || typeFilterLower === "initials" ? "1" : "10"}"
                            value="${(() => {
                              if (tab && tab.manualText) {
                                return tab.manualText;
                              } else if (isMain && this._mainManualText) {
                                return this._mainManualText;
                              }
                              return '';
                            })()}"
                            oninput="window.customizerApp._handleManualTextInput(this, '${activePreviewId}', ${isMain ? 'true' : 'false'}, '${typeFilterLower}');"
                        />
                        <div class="manual-counter">
                            ${(() => {
                              const currentValue = tab?.manualText || (isMain && this._mainManualText ? this._mainManualText : '');
                              const isInitial = typeFilterLower === "initial" || typeFilterLower === "initials";
                              return isInitial ? `${currentValue.length}/1` : `${currentValue.length}/10`;
                            })()}
                        </div>
                    </div>
                </div>
            ` : ''}
        `;
  }

  _renderAddAddonViewHTML() {
    const parsedAddons = this._parseAddonData();
    if (!parsedAddons || parsedAddons.length === 0) {
      return "<p>No addons available.</p>";
    }

    // Get the main product's finish to prefer matching variants, but show all products
    const currentOption = this.selectedOption1
      ? this.selectedOption1.toLowerCase()
      : "";

    // Helper function to get blank product image HTML
    const getBlankProductImage = (product, variant) => {
      // Determine preview type from product
      const previewType = this._determinePreviewFromProduct(product.title, variant.title);
      const previewOption = Object.values(PREVIEW_OPTIONS).find((opt) => opt.id === previewType) || PREVIEW_OPTIONS.GOLD_CIRCLE;
      
      // Check if it's a birthstone pendant or charm
      const searchText = `${product.title} ${variant.title}`.toLowerCase();
      const isBirthstone = searchText.includes("birthstone") || searchText.includes("stone");
      const isBirthstonePendant = isBirthstone && searchText.includes("pendant");
      const isBirthstoneCharm = isBirthstone && (searchText.includes("charm") || (!isBirthstonePendant && isBirthstone));
      
      if (isBirthstonePendant || isBirthstoneCharm) {
        // Use blank birthstone image based on type and finish
        const finishNormalized = this._normalizeFinish(this.selectedOption1);
        let blankImage;
        if (isBirthstonePendant) {
          // Birthstone pendant
          blankImage = finishNormalized === "gold" 
            ? this.blankBirthstonePendantGold
            : finishNormalized === "silver"
            ? this.blankBirthstonePendantSilver
            : this.blankBirthstonePendantGold; // Default to gold
        } else {
          // Birthstone charm - silver uses same image as pendant silver
          blankImage = finishNormalized === "gold" 
            ? this.blankBirthstoneCharmGold
            : finishNormalized === "silver"
            ? this.blankBirthstonePendantSilver
            : this.blankBirthstoneCharmGold; // Default to gold
        }
        
        return `<img src="${blankImage}" alt="Blank ${isBirthstonePendant ? 'pendant' : 'charm'}" style="width: 80px; height: 80px; object-fit: contain;">`;
      } else {
        // Render blank circle/oval using CSS (like preview circles)
        const isOval = previewType === PREVIEW_OPTIONS.GOLD_OVAL.id || previewType === PREVIEW_OPTIONS.SILVER_OVAL.id;
        const finishNormalized = this._normalizeFinish(this.selectedOption1);
        
        // Get color based on finish and shape
        let color = "#f4dda5"; // Default gold
        if (finishNormalized === "gold") {
          color = isOval ? "#f4dda5" : "#f4dda5"; // Gold color
        } else if (finishNormalized === "silver") {
          color = "#e1e1e1"; // Silver color
        }
        
        // Use appropriate border-radius for oval vs circle
        const borderRadius = isOval ? "40% / 60%" : "50%";
        
        return `<div style="width: 80px; height: 80px; margin: 0 auto; background-color: ${color}; border-radius: ${borderRadius}; border: 1px solid rgba(0,0,0,0.1);"></div>`;
      }
    };

    return `
            <div style="text-align: center;">
                <p style="margin: 0 0 1.5rem 0; text-align: center;">Select a one to add to your necklace:</p>
                <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 1.5rem;">
                    ${parsedAddons
                      .map((product) => {
                        if (!product || !product.variants || product.variants.length === 0) {
                          return "";
                        }
                        
                        // Try to find a variant that matches the finish, but fall back to any available variant
                        let selectedVariant = null;
                        
                        if (currentOption) {
                          // First try to find a variant matching the finish
                          selectedVariant = product.variants.find(
                            (v) =>
                              v.option1 &&
                              v.option1.toLowerCase() === currentOption &&
                              v.available
                          );
                        }
                        
                        // If no matching variant found, use the first available variant
                        if (!selectedVariant) {
                          selectedVariant = product.variants.find(v => v.available);
                        }
                        
                        // If still no variant, use the first variant (even if not available)
                        if (!selectedVariant) {
                          selectedVariant = product.variants[0];
                        }
                        
                        if (!selectedVariant) {
                          return "";
                        }
                        
                        return `
                            <div style="border: 1px solid #eee; padding: 10px; text-align: center; cursor: pointer; transition: all 0.2s; background: #fff; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0.5rem;"
                                 data-product-id="${product.id}"
                                 data-variant-id="${selectedVariant.id}"
                                 onmouseover="this.style.borderColor='#000000'; this.style.boxShadow='0 2px 8px rgba(0,0,0,0.1)';"
                                 onmouseout="this.style.borderColor='#eee'; this.style.boxShadow='none';">
                                ${getBlankProductImage(product, selectedVariant)}
                                <div style="font-weight: bold; color: #000; font-size: 1.1rem; margin-top: 0.5rem;">+$${(
                                  selectedVariant.price / 100
                                ).toFixed(2)}</div>
                            </div>
                        `;
                      })
                      .filter(html => html !== "") // Remove empty strings
                      .join("")}
                </div>
                <button 
                    class="customizer__cancel-addon" 
                    style="background: transparent; border: 1px solid #ccc; padding: 0.75rem 1.5rem; border-radius: 4px; cursor: pointer; font-size: 0.9rem; color: #666; transition: all 0.2s; margin-top: 1.5rem;"
                    onmouseover="this.style.borderColor='#000'; this.style.color='#000';"
                    onmouseout="this.style.borderColor='#ccc'; this.style.color='#666';">
                    Cancel
                </button>
            </div>
        `;
  }

  _initializeAllAddons() {
    // Initialize all addon products when customizer first opens
    // These are non-removable addons that come with the main product
    if (this.initialAddonsInitialized) {
      return; // Only initialize once
    }

    const parsedAddons = this._parseAddonData();
    if (!parsedAddons || parsedAddons.length === 0) {
      this.initialAddonsInitialized = true;
      return;
    }

    // Get the main product's selected finish (option1)
    const mainProductFinish = this.selectedOption1
      ? this.selectedOption1.trim()
      : "";

    // Store the current activeTab to restore it after initialization
    const originalActiveTab = this.activeTab;

    // Track which product types we've already added (to ensure only one of each type)
    const addedTypes = new Set();

    // Add all addon products as initial (non-removable) tabs
    // Only add ONE of each product type (disc, pendant, etc.)
    // This works with any combination - if there's a disc and a pendant, both will show
    // If there are multiple pendants, only one will show
    parsedAddons.forEach((product) => {
      if (!product || !product.variants || product.variants.length === 0) {

        return;
      }

      // Determine product type from title (disc, pendant, etc.)
      // All pendants are grouped together as one type - only one pendant total should be added
      const productTitleLower = (product.title || "").toLowerCase().trim();
      let productType = null;
      
      // Check for specific product types (order matters - check more specific first)
      if (productTitleLower.includes("disc")) {
        productType = "disc";
      } else if (productTitleLower.includes("pendant")) {
        // All pendant types (birthstone pendant, initial pendant, etc.) are grouped as "pendant"
        productType = "pendant";
      } else {
        // For other types, use a normalized version of the product title as the type identifier
        // This ensures unique products are still distinguished
        productType = productTitleLower.replace(/\s+/g, "-");
      }

      // Skip if we've already added this product type
      if (productType && addedTypes.has(productType)) {
        return;
      }

      // Filter variants by main product's finish - use normalized comparison (handles English and French)
      let filteredVariants = [];
      const mainProductFinishNormalized = this._normalizeFinish(mainProductFinish);
      if (mainProductFinishNormalized) {
        filteredVariants = product.variants.filter((v) => {
          if (!v.option1) return false;
          const variantFinishNormalized = this._normalizeFinish(v.option1);
          return variantFinishNormalized === mainProductFinishNormalized;
        });

        // If no exact match, try partial matching (e.g., "Gold Filled" matches "Gold", "Or" matches "Gold")
        if (filteredVariants.length === 0) {
          filteredVariants = product.variants.filter((v) => {
            if (!v.option1) return false;
            const variantFinishNormalized = this._normalizeFinish(v.option1);
            // Check if normalized finishes match
            return variantFinishNormalized === mainProductFinishNormalized;
          });
        }
      } else {
        // If no finish selected, use all variants
        filteredVariants = product.variants;
      }

      if (filteredVariants.length === 0) {
        // Fallback: try to find any available variant
        filteredVariants = product.variants;
      }

      // Get the first available variant
      const variant =
        filteredVariants.find((v) => v.available !== false) ||
        filteredVariants[0];

      if (variant) {
        // Mark this product type as added BEFORE adding the tab to prevent duplicates
        if (productType) {
          addedTypes.add(productType);
        }
        
        this._addAddonTab(product, variant, true); // true = isInitial (non-removable)
      } else {

      }
    });

    // If we have default addons, show the first addon preview (activeTab = 1)
    // Otherwise, show the main product (activeTab = 0)
    if (this.tabs.length > 0) {
      // Set activeTab to 1 to show the first addon preview
      this.activeTab = 1;
      // Set typeFilter to the first addon's customizationType
      const firstTab = this.tabs[0];
      if (firstTab && firstTab.customizationType) {
        this.typeFilter = firstTab.customizationType;
      }

    } else {
      // No default addons, show main product
      this.activeTab = originalActiveTab || 0;
    }

    this.initialAddonsInitialized = true;
    
    // Force update to show the initialized tabs
    this.requestUpdate();
    
    // Update overlay if open
    if (this.isOpen && this._overlayElement) {
      this._updateOverlayContent();
    }
  }

  _addFirstAvailableAddon() {
    // This is called when user clicks "+" to add a new addon
    // It should add one addon at a time (the first available one)
    const parsedAddons = this._parseAddonData();
    if (!parsedAddons || parsedAddons.length === 0) {

      return;
    }

    // Get the main product's selected finish (option1)
    const mainProductFinish = this.selectedOption1
      ? this.selectedOption1.trim()
      : "";

    // Get the first addon product
    const firstProduct = parsedAddons[0];
    if (
      !firstProduct ||
      !firstProduct.variants ||
      firstProduct.variants.length === 0
    ) {
      return;
    }

    // Filter variants by main product's finish - use normalized comparison (handles English and French)
    let filteredVariants = [];
    const mainProductFinishNormalized = this._normalizeFinish(mainProductFinish);
    if (mainProductFinishNormalized) {
      filteredVariants = firstProduct.variants.filter((v) => {
        if (!v.option1) return false;
        const variantFinishNormalized = this._normalizeFinish(v.option1);
        return variantFinishNormalized === mainProductFinishNormalized;
      });

      // If no exact match, try partial matching (e.g., "Gold Filled" matches "Gold", "Or" matches "Gold")
      if (filteredVariants.length === 0) {
        filteredVariants = firstProduct.variants.filter((v) => {
          if (!v.option1) return false;
          const variantFinishNormalized = this._normalizeFinish(v.option1);
          // Check if normalized finishes match
          return variantFinishNormalized === mainProductFinishNormalized;
        });
      }
    } else {
      // If no finish selected, use all variants
      filteredVariants = firstProduct.variants;
    }

    if (filteredVariants.length === 0) {
      // Fallback: try to find any available variant
      filteredVariants = firstProduct.variants;
    }

    // Get the first available variant
    const firstVariant =
      filteredVariants.find((v) => v.available !== false) ||
      filteredVariants[0];

    if (firstVariant) {
      this._addAddonTab(firstProduct, firstVariant);
    }
  }

  _addAddonTab(product, variant, isInitial = false) {
    // Determine preview from product properties
    const previewId = this._determinePreviewFromProduct(
      product.title,
      variant.title
    );

    // Get customization data - query from window.allCustomizationsMetaobjects
    let customizations = [];
    let customizationType = null;

    // Get all customizations from the global array
    const allCustomizations = window.allCustomizationsMetaobjects || [];

    // Try to get type and customizations from product.customizer (from Liquid template)
    // This works the same way for ALL types (Birthstone, Birth Flower, etc.)
    if (product.customizer) {
      // Get type, but treat empty strings as null
      const rawType =
        product.customizer.type || product.customizer.typeHandle || null;
      customizationType = rawType && rawType.trim() !== "" ? rawType : null;
      customizations = product.customizer.customizations || [];

      // Debug: Log raw customizations to see if finish field is present
      if (Array.isArray(customizations) && customizations.length > 0) {

      }

      // Ensure customizations are properly formatted
      if (Array.isArray(customizations) && customizations.length > 0) {
        // First, extract type from customizations if not already set
        if (!customizationType) {
          // Find the first customization with a type
          const firstWithType = customizations.find(
            (c) => c.type && c.type.trim() !== ""
          );
          if (firstWithType && firstWithType.type) {
            customizationType = firstWithType.type;
          }
        }

        // Now map customizations, using the extracted type if needed
        customizations = customizations.map((c, index) => {
          const mapped = {
            id: c.id || `customization-${index}-${c.name}`,
            name: c.name,
            image: c.image,
            type: c.type || customizationType || "Unknown",
            finish: c.finish || null, // Store finish field from metaobject
          };

          return mapped;
        });
      }
    }
    
    // FALLBACK: If type is still empty, check product title/handle for "Family Birth Flower Bouquet"
    if (!customizationType) {
      const productTitleLower = (product.title || "").toLowerCase();
      const productHandleLower = (product.handle || "").toLowerCase();

      if (
        this._checkIfFamilyBirthFlowerBouquet(product.title) ||
        this._checkIfFamilyBirthFlowerBouquet(product.handle)
      ) {
        customizationType = "Family Birth Flower Bouquet";

      } else {

      }
    }
    
    // Check if we have BOTH types: "Family Birth Flower Bouquet" as customizationType AND "Bloom Birth Flower" in customizations
    const hasBloomBirthFlowerInCustomizations = customizations && customizations.some((c) => c.type === "Bloom Birth Flower");
    const hasBothTypes = customizationType === "Family Birth Flower Bouquet" && hasBloomBirthFlowerInCustomizations;
    
    // SPECIAL CASE: If type is "Family Birth Flower Bouquet" BUT we DON'T have both types, clear customizations
    // If we HAVE both types, KEEP the customizations so multiple selection can work
    if (customizationType === "Family Birth Flower Bouquet" && !hasBothTypes) {
      customizations = []; // Clear customizations - will use Bloom Birth Flower from global in filter step
    } else if (hasBothTypes) {

    }

    // If customizations is still empty, query from window.allCustomizationsMetaobjects
    // Match by type name - works the same way for ALL types (Birthstone, Birth Flower, etc.)
    // SPECIAL CASE: Skip this for "Family Birth Flower Bouquet" - filtering will handle it
    // IMPORTANT: Only use this as a fallback - prefer customizations from product.customizer
    if (
      (!customizations || customizations.length === 0) &&
      allCustomizations.length > 0 &&
      customizationType !== "Family Birth Flower Bouquet"
    ) {
      // If we have a type name, filter by it (case-insensitive matching)
      if (customizationType) {
        customizations = allCustomizations
          .filter((mo) => {
            const moType = (mo.type || '').toLowerCase().trim();
            const filterType = (customizationType || '').toLowerCase().trim();
            return moType === filterType;
          })
          .map((mo) => ({
            id: mo.id || mo.name,
            name: mo.name,
            image: mo.image,
            type: mo.type,
            finish: mo.finish || null, // Store finish field if available
          }));

      } else {
        // If no type from metafield, try to infer from product name/handle
        // This makes it work dynamically for any type when metafield is missing
        const productTitleLower = (product.title || "").toLowerCase();
        const productHandleLower = (product.handle || "").toLowerCase();
        
        // Get all unique types from global customizations
        const allTypes = [...new Set(allCustomizations.map(mo => mo.type).filter(t => t))];
        
        // Try to find a matching type based on product name
        // Extract key words from product name (e.g., "birthstone" from "Add-On Birthstone Pendant")
        const productWords = productTitleLower.split(/[\s\-_]+/).filter(w => w.length > 2);
        const handleWords = productHandleLower.split(/[\s\-_]+/).filter(w => w.length > 2);
        const allProductWords = [...productWords, ...handleWords];

        let inferredType = null;
        let bestMatch = null;
        let bestMatchScore = 0;
        
        for (const type of allTypes) {
          const typeLower = (type || '').toLowerCase().trim();
          if (!typeLower) continue;
          
          // Check for exact word matches
          for (const word of allProductWords) {
            if (typeLower.includes(word) || word.includes(typeLower) || typeLower === word) {
              const score = word.length; // Longer matches are better
              if (score > bestMatchScore) {
                bestMatchScore = score;
                bestMatch = type;

              }
            }
          }
          
          // Also check if product name/handle contains the full type name
          if (productTitleLower.includes(typeLower) || productHandleLower.includes(typeLower)) {
            inferredType = type;

            break;
          }
        }
        
        // Use best match if no direct match found
        if (!inferredType && bestMatch) {
          inferredType = bestMatch;

        }
        
        if (inferredType) {
          customizationType = inferredType;
          const beforeFilter = allCustomizations.length;
          customizations = allCustomizations
            .filter((mo) => {
              const moType = (mo.type || '').toLowerCase().trim();
              const filterType = (inferredType || '').toLowerCase().trim();
              return moType === filterType;
            })
            .map((mo) => ({
              id: mo.id || mo.name,
              name: mo.name,
              image: mo.image,
              type: mo.type,
              finish: mo.finish || null, // Store finish field if available
            }));

          if (customizations.length === 0) {
            // No customizations found
          }
        } else {
          // If no type detected, don't use all customizations - this would show too many tabs

          customizations = [];
        }
      }
    }

    // Create a new tab for this addon
    const newTab = {
      id: Date.now() + Math.random(), // Unique ID for this instance
      type: "addon",
      variantId: variant.id,
      productTitle: product.title,
      variantTitle: variant.title,
      price: variant.price,
      selectedPreview: previewId, // Auto-determined preview
      selectedSymbol: null, // Selected customization
      customizations: customizations, // Available customizations
      customizationType: customizationType, // Type of customization (e.g., "Initial", "Symbol", etc.)
      isInitial: isInitial, // Mark if this is an initial addon (non-removable)
    };
    
    // Check if we have BOTH types after all processing
    const finalHasBloomBirthFlower = customizations && customizations.some((c) => c.type === "Bloom Birth Flower");
    const finalHasBothTypes = customizationType === "Family Birth Flower Bouquet" && finalHasBloomBirthFlower;
    
    // IMPORTANT: If type is "Family Birth Flower Bouquet", log it clearly
    if (customizationType === "Family Birth Flower Bouquet") {
      if (finalHasBothTypes) {

      } else {

      }
    }

    this.tabs = [...this.tabs, newTab];
    
    // Track addon added
    this._trackEvent('customizer_addon_added', {
      productTitle: this.productTitle,
      addonTitle: product.title,
      addonVariantId: variant.id,
      addonType: customizationType || 'unknown',
      isInitial: isInitial,
      totalAddons: this.tabs.length
    });
    
    // Only switch tabs and reset filters if this is NOT an initial addon
    if (!isInitial) {
      // Switch to the new tab (Main is 0, so new tab index is tabs.length)
      // activeTab: 0 = main, 1+ = addon tabs (index + 1), -1 = add new
      this.activeTab = this.tabs.length;
      // Reset type filter to first type when adding new tab
      const types = this._getAvailableTypes();
      this.typeFilter = types && types.length > 0 ? types[0] : null;
    }
    // For initial addons, keep activeTab at 0 (main) and don't change typeFilter
    
    this.requestUpdate();
    // Update overlay if open
    if (this.isOpen && this._overlayElement) {
      this._updateOverlayContent();
      // Ensure the add to cart button is visible after adding an addon
      requestAnimationFrame(() => {
        const addCartButton = this._overlayElement?.querySelector('.customizer__add-cart');
        const actionsSection = this._overlayElement?.querySelector('.customizer__actions');
        if (addCartButton && actionsSection) {
          // Ensure button is visible
          addCartButton.style.display = 'block';
          addCartButton.style.visibility = 'visible';
          // Scroll actions into view if needed (but don't force scroll if already visible)
          const rect = actionsSection.getBoundingClientRect();
          const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
          if (!isVisible) {
            actionsSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      });
    }
  }

  _selectCustomization(tabIndex, customization) {
    const addonIndex = tabIndex - 1;
    if (this.tabs[addonIndex]) {
      // Try to find a customization with matching finish if available
      const tab = this.tabs[addonIndex];
      const bestMatch = this._findBestMatchingCustomization(customization, tab.customizations);
      this.tabs = this.tabs.map((tab, idx) =>
        idx === addonIndex ? { ...tab, selectedSymbol: bestMatch || customization } : tab
      );
      this.requestUpdate();
    }
  }

  /**
   * Find the best matching customization based on finish
   * If finish field contains "gold" or "silver" matching the main product, prefer that
   */
  _findBestMatchingCustomization(selectedCustomization, availableCustomizations) {
    if (!selectedCustomization || !availableCustomizations) {
      return selectedCustomization;
    }

    const mainFinishNormalized = this._normalizeFinish(this.selectedOption1);
    if (!mainFinishNormalized) {
      // No finish selected, return original
      return selectedCustomization;
    }

    const selectedId = selectedCustomization.id || selectedCustomization.name;
    const selectedName = selectedCustomization.name;

    // First, try to find match by ID and finish matches (normalized - handles English and French)
    const exactMatch = availableCustomizations.find((c) => {
      const idMatch = (c.id === selectedId || c.name === selectedId);
      if (!idMatch) return false;
      // Check if finish field matches (normalized comparison handles both English and French)
      // Handle null, undefined, empty string, or actual values
      if (c.finish && c.finish !== null && c.finish !== 'null' && String(c.finish).trim() !== '') {
        const customizationFinishNormalized = this._normalizeFinish(c.finish);
        return customizationFinishNormalized === mainFinishNormalized;
      }
      return false;
    });

    if (exactMatch) {
      return exactMatch;
    }

    // Fallback: find by name and finish matches (normalized - handles English and French)
    const nameMatch = availableCustomizations.find((c) => {
      const nameMatches = (c.name === selectedName);
      if (!nameMatches) return false;
      // Check if finish field matches (normalized comparison handles both English and French)
      // Handle null, undefined, empty string, or actual values
      if (c.finish && c.finish !== null && c.finish !== 'null' && String(c.finish).trim() !== '') {
        const customizationFinishNormalized = this._normalizeFinish(c.finish);
        return customizationFinishNormalized === mainFinishNormalized;
      }
      return false;
    });

    return nameMatch || selectedCustomization;
  }

  _determinePreviewFromProduct(productTitle, variantTitle) {
    // Combine product and variant title for analysis
    const searchText = `${productTitle} ${variantTitle}`.toLowerCase();

    // Determine material
    const isGold = searchText.includes("gold");
    const isSilver =
      searchText.includes("silver") || searchText.includes("sterling");

    // Determine shape
    const isOval = searchText.includes("oval");
    const isCircle =
      searchText.includes("circle") ||
      searchText.includes("disc") ||
      searchText.includes("round");
    const isRectangle = searchText.includes("tag");
    const isBirthstone =
      searchText.includes("birthstone") || searchText.includes("stone");

    // Return appropriate preview
    if (isBirthstone) {
      return PREVIEW_OPTIONS.BIRTHSTONE.id;
    } else if (isRectangle) {
      // If product title contains "Tag", use rectangle preview
      return isGold
        ? PREVIEW_OPTIONS.GOLD_RECTANGLE.id
        : PREVIEW_OPTIONS.SILVER_RECTANGLE.id;
    } else if (isOval) {
      return isGold
        ? PREVIEW_OPTIONS.GOLD_OVAL.id
        : PREVIEW_OPTIONS.SILVER_OVAL.id;
    } else if (isCircle) {
      return isGold
        ? PREVIEW_OPTIONS.GOLD_CIRCLE.id
        : PREVIEW_OPTIONS.SILVER_CIRCLE.id;
    } else {
      // Default to gold circle if no match
      return PREVIEW_OPTIONS.GOLD_CIRCLE.id;
    }
  }

  _getCurrentPreview() {
    if (this.activeTab === 0) {
      // For main product, determine from selected variant
      const optionText = this.selectedOption1
        ? this.selectedOption1.toLowerCase()
        : "";
      if (optionText.includes("gold")) {
        return optionText.includes("oval")
          ? PREVIEW_OPTIONS.GOLD_OVAL.id
          : PREVIEW_OPTIONS.GOLD_CIRCLE.id;
      } else if (
        optionText.includes("silver") ||
        optionText.includes("sterling")
      ) {
        return optionText.includes("oval")
          ? PREVIEW_OPTIONS.SILVER_OVAL.id
          : PREVIEW_OPTIONS.SILVER_CIRCLE.id;
      }
      return PREVIEW_OPTIONS.GOLD_CIRCLE.id;
    } else {
      // For addon tabs, determine from product/variant info
      const addonIndex = this.activeTab - 1;
      const tab = this.tabs[addonIndex];
      if (tab) {
        // Use stored preview or determine from product title
        if (tab.selectedPreview) {
          return tab.selectedPreview;
        }
        // Determine from product title and variant
        return this._determinePreviewFromProduct(
          tab.productTitle,
          tab.variantTitle
        );
      }
      return PREVIEW_OPTIONS.GOLD_CIRCLE.id;
    }
  }

  _getActivePreviewId() {
    if (this.activeTab === 0) {
      return "main";
    } else if (this.activeTab === -1) {
      return "add-new";
    } else {
      // activeTab: 1 = first addon (tabs[0]), 2 = second addon (tabs[1]), etc.
      const tabIndex = this.activeTab - 1;
      const tab = this.tabs[tabIndex];
      if (tab) {
        const previewId = `preview-${tab.id}`;
        return previewId;
      } else {
        return "main";
      }
    }
  }

  _getAvailableTypes() {
    // Get all unique types from the active preview's customizations
    const activePreviewId = this._getActivePreviewId();
    const isMain = activePreviewId === "main";

    let customizations = [];
    if (isMain) {
      // For main product, use customizations from ALL addon products' metafields
      const parsedAddons = this._parseAddonData();
      const allAddonCustomizations = [];

      const allCustomizations = window.allCustomizationsMetaobjects || [];
      if (parsedAddons && Array.isArray(parsedAddons)) {
        parsedAddons.forEach((product) => {
          // Get customizations from the addon product's customizer metafield (metaobject references)
          // Works the EXACT same way as _addAddonTab
          if (product.customizer) {
            if (
              product.customizer.customizations &&
              Array.isArray(product.customizer.customizations)
            ) {
              // The customizations are already extracted from metaobject references by Liquid
              product.customizer.customizations.forEach((c) => {
                allAddonCustomizations.push({
                  id: c.id || `customization-${c.name}`,
                  name: c.name || "",
                  image: c.image || "",
                  type: c.type || product.customizer.type || "",
                });
              });
            }
          } else {
            // If customizer is null, use the EXACT same fallback logic as _addAddonTab
            // This includes type inference from product name (lines 1668-1754 in _addAddonTab)
            let customizationType = null;
            
            // FALLBACK: If type is still empty, check product title/handle for "Family Birth Flower Bouquet"
            const productTitleLower = (product.title || "").toLowerCase();
            const productHandleLower = (product.handle || "").toLowerCase();
            if (
              this._checkIfFamilyBirthFlowerBouquet(product.title) ||
              this._checkIfFamilyBirthFlowerBouquet(product.handle)
            ) {
              customizationType = "Family Birth Flower Bouquet";
            }
            
            // If no type yet, infer from product name - EXACT same logic as _addAddonTab
            if (!customizationType && allCustomizations.length > 0) {
              const allTypes = [...new Set(allCustomizations.map(mo => mo.type).filter(t => t))];
              const productWords = productTitleLower.split(/[\s\-_]+/).filter(w => w.length > 2);
              const handleWords = productHandleLower.split(/[\s\-_]+/).filter(w => w.length > 2);
              const allProductWords = [...productWords, ...handleWords];
              
              let inferredType = null;
              let bestMatch = null;
              let bestMatchScore = 0;
              
              for (const type of allTypes) {
                const typeLower = (type || '').toLowerCase().trim();
                if (!typeLower) continue;
                
                for (const word of allProductWords) {
                  if (typeLower.includes(word) || word.includes(typeLower) || typeLower === word) {
                    const score = word.length;
                    if (score > bestMatchScore) {
                      bestMatchScore = score;
                      bestMatch = type;
                    }
                  }
                }
                
                if (productTitleLower.includes(typeLower) || productHandleLower.includes(typeLower)) {
                  inferredType = type;
                  break;
                }
              }
              
              if (!inferredType && bestMatch) {
                inferredType = bestMatch;
              }
              
              if (inferredType) {
                customizationType = inferredType;
              }
            }
            
            // If we have a type, load from global array - EXACT same logic as _addAddonTab
            if (customizationType && allCustomizations.length > 0 && customizationType !== "Family Birth Flower Bouquet") {
              const loaded = allCustomizations
                .filter((mo) => {
                  const moType = (mo.type || '').toLowerCase().trim();
                  const filterType = (customizationType || '').toLowerCase().trim();
                  return moType === filterType;
                })
                .map((mo) => ({
                  id: mo.id || mo.name,
                  name: mo.name,
                  image: mo.image,
                  type: mo.type,
                }));
              loaded.forEach((c) => allAddonCustomizations.push(c));
            }
          }
        });
      }

      // Remove duplicates based on id and name
      const uniqueCustomizations = [];
      const seen = new Set();
      allAddonCustomizations.forEach((c) => {
        const key = `${c.id || ""}-${c.name || ""}`;
        if (!seen.has(key)) {
          seen.add(key);
          uniqueCustomizations.push(c);
        }
      });

      customizations = uniqueCustomizations;
    } else {
      // For addon tabs, ALWAYS return ONLY the tab's customizationType
      // Each initial addon tab should show ONLY its own type, not multiple types
      const tab = this.tabs.find((t) => `preview-${t.id}` === activePreviewId);
      if (tab) {
        // For addon tabs, ONLY return the customizationType - never extract from customizations
        if (tab.customizationType) {

          return [tab.customizationType];
        } else {
          // If no customizationType, return empty (shouldn't happen for properly configured addons)

          return [];
        }
      } else {
        return [];
      }
    }

    // Extract unique types ONLY from the customizations we have (not from all addons)
    // This code only runs for main product tabs
    const types = new Set();
    customizations.forEach((mo) => {
      if (mo.type && mo.type.trim() !== "") {
        // Preserve original case but normalize for comparison
        types.add(mo.type.trim());
      }
    });
    
    // Check if tab has both "Bloom Birth Flower" and "Family Birth Flower Bouquet" types
    // ONLY check within the current tab's customizations
    if (!isMain) {
      const tab = this.tabs.find((t) => `preview-${t.id}` === activePreviewId);
      if (tab) {
        // Check customizations for both types - ONLY from this tab's customizations
        const hasBloomBirthFlower = customizations.some((mo) => mo.type === "Bloom Birth Flower");
        const hasFamilyBouquet = customizations.some((mo) => mo.type === "Family Birth Flower Bouquet") || 
                          tab.customizationType === "Family Birth Flower Bouquet";
        
        // If has both types, add both to the types set
        if (hasBloomBirthFlower && hasFamilyBouquet) {
          types.add("Bloom Birth Flower");
          types.add("Family Birth Flower Bouquet");
        } else if (hasFamilyBouquet) {
          types.add("Family Birth Flower Bouquet");
        } else if (hasBloomBirthFlower) {
          types.add("Bloom Birth Flower");
        }
      }
    } else {
      // For main product
      const hasFamilyBouquet = customizations.some((mo) => mo.type === "Family Birth Flower Bouquet");
      if (hasFamilyBouquet) {
        types.add("Family Birth Flower Bouquet");
      }
    }
    
    // Return only the types that exist in the current tab's customizations
    const typesArray = Array.from(types).sort();

    return typesArray;
  }

  _getFilteredOptions() {
    // Get options for the active preview, filtered by typeFilter
    const activePreviewId = this._getActivePreviewId();
    const isMain = activePreviewId === "main";

    let availableOptions = [];

    if (isMain) {
      // For main product, use ALL customizations from global array directly
      // Same approach as addon tabs - use the source directly
      const allCustomizations = window.allCustomizationsMetaobjects || [];
      
      // Map all global customizations, preserving finish field (same as addon tabs)
      availableOptions = allCustomizations.map((mo) => ({
        id: mo.id || mo.name,
        name: mo.name,
        image: mo.image,
        type: mo.type,
        finish: mo.finish || null, // Preserve finish field
      }));

    } else {
      // For addon tabs, use ONLY the customizations from the tab (not global)
      const tab = this.tabs.find((t) => `preview-${t.id}` === activePreviewId);

      if (tab) {
        // Check if tab has both types
        const hasBloomBirthFlower = tab.customizations && tab.customizations.some((c) => c.type === "Bloom Birth Flower");
        const hasFamilyBouquet = tab.customizationType === "Family Birth Flower Bouquet" || 
                                 (tab.customizations && tab.customizations.some((c) => c.type === "Family Birth Flower Bouquet"));
        const hasBothTypes = hasBloomBirthFlower && hasFamilyBouquet;
        
        // SPECIAL CASE: If tab has "Family Birth Flower Bouquet" type (but not both), get "Bloom Birth Flower" options from global
        if (tab.customizationType === "Family Birth Flower Bouquet" && !hasBothTypes) {
          const allCustomizations = window.allCustomizationsMetaobjects || [];

          const bloomOptions = allCustomizations.filter((mo) => mo.type === "Bloom Birth Flower");

          availableOptions = bloomOptions.map((mo) => ({
            id: mo.id || mo.name,
            name: mo.name,
            image: mo.image,
            type: mo.type,
            finish: mo.finish || null, // Include finish field
          }));

        } else if (hasBothTypes) {
          // Tab has both types - use customizations from the tab
          availableOptions = tab.customizations || [];

        } else if (
          tab.customizations &&
          Array.isArray(tab.customizations) &&
          tab.customizations.length > 0
        ) {
          availableOptions = tab.customizations;
        } else {
          availableOptions = [];
        }
        
        // Filter by product type (Disc vs Pendant) - only filter if options explicitly specify product type
        // Only exclude options that explicitly mention the opposite product type
        if (availableOptions.length > 0 && tab.productTitle) {
          const productTitleLower = (tab.productTitle || "").toLowerCase();
          const isDisc = productTitleLower.includes("disc");
          const isPendant = productTitleLower.includes("pendant");
          
          if (isDisc || isPendant) {
            const beforeProductTypeFilter = availableOptions.length;
            
            // Only filter out options that EXPLICITLY mention the opposite product type
            // This is less aggressive - we keep all general options and only exclude mismatches
            availableOptions = availableOptions.filter((option) => {
              const optionNameLower = (option.name || "").toLowerCase();
              const optionTypeLower = (option.type || "").toLowerCase();
              
              // If product is a disc, exclude options that explicitly mention "pendant"
              if (isDisc) {
                const hasPendant = optionNameLower.includes("pendant") || optionTypeLower.includes("pendant");
                // Only exclude if it explicitly mentions pendant
                return !hasPendant;
              }
              
              // If product is a pendant, exclude options that explicitly mention "disc"
              if (isPendant) {
                const hasDisc = optionNameLower.includes("disc") || optionTypeLower.includes("disc");
                // Only exclude if it explicitly mentions disc
                return !hasDisc;
              }
              
              // If product type is unclear, show all options
              return true;
            });

          }
        }
      } else {
        availableOptions = [];
      }
    }

    // Filter by type if typeFilter is set
    let filtered = availableOptions;
    if (this.typeFilter) {
      // SPECIAL CASE: If tab has BOTH types, show options for the selected type filter
      // Otherwise, swap "Family Birth Flower Bouquet" to "Bloom Birth Flower" (legacy behavior)
      const tab = !isMain ? this.tabs.find((t) => `preview-${t.id}` === activePreviewId) : null;
      const hasBothTypes = tab && tab.customizations && 
        tab.customizations.some((c) => c.type === "Bloom Birth Flower") &&
        (tab.customizationType === "Family Birth Flower Bouquet" || 
         tab.customizations.some((c) => c.type === "Family Birth Flower Bouquet"));
      
      let filterType = this.typeFilter;
      if (this.typeFilter === "Family Birth Flower Bouquet" && !hasBothTypes) {
        // Only swap if we don't have both types (legacy behavior)
        filterType = "Bloom Birth Flower";
      }
      
      // Use case-insensitive comparison for type matching
      filtered = filtered.filter((mo) => {
        const moType = (mo.type || '').toLowerCase().trim();
        const filterTypeLower = (filterType || '').toLowerCase().trim();
        const matches = moType === filterTypeLower;
        if (!matches && availableOptions.length < 10) {

        }
        return matches;
      });

      if (filtered.length === 0 && availableOptions.length > 0) {
        // No filtered results but options available
      }
    } else {

    }

    // Filter by finish if main product has a finish selected
    // Only filter options that have a finish field - options without finish should always be shown
    if (this.selectedOption1) {
      const mainFinishNormalized = this._normalizeFinish(this.selectedOption1);
      if (mainFinishNormalized) {
        const beforeFinishFilter = filtered.length;
        
        filtered = filtered.filter((option) => {
          // If option doesn't have a finish field, always show it
          if (!option.finish || option.finish === null || option.finish === 'null' || String(option.finish).trim() === '') {
            return true;
          }
          
          // If option has a finish field, check if it matches the main product's finish
          // Use normalized comparison to handle both English and French (e.g., "Gold"/"Or", "Silver"/"Argent")
          const optionFinishNormalized = this._normalizeFinish(option.finish);
          const matches = optionFinishNormalized === mainFinishNormalized;
          
          if (!matches && beforeFinishFilter < 20) {

          }
          
          return matches;
        });

        if (filtered.length < beforeFinishFilter) {
          // Some options were filtered out by finish
        }
        
        // Deduplicate after finish filtering to remove any duplicates
        const deduplicated = [];
        const seenAfterFilter = new Set();
        filtered.forEach((option) => {
          const key = `${option.id || ""}-${option.name || ""}`;
          if (!seenAfterFilter.has(key)) {
            seenAfterFilter.add(key);
            deduplicated.push(option);
          }
        });
        
        if (deduplicated.length !== filtered.length) {

        }
        
        filtered = deduplicated;
      } else {

      }
    } else {

    }

    // Sort: month-based first, then others
    const monthOrder = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthBased = [];
    const others = [];

    filtered.forEach((mo) => {
      const hasMonth = monthOrder.some(
        (month) =>
          mo.name && mo.name.toLowerCase().includes(month.toLowerCase())
      );
      if (hasMonth) {
        monthBased.push(mo);
      } else {
        // Include ALL options, including Initial type
        others.push(mo);
      }
    });

    // Sort month-based by month order
    monthBased.sort((a, b) => {
      const aMonth = monthOrder.findIndex(
        (m) => a.name && a.name.toLowerCase().includes(m.toLowerCase())
      );
      const bMonth = monthOrder.findIndex(
        (m) => b.name && b.name.toLowerCase().includes(m.toLowerCase())
      );
      return aMonth - bMonth;
    });

    return [...monthBased, ...others];
  }

  _getSelectionForPreview(previewId) {
    if (previewId === "main") {
      // Main preview selection - stored separately or in selections object
      const selection = this.selections?.main || null;
      // For Family Birth Flower Bouquet, ALWAYS return as array (even if empty)
      if (this._isFamilyBirthFlowerBouquet()) {
        if (!selection) {
          return [];
        }
        if (Array.isArray(selection)) {
          return selection;
        }
        // Convert single object to array
        return [selection];
      }
      return selection;
    } else {
      // Addon preview selection - get from tab
      const tab = this.tabs.find((t) => `preview-${t.id}` === previewId);
      const selection = tab?.selectedSymbol || null;
      // For Family Birth Flower Bouquet addon tabs, always return as array
      // Check product title/handle, customizationType, or customizations
      if (tab) {
        const isFamilyBouquetProduct = this._checkIfFamilyBirthFlowerBouquet(tab.productTitle) ||
                                       this._checkIfFamilyBirthFlowerBouquet(tab.productHandle);
        const hasFamilyBouquetType = tab.customizationType === "Family Birth Flower Bouquet";
        const hasFamilyBouquetInCustomizations = tab.customizations && tab.customizations.some((c) => c.type === "Family Birth Flower Bouquet");
        
        if (isFamilyBouquetProduct || hasFamilyBouquetType || hasFamilyBouquetInCustomizations) {
          if (!selection) {
            return [];
          }
          if (Array.isArray(selection)) {
            return selection;
          }
          // Convert single object to array
          return [selection];
        }
      }
      return selection;
    }
  }

  _selectOption(option) {
    const previewId = this._getActivePreviewId();

    if (previewId === "main") {
      // Store main selection
      if (!this.selections) this.selections = {};
      
      // Special case: Check if we have both "Bloom Birth Flower" and "Family Birth Flower Bouquet" types
      // OR if typeFilter is "Family Birth Flower Bouquet" OR if product is Family Birth Flower Bouquet - enables multiple selections
      const types = this._getAvailableTypes();
      const hasBothTypes = types.includes("Bloom Birth Flower") && types.includes("Family Birth Flower Bouquet");
      const isFamilyBouquetType = this.typeFilter === "Family Birth Flower Bouquet";
      const isFamilyBouquetProduct = this._isFamilyBirthFlowerBouquet();
      
      // CRITICAL: For Family Birth Flower Bouquet products, ALWAYS use array mode - no exceptions!
      // Check product first - this is the most reliable indicator
      if (isFamilyBouquetProduct || hasBothTypes || isFamilyBouquetType) {
        // Initialize as array if not already (convert single object to array if needed)
        if (!Array.isArray(this.selections.main)) {
          if (this.selections.main) {
            // Convert existing single selection to array
            this.selections.main = [this.selections.main];
          } else {
            // Initialize as empty array
            this.selections.main = [];
          }
        }
        
        // For Family Birth Flower Bouquet, always add (no toggle/remove behavior)
        // Users can select the same flower multiple times
        this.selections.main.push({
          id: option.id,
          image: option.image,
          name: option.name,
          value: option.name,
          type: option.type || "Bloom Birth Flower",
          finish: option.finish || null, // Preserve finish field
        });
        
        // AGGRESSIVE UPDATE - Force immediate re-render of previews
        this.requestUpdate();
        // Use setTimeout to ensure DOM updates after LitElement render
        setTimeout(() => {
          if (this.isOpen && this._overlayElement) {
            this._updateOverlayContent();
          }
          // Force another update to ensure previews are rendered
          this.requestUpdate();
        }, 0);
        
        // Track customization selected (main, multiple)
        this._trackEvent('customizer_customization_selected', {
          productTitle: this.productTitle,
          previewId: 'main',
          customizationName: option.name,
          customizationType: option.type || this.typeFilter,
          isMultiple: true,
          selectionCount: Array.isArray(this.selections.main) ? this.selections.main.length : 0
        });
      } else {
        // Single selection for other types - allow toggle off if same option clicked
        if (this.selections.main && this.selections.main.id === option.id) {
          // Toggle off - clear selection
          this.selections.main = null;
          // Track customization deselected
          this._trackEvent('customizer_customization_deselected', {
            productTitle: this.productTitle,
            previewId: 'main',
            customizationName: option.name,
            customizationType: option.type || this.typeFilter
          });
        } else {
            // Set new selection
          this.selections.main = {
            id: option.id,
            image: option.image,
            name: option.name,
            value: option.name,
            type: option.type,
            fontFamily: option.fontFamily || null,
            finish: option.finish || null, // Preserve finish field
          };
          
          // Track customization selected (main, single)
          this._trackEvent('customizer_customization_selected', {
            productTitle: this.productTitle,
            previewId: 'main',
            customizationName: option.name,
            customizationType: option.type || this.typeFilter,
            isMultiple: false
          });
        }
      }
      
      // Update preview if manual text exists (for Initial/Name types)
      const typeFilterLower = (this.typeFilter || "").toLowerCase();
      const isInitialOrName = typeFilterLower === "initial" || typeFilterLower === "initials" || typeFilterLower === "name";
      if (isInitialOrName && this._mainManualText && this._mainManualText.trim()) {
        // Update preview in real-time when font style changes - use double requestAnimationFrame to ensure DOM is ready
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this._updatePreviewForManualText("main", true);
          });
        });
      }
    } else {
      // Store in tab
      const tabIndex = this.tabs.findIndex(
        (t) => `preview-${t.id}` === previewId
      );
      if (tabIndex >= 0) {
        const tab = this.tabs[tabIndex];
        // Check if this tab has BOTH "Bloom Birth Flower" AND "Family Birth Flower Bouquet" types
        // This enables multiple selections
        // Check if tab has both types in its customizations OR if customizationType is set and customizations have the other type
        // ALSO check product title/handle for Family Birth Flower Bouquet products
        const hasBloomBirthFlower = tab.customizations && tab.customizations.some((c) => c.type === "Bloom Birth Flower");
        const hasFamilyBouquetInCustomizations = tab.customizations && tab.customizations.some((c) => c.type === "Family Birth Flower Bouquet");
        const isFamilyBouquetProduct = this._checkIfFamilyBirthFlowerBouquet(tab.productTitle) ||
                                       this._checkIfFamilyBirthFlowerBouquet(tab.productHandle);
        const hasFamilyBouquet = tab.customizationType === "Family Birth Flower Bouquet" || 
                                 hasFamilyBouquetInCustomizations || 
                                 isFamilyBouquetProduct;
        const hasBothTypes = hasBloomBirthFlower && hasFamilyBouquet;
        
        if (hasBothTypes || isFamilyBouquetProduct) {
          // Initialize as array if not already
          if (!Array.isArray(tab.selectedSymbol)) {
            if (tab.selectedSymbol) {
              // Convert existing single selection to array
              tab.selectedSymbol = [tab.selectedSymbol];
            } else {
              tab.selectedSymbol = [];
            }
          }
          
          // For Family Birth Flower Bouquet, ALWAYS add (no toggle/remove behavior)
          // Users can select the same flower multiple times
          // Find best matching option based on finish
          const bestMatch = this._findBestMatchingCustomization(option, tab.customizations);
          const selectedOption = bestMatch || option;
          // Add to selections - include finish field from the customization
          tab.selectedSymbol.push({
            id: selectedOption.id,
            image: selectedOption.image,
            name: selectedOption.name,
            value: selectedOption.name,
            type: selectedOption.type || "Bloom Birth Flower",
            finish: selectedOption.finish || null, // Preserve finish field
          });
          
          // AGGRESSIVE UPDATE - Force immediate re-render of previews
          this.requestUpdate();
          setTimeout(() => {
            if (this.isOpen && this._overlayElement) {
              this._updateOverlayContent();
            }
            // Force another update to ensure previews are rendered
            this.requestUpdate();
          }, 0);
          
          // Track customization selected (addon, multiple)
          this._trackEvent('customizer_customization_selected', {
            productTitle: this.productTitle,
            previewId: previewId,
            addonTitle: tab.productTitle,
            customizationName: selectedOption.name,
            customizationType: selectedOption.type || tab.customizationType,
            isMultiple: true,
            selectionCount: Array.isArray(tab.selectedSymbol) ? tab.selectedSymbol.length : 0
          });
        } else if (hasFamilyBouquet) {

          // Initialize as array if not already
          if (!Array.isArray(tab.selectedSymbol)) {
            tab.selectedSymbol = [];
          }
          
          // For Family Birth Flower Bouquet, always add (no toggle/remove behavior)
          // Users can select the same flower multiple times
          // Find best matching option based on finish
          const bestMatch = this._findBestMatchingCustomization(option, tab.customizations);
          const selectedOption = bestMatch || option;
          // Add to selections - include finish field from the customization
          tab.selectedSymbol.push({
            id: selectedOption.id,
            image: selectedOption.image,
            name: selectedOption.name,
            value: selectedOption.name,
            type: selectedOption.type || "Bloom Birth Flower",
            fontFamily: selectedOption.fontFamily || option.fontFamily || null,
            finish: selectedOption.finish || null, // Preserve finish field
          });

          // Force update to show visual cues
          this.requestUpdate();
          if (this.isOpen && this._overlayElement) {
            this._updateOverlayContent();
          }
          
          // Track customization selected (addon, multiple - Family Bouquet)
          this._trackEvent('customizer_customization_selected', {
            productTitle: this.productTitle,
            previewId: previewId,
            addonTitle: tab.productTitle,
            customizationName: selectedOption.name,
            customizationType: selectedOption.type || tab.customizationType,
            isMultiple: true,
            selectionCount: Array.isArray(tab.selectedSymbol) ? tab.selectedSymbol.length : 0
          });
        } else {
          // Single selection for other types - allow toggle off if same option clicked
          if (tab.selectedSymbol && tab.selectedSymbol.id === option.id) {
            // Toggle off - clear selection
            tab.selectedSymbol = null;
            
            // Track customization deselected (addon)
            this._trackEvent('customizer_customization_deselected', {
              productTitle: this.productTitle,
              previewId: previewId,
              addonTitle: tab.productTitle,
              customizationName: option.name,
              customizationType: option.type || tab.customizationType
            });
          } else {
            // Try to find best matching option based on finish
            const bestMatch = this._findBestMatchingCustomization(option, tab.customizations);
            const selectedOption = bestMatch || option;
            // Set new selection (preserve fontFamily and finish if it's a font option)
            tab.selectedSymbol = {
              id: selectedOption.id,
              image: selectedOption.image,
              name: selectedOption.name,
              value: selectedOption.name,
              type: selectedOption.type,
              fontFamily: selectedOption.fontFamily || option.fontFamily || null,
              finish: selectedOption.finish || null, // Preserve finish field
            };
            
            // Track customization selected (addon, single)
            this._trackEvent('customizer_customization_selected', {
              productTitle: this.productTitle,
              previewId: previewId,
              addonTitle: tab.productTitle,
              customizationName: selectedOption.name,
              customizationType: selectedOption.type || tab.customizationType,
              isMultiple: false
            });
            
            // Auto-switch to next tab if this is the first default addon and there's another default addon
            if (tab.isInitial) {
              const initialTabs = this.tabs.filter(t => t.isInitial);
              const currentInitialIndex = initialTabs.findIndex(t => t.id === tab.id);
              if (currentInitialIndex >= 0 && currentInitialIndex < initialTabs.length - 1) {
                // This is not the last initial tab, switch to the next one
                const nextInitialTab = initialTabs[currentInitialIndex + 1];
                const nextTabIndex = this.tabs.findIndex(t => t.id === nextInitialTab.id);
                if (nextTabIndex >= 0) {
                  setTimeout(() => {
                    this.activeTab = nextTabIndex + 1;
                    if (nextInitialTab.customizationType) {
                      this.typeFilter = nextInitialTab.customizationType;
                    }
                    this.requestUpdate();
                    if (this.isOpen && this._overlayElement) {
                      this._updateOverlayContent();
                    }
                  }, 300); // Small delay for better UX
                }
              }
            }
          }
        }
        
        this.tabs = this.tabs.map((t, idx) =>
          idx === tabIndex ? tab : t
        );
        
        // Update preview if manual text exists (for Initial/Name types)
        const tabCustomizationType = (tab?.customizationType || "").toLowerCase();
        const isInitialOrName = tabCustomizationType === "initial" || tabCustomizationType === "initials" || tabCustomizationType === "name";
        if (isInitialOrName && tab.manualText && tab.manualText.trim()) {
          // Update preview in real-time when font style changes - use double requestAnimationFrame to ensure DOM is ready
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this._updatePreviewForManualText(previewId, false);
            });
          });
        }
      }
    }
    this.requestUpdate();
    // Update overlay if open
    if (this.isOpen && this._overlayElement) {
      this._updateOverlayContent();
    }
  }

  _switchPreview(previewId) {
    if (previewId === "main") {
      // If there are initial (default) addons, redirect to first addon instead
      const hasInitialAddons = this.tabs.some(tab => tab.isInitial);
      if (hasInitialAddons && this.tabs.length > 0) {
        // Switch to first addon instead of main
        this.activeTab = 1;
        const firstTab = this.tabs[0];
        if (firstTab && firstTab.customizationType) {
          this.typeFilter = firstTab.customizationType;
        }
        return;
      }
      this.activeTab = 0;
      // For main product, get types from all addons
      const types = this._getAvailableTypes();
      this.typeFilter = types && types.length > 0 ? types[0] : null;
    } else {
      // Find the tab that matches this preview ID
      const tabIndex = this.tabs.findIndex((t) => {
        const tabPreviewId = `preview-${t.id}`;
        return tabPreviewId === previewId;
      });
      if (tabIndex >= 0) {
        // activeTab: 0 = main, 1+ = addon tabs (tabIndex + 1)
        this.activeTab = tabIndex + 1;
        const tab = this.tabs[tabIndex];
        // For addon tabs, ALWAYS set typeFilter to the tab's customizationType
        // This ensures each addon tab shows only its own type
        if (tab && tab.customizationType) {
          this.typeFilter = tab.customizationType;

        } else {
          const types = this._getAvailableTypes();
          this.typeFilter = types && types.length > 0 ? types[0] : null;
        }
      }
    }
    
    this.requestUpdate();
    // Update overlay if open
    if (this.isOpen && this._overlayElement) {
      this._updateOverlayContent();
    }
  }

  _renderPreview(previewId, selectedCustomization = null) {
    const preview =
      Object.values(PREVIEW_OPTIONS).find((opt) => opt.id === previewId) ||
      PREVIEW_OPTIONS.GOLD_CIRCLE;

    if (preview.id === PREVIEW_OPTIONS.BIRTHSTONE.id) {
      // Birthstone - no circle/oval
      // IF IT'S A HEART BIRTHSTONE, GET FIRST OPTION
      let firstOption = null;
      if (!selectedCustomization) {
        const typeFilterLower = (this.typeFilter || "").toLowerCase();
        const isHeartBirthstone = typeFilterLower.includes("heart");
        
        if (isHeartBirthstone) {
          const allCustomizations = window.allCustomizationsMetaobjects || [];
          const availableCustomizations = allCustomizations.filter(c => 
            c.type && c.type.toLowerCase() === typeFilterLower
          );
          if (availableCustomizations.length > 0) {
            firstOption = availableCustomizations[0];
            const matchingImage = this._getMatchingFinishImage(firstOption, allCustomizations);
            if (matchingImage) {
              firstOption = { ...firstOption, image: matchingImage };
            }
          }
        }
      }
      
      return html`
        <div class="preview-display preview-birthstone">
          ${selectedCustomization
            ? html`
                <img
                  src="${selectedCustomization.image}"
                  alt="${selectedCustomization.name}"
                  style="max-width: 120px; max-height: 120px; object-fit: contain;"
                />
              `
            : firstOption && firstOption.image
            ? html`
                <img
                  src="${firstOption.image}"
                  alt="${firstOption.name || ''}"
                  style="max-width: 120px; max-height: 120px; object-fit: contain;"
                />
              `
            : html``}
          <div class="preview-label">${preview.name}</div>
          ${selectedCustomization
            ? html`<div class="preview-customization-name">
                ${selectedCustomization.name}
              </div>`
            : ""}
        </div>
      `;
    } else {
      // Circle or Oval with material
      const shapeClass =
        preview.shape === "circle" ? "preview-circle" : "preview-oval";
      const materialClass =
        preview.material === "gold" ? "preview-gold" : "preview-silver";

      return html`
        <div class="preview-display ${shapeClass} ${materialClass}">
          <div class="preview-shape">
            ${selectedCustomization
              ? html`
                  <img
                    src="${selectedCustomization.image}"
                    alt="${selectedCustomization.name}"
                    style="max-width: 80%; max-height: 80%; object-fit: contain; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                  />
                `
              : ""}
          </div>
          <div class="preview-label">${preview.name}</div>
          ${selectedCustomization
            ? html`<div class="preview-customization-name">
                ${selectedCustomization.name}
              </div>`
            : ""}
        </div>
      `;
    }
  }

  _removeTab(index) {
    // Index is 1-based relative to tabs array (since 0 is Main)
    // Actually let's keep tabs array just for addons to keep it simple.
    // So index 0 in tabs array is Tab 1 in UI (after Main).
    
    // Don't allow removing initial addons (non-removable)
    const tab = this.tabs[index];
    if (tab && tab.isInitial) {

      return;
    }
    
    // Track addon removed before removing
    if (tab) {
      this._trackEvent('customizer_addon_removed', {
        productTitle: this.productTitle,
        addonTitle: tab.productTitle || 'unknown',
        addonType: tab.customizationType || 'unknown',
        totalAddonsBefore: this.tabs.length
      });
    }
    
    const newTabs = [...this.tabs];
    newTabs.splice(index, 1);
    this.tabs = newTabs;

    // Adjust active tab if needed
    if (this.activeTab > this.tabs.length) {
      this.activeTab = this.tabs.length;
    }
    // Update overlay if open
    if (this.isOpen && this._overlayElement) {
      this._updateOverlayContent();
    }
  }

  _calculateTotal() {
    let total = this.selectedVariantPrice || 0;

    // Add price of all active addon tabs (EXCLUDE initial addons - they're included in base price)
    this.tabs.forEach((tab) => {
      if (!tab.isInitial) {
        total += tab.price;
      }
    });

    // Add gift wrap price if enabled (will be fetched from product)
    if (this.giftWrapEnabled && this.giftWrapEnable && this.giftWrapProductId && this._giftWrapPrice) {
      total += this._giftWrapPrice;
    }

    return total;
  }

  _updatePriceDisplay() {
    // Update only the price display without re-rendering the entire overlay
    if (!this._overlayElement) return;
    
    const totalPrice = this._calculateTotal();
    const formattedPrice = (totalPrice / 100).toFixed(2);
    const priceElement = this._overlayElement.querySelector('.btn-price');
    if (priceElement) {
      priceElement.textContent = `$${formattedPrice}`;
    }
  }

  _ensureFirstFontSelected(isMain) {
    // Helper method to ensure first font is selected for Initial/Name types
    const typeFilterLower = (this.typeFilter || "").toLowerCase();
    const isInitialOrName = typeFilterLower === "initial" || typeFilterLower === "initials" || typeFilterLower === "name";
    
    if (!isInitialOrName) return;
    
    const mainSelection = this.selections?.main;
    if (isMain && (!mainSelection || !mainSelection.name)) {
      // Get available options for the current type using the same method as rendering
      let options = this._getFilteredOptions();
      
      // Filter by typeFilter if it exists
      if (this.typeFilter && options) {
        options = options.filter((opt) => {
          const optType = (opt.type || "").toLowerCase().trim();
          const filterType = (this.typeFilter || "").toLowerCase().trim();
          return optType === filterType;
        });
      }
      
      // For Initial/Name types, extract font types (Font 1, Font 2, etc.)
      if (options && options.length > 0) {
        const fontTypesMap = new Map();
        options.forEach((option) => {
          const name = (option.name || "").trim();
          const fontMatch = name.match(/^(Font\s+\d+)/i);
          if (fontMatch) {
            const fontType = fontMatch[1];
            if (!fontTypesMap.has(fontType)) {
              fontTypesMap.set(fontType, option);
            }
          }
        });
        
        // Get the first font type
        const firstFontOption = fontTypesMap.size > 0 
          ? Array.from(fontTypesMap.values())[0]
          : options[0];
        
        if (firstFontOption) {
          if (!this.selections) this.selections = {};
          // Don't overwrite Family Birth Flower Bouquet array selections
          if (this._isFamilyBirthFlowerBouquet() && Array.isArray(this.selections.main)) {
            // Skip auto-select for Family Birth Flower Bouquet
            return;
          }
          this.selections.main = {
            id: firstFontOption.id,
            image: firstFontOption.image,
            name: firstFontOption.name,
            value: firstFontOption.name,
            type: firstFontOption.type,
            fontFamily: firstFontOption.fontFamily || null,
          };
        }
      }
    }
  }

  _ensureFirstFontSelectedForTab(tab) {
    // Helper method to ensure first font is selected for Initial/Name types in addon tabs
    if (!tab) return;
    
    const tabCustomizationType = (tab?.customizationType || "").toLowerCase();
    const isInitialOrName = tabCustomizationType === "initial" || tabCustomizationType === "initials" || tabCustomizationType === "name";
    
    if (!isInitialOrName) return;
    
    if (!tab.selectedSymbol || !tab.selectedSymbol.name) {
      // Get available options from tab customizations
      const options = tab.customizations || [];
      
      // For Initial/Name types, extract font types (Font 1, Font 2, etc.)
      if (options && options.length > 0) {
        const fontTypesMap = new Map();
        options.forEach((option) => {
          const name = (option.name || "").trim();
          const fontMatch = name.match(/^(Font\s+\d+)/i);
          if (fontMatch) {
            const fontType = fontMatch[1];
            if (!fontTypesMap.has(fontType)) {
              fontTypesMap.set(fontType, option);
            }
          }
        });
        
        // Get the first font type
        const firstFontOption = fontTypesMap.size > 0 
          ? Array.from(fontTypesMap.values())[0]
          : options[0];
        
        if (firstFontOption) {
          tab.selectedSymbol = {
            id: firstFontOption.id,
            image: firstFontOption.image,
            name: firstFontOption.name,
            value: firstFontOption.name,
            type: firstFontOption.type,
            fontFamily: firstFontOption.fontFamily || null,
          };
        }
      }
    }
  }

  _hasAllSelections() {
    // Check if this is Birth Flower Bouquet and requires email
    if (this._isBirthFlowerBouquet()) {
      const email = (this.proofEmail || '').trim();
      if (!email) {
        // Show error message
        if (this._overlayElement) {
          const emailInput = this._overlayElement.querySelector('.customizer__proof-email-input');
          const errorElement = this._overlayElement.querySelector('.customizer__proof-email-error');
          if (emailInput && errorElement) {
            errorElement.textContent = this._getTranslation('proof_email_required', 'Email is required');
            errorElement.style.display = 'block';
            emailInput.style.borderColor = '#d32f2f';
          }
        }
        return false;
      }
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        // Show error message
        if (this._overlayElement) {
          const emailInput = this._overlayElement.querySelector('.customizer__proof-email-input');
          const errorElement = this._overlayElement.querySelector('.customizer__proof-email-error');
          if (emailInput && errorElement) {
            errorElement.textContent = this._getTranslation('proof_email_invalid', 'Please enter a valid email address');
            errorElement.style.display = 'block';
            emailInput.style.borderColor = '#d32f2f';
          }
        }
        return false;
      }
      // Clear error if email is valid
      if (this._overlayElement) {
        const emailInput = this._overlayElement.querySelector('.customizer__proof-email-input');
        const errorElement = this._overlayElement.querySelector('.customizer__proof-email-error');
        if (emailInput && errorElement) {
          errorElement.style.display = 'none';
          emailInput.style.borderColor = '#ccc';
        }
      }
    }
    
    // Check if there are initial (default) addons
    const hasInitialAddons = this.tabs.some(tab => tab.isInitial);
    
    // For Initial/Name types, check if manual text is entered first
    const typeFilterLower = (this.typeFilter || "").toLowerCase();
    const isInitialOrName = typeFilterLower === "initial" || typeFilterLower === "initials" || typeFilterLower === "name";
    
    // Check if main product has a selection (regardless of initial addons)
    const mainSelection = this.selections?.main;
    
    // Only check main product for Initial/Name manual text if there are NO initial addons
    // When there are initial addons, the main product doesn't need manual text - only addon tabs do
    if (isInitialOrName && !hasInitialAddons) {
      // For Initial/Name types without initial addons, check manual text first
      const manualText = this._mainManualText || "";
      if (!manualText || !manualText.trim()) {
        // No text entered yet
        return false;
      }
      
      // If manual text exists, try to ensure a font is selected (auto-select first if needed)
      this._ensureFirstFontSelected(true);
      
      // For Initial/Name types, text existence is sufficient
      // Font will be auto-selected when options render if not already selected
      // Continue to check addon tabs below
    } else if (!hasInitialAddons) {
      // For non-Initial/Name types without initial addons, main selection is required
      if (!mainSelection) {
        return false;
      }
      
      // For Family Birth Flower Bouquet, check if array has at least one selection
      if (Array.isArray(mainSelection)) {
        if (mainSelection.length === 0) {
          return false;
        }
      } else if (!mainSelection.name) {
        return false;
      }
    }

    // Check if all addon tabs have selections
    if (this.tabs.length > 0) {
      for (const tab of this.tabs) {
        // For Initial/Name types in tabs, check manual text first
        const tabCustomizationType = (tab?.customizationType || "").toLowerCase();
        const isTabInitialOrName = tabCustomizationType === "initial" || tabCustomizationType === "initials" || tabCustomizationType === "name";
        
        if (isTabInitialOrName) {
          const manualText = tab.manualText || "";
          if (!manualText || !manualText.trim()) {
            // No text entered yet for this Initial/Name tab
            return false;
          }
          
          // If manual text exists, ensure a font is selected (auto-select first if needed)
          if (!tab.selectedSymbol || !tab.selectedSymbol.name) {
            // Auto-select first font for this addon tab
            this._ensureFirstFontSelectedForTab(tab);
            // Re-check after auto-selection
            if (!tab.selectedSymbol || !tab.selectedSymbol.name) {
              // Still allow it - font will be selected when options render
            }
          }
          
          // For Initial/Name types with text, that's sufficient (font will be auto-selected)
          // Continue to next tab
          continue;
        }
        
        // For non-Initial/Name tabs, check if selection exists
        if (!tab.selectedSymbol) {
          return false;
        }
        // For Family Birth Flower Bouquet, check if array has at least one selection
        if (Array.isArray(tab.selectedSymbol)) {
          if (tab.selectedSymbol.length === 0) {
            return false;
          }
        } else if (!tab.selectedSymbol.name) {
          return false;
        }
      }
    }

    return true;
  }

  async _addToCart() {
    if (this.isAddingToCart) return;
    if (!this._hasAllSelections()) return;
    this.isAddingToCart = true;

    const items = [];
    const hasAddons = this.tabs && this.tabs.length > 0;
    const hasInitialAddons = hasAddons && this.tabs.some(tab => tab.isInitial);
    const hasAdditionalAddons = hasAddons && this.tabs.some(tab => !tab.isInitial);
    const hasGiftWrap = this.giftWrapEnabled && this.giftWrapEnable && this.giftWrapProductId;
    // Create bundle ID only if there are additional (non-initial) addons OR gift wrap
    // Initial addons are added as properties, not separate products (no price increase)
    const bundleId = (hasAdditionalAddons || hasGiftWrap) ? Date.now().toString() : null;
    const productGroupId = (hasAdditionalAddons || hasGiftWrap) ? `PG-${bundleId}` : null; // Visible product group ID

    // 1. Add main product
    if (this.selectedVariantId) {
      const mainProperties = {};

      // Add bundle properties only if there are additional addons OR gift wrap
      // Initial addons are added as properties, not separate products (no price increase)
      if (hasAdditionalAddons || hasGiftWrap) {
        mainProperties["_BundleId"] = bundleId;
        mainProperties["_IsMain"] = true;
        mainProperties["Product Group ID"] = productGroupId; // Visible ID to associate with addons/gift wrap
      }

      // Don't add variant options as properties - they're already shown in variant options
      // This prevents duplicate display of Finish, Chain Style, Length, etc. in checkout

      // Add main product's selected customization name and type if available
      const mainSelection = this.selections?.main;
      if (mainSelection) {
        // Handle multiple selections for Family Birth Flower Bouquet
        if (Array.isArray(mainSelection) && mainSelection.length > 0) {
          // For Family Birth Flower Bouquet, add each flower as a separate line item
          if (this._isFamilyBirthFlowerBouquet()) {
            mainSelection.forEach((sel, index) => {
              mainProperties[`Flower ${index + 1}`] = sel.name;
            });
            // Also add the type for reference
            if (mainSelection[0].type) {
              mainProperties["Customization Type"] = mainSelection[0].type;
            }
          } else {
            // For other products with multiple selections, join with comma
            const names = mainSelection.map((sel) => sel.name).join(", ");
            // Combine type and name into one property: "[Type]: [Name]"
            const type = mainSelection[0].type || 'Custom';
            mainProperties["Customization"] = `${type}: ${names}`;
          }
        } else if (mainSelection.name) {
          // Combine type and name into one property: "[Type]: [Name]"
          const type = mainSelection.type || 'Custom';
          mainProperties["Customization"] = `${type}: ${mainSelection.name}`;
          
          // For Initial or Name types, include the manual text input value
          const mainTypeLower = (mainSelection.type || '').toLowerCase();
          const isMainInitialOrName = mainTypeLower === 'initial' || 
                                     mainTypeLower === 'initials' || 
                                     mainTypeLower === 'name';
          if (isMainInitialOrName && this._mainManualText && this._mainManualText.trim()) {
            mainProperties["Customization Text"] = this._mainManualText.trim();
          }
        }
      }

      // Add special request message if enabled and has content
      if (this.specialRequestEnabled && this.specialRequestMessage && this.specialRequestMessage.trim()) {
        mainProperties["Special Request"] = this.specialRequestMessage.trim();
      }

      // Add proof email for Birth Flower Bouquet
      if (this._isBirthFlowerBouquet() && this.proofEmail && this.proofEmail.trim()) {
        mainProperties["Proof Email"] = this.proofEmail.trim();
      }

      // Note: Gift wrap will be added as a separate line item below

      // Check for custom length input and add it as a property
      // Look for the input in various locations - it might be hidden but still have a value
      let customLengthInput = null;
      
      // Get section ID from customizer element ID (format: customizer-app-{sectionId})
      const sectionId = this.id?.replace('customizer-app-', '') || '';
      
      // Try multiple selectors to find the input (supports both old and new attribute names for backward compatibility)
      const selectors = [
        `input[data-custom-option-input]`,
        `input[data-custom-length-input]`, // backward compatibility
        `input[name="properties[Custom Length]"]`,
        `input[name="properties[Custom Longueur]"]`,
        `input[name="properties[Custom Size]"]`,
        `input[name="properties[Custom Taille]"]`,
      ];
      
      // If we have section ID, try specific selectors
      if (sectionId) {
        selectors.push(`#custom-option-input-${sectionId}-${this.selectedVariantId || ''}`);
        selectors.push(`#custom-length-input-${sectionId}-${this.selectedVariantId || ''}`); // backward compatibility
        // Try with product ID if available
        const productId = document.querySelector('[data-product-id]')?.dataset?.productId;
        if (productId) {
          selectors.push(`#custom-option-input-${sectionId}-${productId}`);
          selectors.push(`#custom-length-input-${sectionId}-${productId}`); // backward compatibility
        }
      }
      
      // Try all selectors
      for (const selector of selectors) {
        try {
          customLengthInput = document.querySelector(selector);
          if (customLengthInput && customLengthInput.value) {
            break;
          }
        } catch (e) {
          // Invalid selector, continue
        }
      }
      
      // Also check inside variant picker (might be outside modal)
      if (!customLengthInput || !customLengthInput.value) {
        const variantPickers = document.querySelectorAll('block-variant-picker');
        for (const variantPicker of variantPickers) {
          customLengthInput = variantPicker.querySelector('input[data-custom-option-input]') || 
                             variantPicker.querySelector('input[data-custom-length-input]'); // backward compatibility
          if (customLengthInput && customLengthInput.value) {
            break;
          }
        }
      }
      
      // Check inside product forms
      if (!customLengthInput || !customLengthInput.value) {
        const productForms = document.querySelectorAll('form[action*="/cart/add"]');
        for (const productForm of productForms) {
          customLengthInput = productForm.querySelector('input[data-custom-option-input]') ||
                             productForm.querySelector('input[data-custom-length-input]'); // backward compatibility
          if (customLengthInput && customLengthInput.value) {
            break;
          }
        }
      }
      
      // Check all inputs with the data attribute (last resort)
      if (!customLengthInput || !customLengthInput.value) {
        const allInputs = document.querySelectorAll('input[data-custom-option-input], input[data-custom-length-input]');
        for (const input of allInputs) {
          if (input.value) {
            customLengthInput = input;
            break;
          }
        }
      }
      
      // Check for custom Length value (using new or old attribute)
      if (customLengthInput && customLengthInput.value) {
        const lengthValue = parseFloat(customLengthInput.value);
        if (!isNaN(lengthValue) && lengthValue >= 10 && lengthValue <= 30) {
          // Determine property name based on option name (English or French)
          const optionName = customLengthInput.dataset?.optionName || '';
          const propertyName = optionName.includes('Longueur') ? "Custom Longueur" : "Custom Length";
          mainProperties[propertyName] = customLengthInput.value;
        }
      } else {
        // Also check for Length inputs with the new attribute (English and French)
        const customLengthInputs = document.querySelectorAll('input[data-custom-option-input][data-option-name*="Length"], input[data-custom-option-input][data-option-name*="Longueur"]');
        for (const lengthInput of customLengthInputs) {
          if (lengthInput && lengthInput.value) {
            const lengthValue = parseFloat(lengthInput.value);
            if (!isNaN(lengthValue) && lengthValue >= 10 && lengthValue <= 30) {
              // Determine property name based on option name (English or French)
              const optionName = lengthInput.dataset?.optionName || '';
              const propertyName = optionName.includes('Longueur') ? "Custom Longueur" : "Custom Length";
              mainProperties[propertyName] = lengthInput.value;
              break;
            }
          }
        }
      }
      
      // Check for custom Size value (English and French)
      const customSizeInputs = document.querySelectorAll('input[data-custom-option-input][data-option-name="Size"], input[data-custom-option-input][data-option-name="Taille"]');
      for (const sizeInput of customSizeInputs) {
        if (sizeInput && sizeInput.value) {
          const sizeValue = parseFloat(sizeInput.value);
          if (!isNaN(sizeValue) && sizeValue >= 10 && sizeValue <= 30) {
            // Determine property name based on option name (English or French)
            const optionName = sizeInput.dataset?.optionName || '';
            const propertyName = optionName.includes('Taille') ? "Custom Taille" : "Custom Size";
            mainProperties[propertyName] = sizeInput.value;
            break;
          }
        }
      }

      items.push({
        id: this.selectedVariantId,
        quantity: 1,
        properties: mainProperties,
      });
    } else {
      this.isAddingToCart = false;
      return;
    }

    // 2. Handle addons from tabs
    if (hasAddons) {
      // Separate initial (default) addons from additional addons
      const initialAddons = this.tabs.filter(tab => tab.isInitial);
      const additionalAddons = this.tabs.filter(tab => !tab.isInitial);
      
      // Add initial addons as properties on the main product (not separate items - no price increase)
      if (initialAddons.length > 0 && items.length > 0) {
        // Collect all customizations and text values
        const customizations = [];
        const textValues = [];
        
        initialAddons.forEach((tab, index) => {
          // Check if this is an Initial or Name type that requires manual text
          const customizationTypeLower = (tab.customizationType || '').toLowerCase();
          const isInitialOrName = customizationTypeLower === 'initial' || 
                                  customizationTypeLower === 'initials' || 
                                  customizationTypeLower === 'name' ||
                                  customizationTypeLower.includes('initial');
          
          // Add selected customization name and type if available
          if (tab.selectedSymbol) {
            // Handle multiple selections for Family Birth Flower Bouquet
            if (Array.isArray(tab.selectedSymbol) && tab.selectedSymbol.length > 0) {
              // Join multiple selections with comma
              const names = tab.selectedSymbol.map((sel) => sel.name).join(", ");
              // Combine type and name into one property: "[Type]: [Name]"
              const type = tab.selectedSymbol[0].type || 'Custom';
              customizations.push(`${type}: ${names}`);
            } else if (tab.selectedSymbol.name) {
              // Combine type and name into one property: "[Type]: [Name]"
              const type = tab.selectedSymbol.type || 'Custom';
              customizations.push(`${type}: ${tab.selectedSymbol.name}`);
            }
          }
          
          // For Initial or Name types, include the manual text input value
          if (isInitialOrName && tab.manualText && tab.manualText.trim()) {
            textValues.push(tab.manualText.trim());
          }
        });
        
        // Store all customizations concatenated
        if (customizations.length > 0) {
          items[0].properties["Customization"] = customizations.join("; ");
        }
        
        // Store all text values concatenated
        if (textValues.length > 0) {
          items[0].properties["Customization Text"] = textValues.join("; ");
        }
      }
      
      // Add additional addons as separate products (these increase price)
      if (additionalAddons.length > 0) {
        // Bundle ID should already be created if we have additional addons
        // But ensure it exists (should be set above)
        const additionalBundleId = bundleId || Date.now().toString();
        const additionalProductGroupId = productGroupId || `PG-${additionalBundleId}`;
        
        // Ensure main product has bundle properties if not already set
        if (items.length > 0 && !items[0].properties._BundleId) {
          items[0].properties["_BundleId"] = additionalBundleId;
          items[0].properties["_IsMain"] = true;
          items[0].properties["Product Group ID"] = additionalProductGroupId;
        }
        
        additionalAddons.forEach((tab, index) => {
          const properties = {
            _BundleId: additionalBundleId,
            _IsAddon: true,
            "Product Group ID": additionalProductGroupId,
            "Addon Position": (initialAddons.length + index + 1).toString(), // Continue numbering after initial addons
          };

          // Add selected customization name and type if available
          if (tab.selectedSymbol) {
            // Handle multiple selections for Family Birth Flower Bouquet
            if (Array.isArray(tab.selectedSymbol) && tab.selectedSymbol.length > 0) {
              // Join multiple selections with comma
              const names = tab.selectedSymbol.map((sel) => sel.name).join(", ");
              // Combine type and name into one property: "[Type]: [Name]"
              const type = tab.selectedSymbol[0].type || 'Custom';
              properties["Customization"] = `${type}: ${names}`;
            } else if (tab.selectedSymbol.name) {
              // Combine type and name into one property: "[Type]: [Name]"
              const type = tab.selectedSymbol.type || 'Custom';
              properties["Customization"] = `${type}: ${tab.selectedSymbol.name}`;
            }
          }

          // For Initial or Name types, include the manual text input value
          const customizationTypeLower = (tab.customizationType || '').toLowerCase();
          const isInitialOrName = customizationTypeLower === 'initial' || 
                                  customizationTypeLower === 'initials' || 
                                  customizationTypeLower === 'name' ||
                                  customizationTypeLower.includes('initial');
          if (isInitialOrName && tab.manualText && tab.manualText.trim()) {
            properties["Customization Text"] = tab.manualText.trim();
          }

          items.push({
            id: tab.variantId,
            quantity: 1,
            properties: properties,
          });
        });
      }
    }

    // 3. Add gift wrap as a separate line item if enabled (always bundled with main product)
    if (this.giftWrapEnabled && this.giftWrapEnable && this.giftWrapProductId) {
      // Convert variant ID to number if it's a string
      const giftWrapVariantId = typeof this.giftWrapProductId === 'string' 
        ? parseInt(this.giftWrapProductId.trim(), 10) 
        : this.giftWrapProductId;
      
      // Only add if we have a valid variant ID and it's available
      if (giftWrapVariantId && !isNaN(giftWrapVariantId)) {
        // Check availability (warn but still try to add - let Shopify handle the final check)
        if (this._giftWrapAvailable === false) {

        }
        
        const giftWrapProperties = {};
        
        // Always bundle gift wrap with main product (bundleId should exist if gift wrap is enabled)
        if (bundleId) {
          giftWrapProperties["_BundleId"] = bundleId;
          giftWrapProperties["Product Group ID"] = productGroupId;
        }
        giftWrapProperties["_IsGiftWrap"] = true;
        giftWrapProperties["_IsAddon"] = true; // Treat gift wrap like an addon for bundling
        giftWrapProperties["Gift Wrap For"] = this.productTitle || "Product";
        
        items.push({
          id: giftWrapVariantId,
          quantity: 1,
          properties: giftWrapProperties,
        });
      } else {

      }
    }

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });

      if (response.ok) {
        const result = await response.json();

        // Verify items were added correctly
        return fetch(window.Shopify.routes.root + "cart.js").then(() => {
          // Track successful add to cart
          this._trackEvent('customizer_add_to_cart_success', {
            productTitle: this.productTitle,
            variantId: this.selectedVariantId,
            tabsCount: this.tabs ? this.tabs.length : 0,
            hasMainSelection: !!this.selections?.main,
            hasSpecialRequest: this.specialRequestEnabled && this.specialRequestMessage,
            hasGiftWrap: this.giftWrapEnabled,
            totalPrice: this._calculateTotal(),
            itemsCount: items.length
          });
          
          // Reset state before closing
          this._reset();
          // Explicitly close modal and restore scroll
          this._closeModal();
          
          // Aggressively restore scroll - use removeProperty which is more effective than setting to ""
          const restoreScroll = () => {
            // Remove lock-scroll class from html element (this is what cart drawer uses)
            document.documentElement.classList.remove('lock-scroll');
            
            // Remove overflow from body
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('overflow-x');
            document.body.style.removeProperty('overflow-y');
            
            // Also remove from html element (documentElement) - cart drawer might set it there
            document.documentElement.style.removeProperty('overflow');
            document.documentElement.style.removeProperty('overflow-x');
            document.documentElement.style.removeProperty('overflow-y');
            
            // Check computed styles and force if needed
            const bodyOverflow = window.getComputedStyle(document.body).overflow;
            const htmlOverflow = window.getComputedStyle(document.documentElement).overflow;
            
            if (bodyOverflow === 'hidden') {
              document.body.style.setProperty('overflow', 'auto', 'important');
            }
            if (htmlOverflow === 'hidden') {
              document.documentElement.style.setProperty('overflow', 'auto', 'important');
            }
            
            // Force reflow to ensure styles are applied
            void document.body.offsetHeight;
          };
          
          // Restore immediately
          restoreScroll();
          
          // Restore at multiple intervals to catch any cart drawer interference
          setTimeout(restoreScroll, 50);
          setTimeout(restoreScroll, 200);
          setTimeout(restoreScroll, 500);
          setTimeout(restoreScroll, 1000);
          setTimeout(restoreScroll, 2000);
          
          // Watch for overflow changes and restore if set to hidden
          let observerTimeout;
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                const overflow = window.getComputedStyle(document.body).overflow;
                if (overflow === 'hidden') {
                  clearTimeout(observerTimeout);
                  observerTimeout = setTimeout(() => {
                    restoreScroll();
                  }, 50);
                }
              }
            });
          });
          
          observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['style']
          });
          
          // Listen for cart drawer close events - multiple event types
          const cartScrollRestore = () => {
            restoreScroll();
            observer.disconnect();
            // Remove all listeners
            document.removeEventListener('cart:close', cartScrollRestore);
            document.removeEventListener('CartDrawer:close', cartScrollRestore);
            document.removeEventListener('headerDrawer:closed', cartScrollRestore);
            document.removeEventListener('drawerClose', cartScrollRestore);
          };
          
          // Listen for multiple cart drawer close event types
          document.addEventListener('cart:close', cartScrollRestore);
          document.addEventListener('CartDrawer:close', cartScrollRestore);
          document.addEventListener('headerDrawer:closed', cartScrollRestore);
          document.addEventListener('drawerClose', cartScrollRestore);
          
          // Stop observing after 10 seconds
          setTimeout(() => {
            observer.disconnect();
            cartScrollRestore(); // Final restoration attempt
          }, 10000);
          
          document.dispatchEvent(new CustomEvent("cart:build"));
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.dispatchEvent(new CustomEvent("cart:open"));
        }).catch((error) => {
          // Ensure scroll is restored even on error
          this._closeModal();
          document.body.style.removeProperty('overflow');
          document.body.style.removeProperty('overflow-x');
          document.body.style.removeProperty('overflow-y');
          setTimeout(() => {
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('overflow-x');
            document.body.style.removeProperty('overflow-y');
          }, 100);

        });
      } else {
        let errorData;
        try {
          errorData = await response.json();
        } catch (e) {
          errorData = { status: response.status, statusText: response.statusText };
        }

        // Provide more helpful error messages
        let errorMessage = errorData.description || errorData.message || errorData.error || `Failed to add to cart (Status: ${response.status}). Please try again.`;
        
        // Check if it's a gift wrap sold out error
        if (errorMessage.includes('sold out') && (errorMessage.includes('Gift wrapping') || errorMessage.includes('Gift wrap'))) {
          errorMessage = 'Gift wrap is currently unavailable. This may be due to inventory settings. Please try again without gift wrap, or contact us for assistance.';

        }
        
        // Track add to cart error
        this._trackEvent('customizer_add_to_cart_error', {
          productTitle: this.productTitle,
          variantId: this.selectedVariantId,
          errorMessage: errorMessage,
          status: response.status
        });
        
        alert(errorMessage);
        // Ensure scroll is restored on error
        this._closeModal();
      }
    } catch (error) {
      // Track add to cart exception
      this._trackEvent('customizer_add_to_cart_exception', {
        productTitle: this.productTitle,
        variantId: this.selectedVariantId,
        error: error?.message || 'Unknown error'
      });

      alert("An error occurred. Please try again.");
      // Ensure scroll is restored on error
      this._closeModal();
    } finally {
      this.isAddingToCart = false;
      // Final safety check - ensure scroll is always restored
      if (!this.isOpen) {
        document.body.style.overflow = "";
      }
    }
  }

  updated(changedProperties) {
    // Initialize gift wrap from attributes if available
    if (changedProperties.has('giftWrapEnable')) {
      // Convert string attribute to boolean
      if (typeof this.giftWrapEnable === 'string') {
        this.giftWrapEnable = this.giftWrapEnable.toLowerCase() === 'true';
      } else if (this.giftWrapEnable === null || this.giftWrapEnable === undefined) {
        this.giftWrapEnable = false;
      }
    }
    if (changedProperties.has('giftWrapProductId') || changedProperties.has('giftWrapEnable')) {
      // Fetch gift wrap product price when product ID is set and feature is enabled
      if (this.giftWrapProductId && this.giftWrapEnable) {
        this._fetchGiftWrapPrice();
      } else {
        this._giftWrapPrice = 0;
      }
    }
    if (changedProperties.has('giftWrapLabel')) {
      // Ensure label is a string
      if (this.giftWrapLabel === null || this.giftWrapLabel === undefined) {
        this.giftWrapLabel = 'Add gift wrap';
      }
    }
    
    // Update addon preview images when finish changes
    if (changedProperties.has('selectedOption1')) {
      // Update addon variants first (variantId, variantTitle, price)
      this._updateAddonVariantsForFinish();
      // Then update preview images
      this._updateAddonPreviewImagesForFinish();
      // Force a full re-render to ensure options are properly filtered
      this.requestUpdate();
      // Update overlay to refresh options with finish filtering
      if (this.isOpen && this._overlayElement) {
        // Small delay to ensure state is updated before rendering
        setTimeout(() => {
          this._updateOverlayContent();
        }, 0);
      }
    }
    
    // Update overlay content when state changes, but exclude specialRequestMessage and proofEmail
    // to prevent re-rendering while user is typing
    if (this._overlayElement && this.isOpen) {
      // If only specialRequestMessage changed, update textarea directly without full re-render
      if (changedProperties.has('specialRequestMessage') && changedProperties.size === 1) {
        const textarea = this._overlayElement.querySelector('.customizer__special-request-textarea');
        if (textarea && textarea.value !== this.specialRequestMessage) {
          textarea.value = this.specialRequestMessage || '';
        }
        // Also update price if gift wrap is enabled (since price might change)
        this._updatePriceDisplay();
      } else if (changedProperties.has('proofEmail') && changedProperties.size === 1) {
        // If only proofEmail changed, update input directly without full re-render
        const emailInput = this._overlayElement.querySelector('.customizer__proof-email-input');
        if (emailInput && emailInput.value !== this.proofEmail) {
          emailInput.value = this.proofEmail || '';
        }
        // Update button state without showing validation errors (just check if email is valid format)
        const addToCartButton = this._overlayElement.querySelector('.customizer__add-cart');
        if (addToCartButton && this._isBirthFlowerBouquet()) {
          const email = (this.proofEmail || '').trim();
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const isEmailValid = email && emailRegex.test(email);
          const hasOtherSelections = this._hasAllSelectionsExceptEmail();
          
          if (hasOtherSelections && isEmailValid) {
            addToCartButton.removeAttribute('disabled');
          } else {
            addToCartButton.setAttribute('disabled', '');
          }
        }
      } else {
        // For other state changes, do full re-render
        this._updateOverlayContent();
      }
    }
  }

  async _fetchGiftWrapPrice() {
    if (!this.giftWrapProductId) return;
    
    // Convert variant ID to number if it's a string
    const variantId = typeof this.giftWrapProductId === 'string' 
      ? parseInt(this.giftWrapProductId.trim(), 10) 
      : this.giftWrapProductId;
    
    if (!variantId || isNaN(variantId)) {

      this._giftWrapPrice = 0;
      this._giftWrapAvailable = false;
      return;
    }
    
    try {
      // Fetch variant data from Shopify
      const response = await fetch(`${window.Shopify.routes.root}variants/${variantId}.js`);
      if (response.ok) {
        const variant = await response.json();
        this._giftWrapPrice = variant.price || 0;
        this._giftWrapAvailable = variant.available !== false;
        
        // Warn if variant is not available
        if (!this._giftWrapAvailable) {

        }
        
        // Update UI if overlay is open
        if (this._overlayElement && this.isOpen) {
          this._updateOverlayContent();
        }
      } else {
        const errorData = await response.json().catch(() => ({}));

        this._giftWrapPrice = 0;
        this._giftWrapAvailable = false;
      }
    } catch (error) {

      this._giftWrapPrice = 0;
      this._giftWrapAvailable = false;
    }
  }

  firstUpdated() {
    // Expose component instance to window for inline event handlers
    window.customizerApp = this;
    
    // Fetch gift wrap price when component is first updated
    if (this.giftWrapProductId && this.giftWrapEnable) {
      this._fetchGiftWrapPrice();
    }
  }

  /**
   * Normalize finish value to standard format (handles both English and French)
   * Returns "gold", "silver", or null (all lowercase for comparison)
   */
  _normalizeFinish(finishValue) {
    if (!finishValue) return null;
    const finish = String(finishValue).trim();
    const finishLower = finish.toLowerCase();
    
    // Check for English
    if (finishLower.includes('gold')) return 'gold';
    if (finishLower.includes('silver')) return 'silver';
    
    // Check for French
    if (finishLower.includes('or')) return 'gold'; // "Or" = Gold
    if (finishLower.includes('argent')) return 'silver'; // "Argent" = Silver
    
    return null;
  }

  /**
   * Get the finish type from selectedOption1 (Gold/Or or Silver/Argent)
   * Returns "Gold", "Silver", or null
   */
  _getMainProductFinishType() {
    if (!this.selectedOption1) return null;
    const normalized = this._normalizeFinish(this.selectedOption1);
    if (normalized === 'gold') return 'Gold';
    if (normalized === 'silver') return 'Silver';
    return null;
  }

  /**
   * Find customization image that matches the main product's finish
   * The finish field in customizations is "Gold"/"Or" or "Silver"/"Argent" or blank
   * Checks if finish field matches (handles both English and French)
   */
  _getMatchingFinishImage(selectedCustomization, availableCustomizations) {
    if (!selectedCustomization || !availableCustomizations) {
      return selectedCustomization?.image || null;
    }

    const mainFinishNormalized = this._normalizeFinish(this.selectedOption1);
    if (!mainFinishNormalized) {
      // No finish selected, use original image
      return selectedCustomization.image || null;
    }

    const selectedId = selectedCustomization.id || selectedCustomization.name;
    const selectedName = selectedCustomization.name;

    // First try to find by ID and finish matches (normalized)
    const idMatch = availableCustomizations.find((c) => {
      const idMatches = (c.id === selectedId || c.name === selectedId);
      if (!idMatches) return false;
      // Check if finish field matches (normalized comparison handles both English and French)
      // Handle null, undefined, empty string, or actual values
      if (c.finish && c.finish !== null && c.finish !== 'null' && String(c.finish).trim() !== '') {
        const customizationFinishNormalized = this._normalizeFinish(c.finish);
        return customizationFinishNormalized === mainFinishNormalized;
      }
      return false;
    });

    if (idMatch && idMatch.image) {

      return idMatch.image;
    }

    // Fallback: find by name and finish matches (normalized)
    const nameMatch = availableCustomizations.find((c) => {
      const nameMatches = (c.name === selectedName);
      if (!nameMatches) return false;
      // Check if finish field matches (normalized comparison handles both English and French)
      // Handle null, undefined, empty string, or actual values
      if (c.finish && c.finish !== null && c.finish !== 'null' && String(c.finish).trim() !== '') {
        const customizationFinishNormalized = this._normalizeFinish(c.finish);
        return customizationFinishNormalized === mainFinishNormalized;
      }
      return false;
    });

    if (nameMatch && nameMatch.image) {

      return nameMatch.image;
    }

    // No match found, return original image

    return selectedCustomization.image || null;
  }

  /**
   * Update addon variants (variantId, variantTitle, price) based on the selected finish
   * This ensures addons match the main product's finish when it changes
   */
  _updateAddonVariantsForFinish() {
    if (!this.selectedOption1) {
      return;
    }
    
    // If no tabs yet, nothing to update
    if (!this.tabs || this.tabs.length === 0) {
      return;
    }

    const parsedAddons = this._parseAddonData();
    if (!parsedAddons || parsedAddons.length === 0) {
      return;
    }

    const mainProductFinishNormalized = this._normalizeFinish(this.selectedOption1);
    let updated = false;

    // Update each addon tab
    this.tabs.forEach((tab, index) => {
      if (tab.type !== 'addon' || !tab.productTitle) {
        return;
      }

      // Find the product by title
      const product = parsedAddons.find(
        (p) => p.title && p.title.trim() === tab.productTitle.trim()
      );

      if (!product || !product.variants || product.variants.length === 0) {
        return;
      }

      // Filter variants by main product's finish - use normalized comparison (handles English and French)
      let filteredVariants = [];
      if (mainProductFinishNormalized) {
        filteredVariants = product.variants.filter((v) => {
          if (!v.option1) return false;
          const variantFinishNormalized = this._normalizeFinish(v.option1);
          return variantFinishNormalized === mainProductFinishNormalized;
        });

        // If no exact match, try partial matching (e.g., "Gold Filled" matches "Gold", "Or" matches "Gold")
        if (filteredVariants.length === 0) {
          filteredVariants = product.variants.filter((v) => {
            if (!v.option1) return false;
            const variantFinishNormalized = this._normalizeFinish(v.option1);
            // Check if normalized finishes match
            return variantFinishNormalized === mainProductFinishNormalized;
          });
        }
      } else {
        // If no finish selected, use all variants
        filteredVariants = product.variants;
      }

      if (filteredVariants.length === 0) {
        // Fallback: try to find any available variant
        filteredVariants = product.variants;
      }

      // Get the first available variant
      const newVariant =
        filteredVariants.find((v) => v.available !== false) ||
        filteredVariants[0];

      if (newVariant && newVariant.id !== tab.variantId) {

        // Update the tab with new variant information
        this.tabs[index] = {
          ...tab,
          variantId: newVariant.id,
          variantTitle: newVariant.title,
          price: newVariant.price
        };
        updated = true;
      }
    });

    if (updated) {
      // Trigger re-render
      this.requestUpdate();
      if (this.isOpen && this._overlayElement) {
        this._updateOverlayContent();
      }
    }
  }

  /**
   * Update addon preview images based on the selected finish
   * Finds customizations with matching finish and updates the preview image
   */
  _updateAddonPreviewImagesForFinish() {
    if (!this.selectedOption1) {
      return;
    }
    
    // If no tabs yet, the preview will be updated when tabs are created
    if (!this.tabs || this.tabs.length === 0) {

      return;
    }

    const mainFinish = this._getMainProductFinishType();

    // Update each addon tab
    this.tabs.forEach((tab, index) => {
      if (!tab.customizations || tab.customizations.length === 0) {
        return;
      }

      // If there's a selected symbol, find matching image based on finish
      if (tab.selectedSymbol) {
        const matchingImage = this._getMatchingFinishImage(tab.selectedSymbol, tab.customizations);
        
        if (matchingImage && matchingImage !== (Array.isArray(tab.selectedSymbol) ? tab.selectedSymbol[0]?.image : tab.selectedSymbol.image)) {

          // Update the selected symbol's image
          if (Array.isArray(tab.selectedSymbol)) {
            // Multiple selections - update all of them
            tab.selectedSymbol = tab.selectedSymbol.map(symbol => ({
              ...symbol,
              image: this._getMatchingFinishImage(symbol, tab.customizations) || symbol.image
            }));
          } else {
            // Single selection
            tab.selectedSymbol = {
              ...tab.selectedSymbol,
              image: matchingImage
            };
          }
          
          // Update the tab in the array
          this.tabs = this.tabs.map((t, idx) => 
            idx === index ? { ...tab } : t
          );
        }
      }
    });

    // Trigger re-render if overlay is open
    if (this._overlayElement && this.isOpen) {
      this._updateOverlayContent();
    } else {
      this.requestUpdate();
    }
  }

  disconnectedCallback() {
    // Clean up window reference
    if (window.customizerApp === this) {
      window.customizerApp = null;
    }
    
    // Clean up overlay when component is removed
    if (this._overlayElement) {
      if (this._overlayClickHandler) {
        this._overlayElement.removeEventListener(
          "click",
          this._overlayClickHandler
        );
        this._overlayClickHandler = null;
      }
      if (this._overlayElement.parentNode) {
        this._overlayElement.parentNode.removeChild(this._overlayElement);
      }
      this._overlayElement = null;
    }
    super.disconnectedCallback();
  }

  _renderPreviewCircle(previewId, isActive = false) {
    const previewIdStr = String(previewId);
    const isMain = previewIdStr === "main";
    let previewData = null;

    if (isMain) {
      const previewType = this._getCurrentPreview();
      const selection = this._getSelectionForPreview("main");
      previewData = { id: "main", type: previewType, selection };
    } else {
      // Find tab by matching preview ID
      const tab = this.tabs.find((t) => {
        const tabPreviewId = `preview-${t.id}`;
        return tabPreviewId === previewIdStr;
      });
      if (tab) {
        const selection = tab.selectedSymbol;
        previewData = {
          id: previewIdStr,
          type: tab.selectedPreview,
          selection,
          tab,
        };
      }
    }

    if (!previewData) {
      return html``;
    }

    const selection = previewData.selection;
    const previewType = isMain ? this._getCurrentPreview() : previewData.type;
    const preview =
      Object.values(PREVIEW_OPTIONS).find((opt) => opt.id === previewType) ||
      PREVIEW_OPTIONS.GOLD_CIRCLE;

    // Check if this is Initial/Name type and has manual text
    const tab = previewData.tab;
    const typeFilterLower = (this.typeFilter || "").toLowerCase();
    const tabCustomizationType = (tab?.customizationType || "").toLowerCase();
    const isInitialOrName = isMain ? (
      typeFilterLower === "initial" || 
      typeFilterLower === "initials" || 
      typeFilterLower === "name"
    ) : tab && (
      tabCustomizationType === "initial" ||
      tabCustomizationType === "initials" ||
      tabCustomizationType === "name"
    );
    const manualText = tab?.manualText || (isMain && this._mainManualText ? this._mainManualText : "");
    // Get selected font type (e.g., "Font 1", "Font 2") from selection
    const selectedFontType = selection?.name || selection?.fontFamily || "";

    // If we have a font type and manual text, find the specific letter image
    let displayImage = null;
    if (isInitialOrName && manualText && selectedFontType) {
      // Find the specific letter option for this font type and letter
      const letter = manualText.charAt(0).toUpperCase();
      
      // Get original options (before font type extraction)
      let allOptions = [];
      if (tab && tab._originalFontOptions) {
        allOptions = tab._originalFontOptions;
      } else if (tab && tab.customizations) {
        allOptions = tab.customizations;
      } else if (isMain && this._mainFontOptions && this._mainFontOptions[this.typeFilter]) {
        allOptions = this._mainFontOptions[this.typeFilter];
      }

      // Look for option like "Font 1 A" when fontType is "Font 1" and letter is "A"
      const letterOption = allOptions.find(opt => {
        const optName = (opt.name || "").toLowerCase().trim();
        const fontType = (selectedFontType || "").toLowerCase().trim();
        const letterLower = letter.toLowerCase();
        // Match pattern: "font 1 a" when selectedFontType is "font 1" and letter is "A"
        const matches = optName === `${fontType} ${letterLower}`;
        if (matches) {

        }
        return matches;
      });
      
      if (letterOption && letterOption.image) {
        displayImage = letterOption.image;
        // Fix image URL
        if (displayImage.startsWith("//")) {
          displayImage = `https:${displayImage}`;
        } else if (displayImage.startsWith("/")) {
          const shopDomain = window.Shopify?.shop || window.location.hostname;
          const protocol = window.location.protocol;
          displayImage = `${protocol}//${shopDomain}${displayImage}`;
        } else if (!displayImage.startsWith("http://") && !displayImage.startsWith("https://")) {
          const shopDomain = window.Shopify?.shop || window.location.hostname;
          const protocol = window.location.protocol;
          displayImage = `${protocol}//${shopDomain}/${displayImage}`;
        }

      } else {
        // No matching options
      }
    } else {

    }

    return html`
      <div
        class="preview-circle ${isMain ? "main-preview" : ""} ${isActive
          ? "active"
          : ""}"
        data-preview-id="${previewIdStr}"
        @click="${() => {
          this._switchPreview(previewIdStr);
        }}"
      >
        <div
          class="preview-image ${preview.id === PREVIEW_OPTIONS.BIRTHSTONE.id
            ? "birthstone-preview"
            : ""}"
        >
          ${isInitialOrName && manualText && displayImage
            ? html` 
                <img src="${displayImage}" alt="${manualText}" style="max-width: 80%; max-height: 80%; object-fit: contain;" />
              `
            : isInitialOrName && manualText
            ? html` 
                <span class="preview-text" style="font-size: 2rem; display: block;">
                  ${manualText}
                </span> 
              `
            : selection && selection.image
            ? html` <img src="${selection.image}" alt="${selection.name}" /> `
            : preview.id === PREVIEW_OPTIONS.BIRTHSTONE.id
            ? (() => {
                // Check if it's a heart birthstone
                const customizationTypeLower = tabCustomizationType || typeFilterLower;
                const isHeartBirthstone = customizationTypeLower.includes("heart");
                
                // IF IT'S A HEART BIRTHSTONE, GET FIRST OPTION
                let firstOption = null;
                if (isHeartBirthstone && (!selection || !selection.image)) {
                  let availableCustomizations = [];
                  if (!isMain && tab && tab.customizations) {
                    availableCustomizations = tab.customizations.filter(c => 
                      c.type && c.type.toLowerCase() === customizationTypeLower
                    );
                  } else if (isMain) {
                    const allCustomizations = window.allCustomizationsMetaobjects || [];
                    availableCustomizations = allCustomizations.filter(c => 
                      c.type && c.type.toLowerCase() === customizationTypeLower
                    );
                  }
                  if (availableCustomizations.length > 0) {
                    firstOption = availableCustomizations[0];
                    if (!isMain && tab && tab.customizations) {
                      const matchingImage = this._getMatchingFinishImage(firstOption, tab.customizations);
                      if (matchingImage) {
                        firstOption = { ...firstOption, image: matchingImage };
                      }
                    } else if (isMain) {
                      const allCustomizations = window.allCustomizationsMetaobjects || [];
                      const matchingImage = this._getMatchingFinishImage(firstOption, allCustomizations);
                      if (matchingImage) {
                        firstOption = { ...firstOption, image: matchingImage };
                      }
                    }
                  }
                }
                
                return firstOption && firstOption.image
                  ? html` <img src="${firstOption.image}" alt="${firstOption.name || ''}" /> `
                  : html``;
              })()
            : html` <span class="preview-text">${preview.name}</span> `}
        </div>
        ${!isMain && previewData.tab && !previewData.tab.isInitial
          ? html`
              <button
                class="preview-remove"
                @click="${(e) => {
                  e.stopPropagation();
                  this._removeTab(
                    this.tabs.findIndex((t) => t.id === previewData.tab.id)
                  );
                }}"
              >
                &times;
              </button>
            `
          : ""}
      </div>
    `;
  }

  _renderTypeTabs() {
    const activePreviewId = this._getActivePreviewId();
    const isMain = activePreviewId === "main";

    // Only hide type tabs for the "add new" view
    if (activePreviewId === "add-new") {
      return html``;
    }

    const types = this._getAvailableTypes();

    // If no types available, don't show tabs
    if (!types || types.length === 0) {
      return html``;
    }
    
    // Hide tabs wrapper if there's only one type (no need for tabs)
    if (types.length === 1) {
      return html``;
    }

    // If typeFilter is null, set it to the first type
    if (!this.typeFilter && types.length > 0) {
      this.typeFilter = types[0];
    }

    return html`
      <div class="customizer__type-tabs-wrapper">
        <div class="customizer__type-tabs">
          ${types.map((type) => {
            const isActive = this.typeFilter === type;
            return html`
              <button
                type="button"
                class="type-tab ${isActive ? "active" : ""}"
                @click="${() => {
                  this.typeFilter = type;
                  this.requestUpdate();
                }}"
              >
                ${type}
              </button>
            `;
          })}
        </div>
      </div>
    `;
  }

  _renderOptionsGrid() {
    const activePreviewId = this._getActivePreviewId();
    const selection = this._getSelectionForPreview(activePreviewId);
    let options = this._getFilteredOptions();

    // Get the active tab to check customizationType
    const isMain = activePreviewId === "main";
    const tab = !isMain ? this.tabs.find((t) => `preview-${t.id}` === activePreviewId) : null;

    // Check if we should show manual input for Initial/Name
    const typeFilterLower = (this.typeFilter || "").toLowerCase().trim();
    const tabCustomizationType = (tab?.customizationType || "").toLowerCase().trim();
    const showManual =
      typeFilterLower === "initial" || 
      typeFilterLower === "initials" || 
      typeFilterLower === "name" ||
      tabCustomizationType === "initial" ||
      tabCustomizationType === "initials" ||
      tabCustomizationType === "name";
    const isInitial = typeFilterLower === "initial" || 
                     typeFilterLower === "initials" || 
                     tabCustomizationType === "initial" ||
                     tabCustomizationType === "initials";

    // For Initial/Name types, extract unique font types (Font 1, Font 2, etc.) from individual letters
    // Check if options have the pattern "Font X Y" (e.g., "Font 1 A", "Font 2 B")
    let hasFontPattern = false;
    if (options && options.length > 0) {
      const firstOpt = options[0];
      const name = (firstOpt?.name || "").trim();
      hasFontPattern = /^Font\s+\d+\s+[A-Z]$/i.test(name);
      if (hasFontPattern) {

      }
    }

    // ALWAYS extract font types if we detect the pattern - this groups Font 1 A, Font 1 B, etc. into just "Font 1"
    // Also check if typeFilter is Initial/Name as a backup
    const isInitialType = typeFilterLower === "initial" || typeFilterLower === "initials" || typeFilterLower === "name";
    
    if ((hasFontPattern || isInitialType) && options && options.length > 0) {

      const fontTypesMap = new Map();
      const allOriginalOptions = [...options]; // Keep reference to all original options
      
      allOriginalOptions.forEach((option) => {
        // Extract font type from name like "Font 1 A" -> "Font 1"
        const name = (option.name || "").trim();
        let fontType = null;
        
        // Match "Font 1 A" -> "Font 1" (space after number, then letter)
        let fontTypeMatch = name.match(/^(Font\s+\d+)\s+[A-Z]$/i);
        if (fontTypeMatch) {
          fontType = fontTypeMatch[1];
        } else {
          // Try "Font 1A" (no space between number and letter)
          fontTypeMatch = name.match(/^(Font\s+\d+)[A-Z]$/i);
          if (fontTypeMatch) {
            fontType = fontTypeMatch[1];
          } else {
            // Try "Font1 A" pattern
            fontTypeMatch = name.match(/^(Font\d+)\s+[A-Z]$/i);
            if (fontTypeMatch) {
              // Normalize "Font1" to "Font 1"
              const numMatch = fontTypeMatch[1].match(/Font(\d+)/i);
              if (numMatch) {
                fontType = `Font ${numMatch[1]}`;
              }
            }
          }
        }
        
        if (fontType) {

          if (!fontTypesMap.has(fontType)) {
            // Use the "A" option of this font type as the representative image
            const fontAOption = allOriginalOptions.find(opt => {
              const optName = (opt.name || "").toLowerCase().trim();
              // Try multiple patterns for "A"
              return optName === `${fontType.toLowerCase()} a` ||
                     optName === `${fontType.toLowerCase()}a` ||
                     optName.startsWith(`${fontType.toLowerCase()} `) && optName.endsWith(' a');
            }) || option;
            
            fontTypesMap.set(fontType, {
              id: `font-type-${fontType.replace(/\s+/g, '-')}`,
              name: fontType,
              image: fontAOption.image || option.image || "",
              type: option.type || "Font",
              fontFamily: fontType, // Store font type for preview
            });
          }
        }
      });
      
      // Convert map to array - these are the font type options to show (Font 1, Font 2, etc.)
      if (fontTypesMap.size > 0) {
        options = Array.from(fontTypesMap.values());

        // Store original options for preview lookup (to find specific letter images)
        if (tab) {
          tab._originalFontOptions = allOriginalOptions;
        } else if (isMain) {
          // For main preview, store in a way we can access it
          if (!this._mainFontOptions) this._mainFontOptions = {};
          this._mainFontOptions[this.typeFilter] = allOriginalOptions;
        }
      } else {
        // No options available
      }
    }

    if (!options || options.length === 0) {
      // If showManual is true, still show text input even if no options
      if (showManual) {
        return html`
          <div class="customizer__manual">
            <div class="manual-field">
              <input
                type="text"
                id="manual-text-input-${activePreviewId}"
                placeholder="${isInitial ? "Enter letter" : "Name"}"
                maxlength="${isInitial ? "1" : "10"}"
                value="${(() => {
                  if (tab && tab.manualText) {
                    return tab.manualText;
                  }
                  return '';
                })()}"
                @input="${(e) => {
                  const value = e.target.value;
                  if (tab) {
                    tab.manualText = value;
                    this.requestUpdate();
                    this._updateOverlayContent();
                  }
                }}"
              />
              <div class="manual-counter">
                ${(() => {
                  const currentValue = tab?.manualText || '';
                  return isInitial ? `${currentValue.length}/1` : `${currentValue.length}/10`;
                })()}
              </div>
            </div>
          </div>
        `;
      }
      
      return html`
        <div style="padding: 2rem; text-align: center; color: #999;">
          <p>No customization options available.</p>
        </div>
      `;
    }

    // Normal options grid - show options like everything else, add text input below if showManual is true
    return html`
      <div>
        <div class="options-grid">
        ${options.map((option) => {
          // Check if option is selected (handle both single selection and array for Family Birth Flower Bouquet)
          // For Family Birth Flower Bouquet, don't show selected state (no checkbox behavior)
          let isSelected = false;
          const isFamilyBouquet = this._isFamilyBirthFlowerBouquet();
          if (!isFamilyBouquet && selection) {
            if (Array.isArray(selection)) {
              // Multiple selections for Family Birth Flower Bouquet
              isSelected = selection.some(
                (sel) => (sel.id && option.id && sel.id === option.id) || 
                         (sel.name && option.name && sel.name === option.name)
              );
            } else {
              // Single selection
              isSelected =
                (selection.id && option.id && selection.id === option.id) || 
                (selection.name && option.name && selection.name === option.name);
            }
          }
          // Fix image URL if it doesn't have protocol
          let imageUrl = option.image || "";
          if (imageUrl) {
            // Handle protocol-relative URLs (starting with //)
            if (imageUrl.startsWith("//")) {
              imageUrl = `https:${imageUrl}`;
            }
            // Handle relative URLs (starting with /)
            else if (imageUrl.startsWith("/")) {
              // Convert relative path to full URL using the shop domain
              // Extract shop domain from current page or use window.location
              const shopDomain =
                window.Shopify?.shop || window.location.hostname;
              const protocol = window.location.protocol;
              imageUrl = `${protocol}//${shopDomain}${imageUrl}`;
            }
            // Handle URLs that don't start with http:// or https://
            else if (
              !imageUrl.startsWith("http://") &&
              !imageUrl.startsWith("https://")
            ) {
              // If it's a relative path without leading slash, prepend shop domain
              const shopDomain =
                window.Shopify?.shop || window.location.hostname;
              const protocol = window.location.protocol;
              imageUrl = `${protocol}//${shopDomain}/${imageUrl}`;
            }
          }
          return html`
            <div
              class="option ${isSelected ? "selected" : ""}"
              data-image="${imageUrl}"
              data-name="${option.name}"
              data-value="${option.name}"
              data-type="${option.type}"
              @click="${() => this._selectOption(option)}"
              @mouseenter="${() => {
                /* Show preview on hover */
              }}"
              @mouseleave="${() => {
                /* Restore selection */
              }}"
            >
              ${imageUrl
                ? html`
                    <img
                      src="${imageUrl}"
                      alt="${option.name}"
                      width="50"
                      height="50"
                      onerror="this.style.display='none';"
                    />
                  `
                : html`
                    <span>${option.name ? option.name.charAt(0) : ""}</span>
                  `}
              ${isSelected
                ? html`
                    <span class="option-checkmark">✓</span>
                  `
                : ""}
            </div>
          `;
        })}
      </div>
      ${showManual
        ? html`
            <div class="customizer__manual" style="margin-top: 1.5rem;">
              <div class="manual-field">
                <input
                  type="text"
                  id="manual-text-input-${activePreviewId}"
                  placeholder="${isInitial ? "Enter letter" : "Name"}"
                  maxlength="${isInitial ? "1" : "10"}"
                  value="${(() => {
                    if (tab && tab.manualText) {
                      return tab.manualText;
                    } else if (isMain && this._mainManualText) {
                      return this._mainManualText;
                    }
                    return '';
                  })()}"
                  @input="${(e) => {
                    const value = e.target.value;
                    if (tab) {
                      tab.manualText = value;
                    } else if (isMain) {
                      // Store manual text for main preview
                      this._mainManualText = value;
                    }
                    this.requestUpdate();
                    this._updateOverlayContent();
                  }}"
                />
                <div class="manual-counter">
                  ${(() => {
                    const currentValue = tab?.manualText || '';
                    return isInitial ? `${currentValue.length}/1` : `${currentValue.length}/10`;
                  })()}
                </div>
              </div>
            </div>
          `
        : ""}
      </div>
    `;
  }

  render() {
    const totalPrice = this._calculateTotal();
    const formattedPrice = (totalPrice / 100).toFixed(2);

    return html`
      ${this.cssComponents
        ? html`<link rel="stylesheet" href="${this.cssComponents}" />`
        : ""}
      ${this.cssCustom
        ? html`<link rel="stylesheet" href="${this.cssCustom}" />`
        : ""}
      ${this.cssOverrides
        ? html`<link rel="stylesheet" href="${this.cssOverrides}" />`
        : ""}

      <style>
        /* Drawer overlay - must be above everything including header */
        /* Applied globally when rendered to body */
        .customizer-modal-overlay {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          width: 100vw !important;
          height: 100vh !important;
          background: rgba(0, 0, 0, 0.5) !important;
          z-index: 2147483647 !important;
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
          transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s,
            visibility 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s !important;
          backdrop-filter: blur(0px) !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        .customizer-modal-overlay.is-open {
          opacity: 1 !important;
          visibility: visible !important;
          pointer-events: auto !important;
        }

        /* Drawer content - slides in from right */
        .customizer__modal-content {
          width: 31.5rem !important;
          max-width: 31.5rem !important;
          background: white !important;
          font-size: 14px !important;
          line-height: 1.4 !important;
          color: #333 !important;
          position: fixed !important;
          top: 0 !important;
          right: -100% !important;
          height: 100vh !important;
          max-height: 100vh !important;
          overflow: hidden !important;
          transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1) 0s !important;
          box-shadow: -2px 0 20px rgba(0, 0, 0, 0.2) !important;
          z-index: 2147483647 !important;
          will-change: right !important;
          transform: translateZ(0) !important;
          margin: 0 !important;
          display: flex !important;
          flex-direction: column !important;
        }

        .customizer-modal-overlay.is-open .customizer__modal-content {
          right: 0 !important;
        }

        /* Scrollable content area */
        .customizer__content-scrollable {
          flex: 1;
          overflow-y: auto;
          padding-bottom: 1rem;
        }

        @media (max-width: 768px) {
          .customizer__modal-content {
            width: 100% !important;
            max-width: 100vw !important;
            right: -100% !important;
          }
          
          .customizer-modal-overlay.is-open .customizer__modal-content {
            right: 0 !important;
          }

          /* Header adjustments */
          .customizer__header {
            padding: 0.75rem 1rem !important;
            font-size: 16px !important;
            min-height: 48px !important;
          }

          /* Product header - keep side by side on mobile */
          .customizer__product-header {
            flex-direction: row !important;
          }

          .customizer__product-image {
            width: 100px !important;
            height: auto !important;
            align-self: stretch !important;
          }

          .customizer__product-image img {
            width: 100% !important;
            height: 100% !important;
            object-fit: cover !important;
          }

          .customizer__product-info {
            padding: 1rem !important;
            flex: 1 !important;
          }

          .customizer__product-title {
            font-size: 16px !important;
          }

          /* Preview circles - smaller on mobile */
          .customizer__previews {
            padding: 1rem 0.5rem !important;
            gap: 0.5rem !important;
            flex-wrap: wrap !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch !important;
          }

          .preview-circle {
            width: 60px !important;
            height: 60px !important;
            max-width: 60px !important;
            max-height: 60px !important;
            min-width: 60px !important;
            min-height: 60px !important;
            flex-shrink: 0 !important;
          }

          .preview-image {
            width: 60px !important;
            height: 60px !important;
            max-width: 60px !important;
            max-height: 60px !important;
            min-width: 60px !important;
            min-height: 60px !important;
          }

          .preview-image.preview-bloom-circle {
            width: 56px !important;
            height: 56px !important;
            max-width: 56px !important;
            max-height: 56px !important;
            min-width: 56px !important;
            min-height: 56px !important;
          }

          /* Options grid - 4 columns on mobile */
          .customizer__options {
            padding: 0.75rem !important;
          }

          .options-grid {
            grid-template-columns: repeat(4, 1fr) !important;
            gap: 0.5rem !important;
          }

          /* Option buttons - full width on mobile */
          .option-button {
            width: 100% !important;
            min-height: 44px !important;
            padding: 0.75rem 1rem !important;
            font-size: 14px !important;
          }

          /* Text inputs - larger for mobile */
          .manual-text-input {
            font-size: 16px !important;
            min-height: 44px !important;
            padding: 0.75rem !important;
          }

          /* Actions/footer - better spacing */
          .customizer__actions {
            padding: 1rem !important;
            border-top: 1px solid #eee !important;
          }

          .customizer__add-cart {
            width: 100% !important;
            min-height: 48px !important;
            font-size: 16px !important;
            padding: 0.875rem 1.5rem !important;
          }

          /* Scrollable content - better touch scrolling */
          .customizer__content-scrollable {
            -webkit-overflow-scrolling: touch !important;
            padding-bottom: 1.5rem !important;
          }

          /* Type tabs - horizontal scroll on mobile */
          .customizer__type-tabs-wrapper {
            padding: 0 !important;
          }

          .customizer__type-tabs {
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch !important;
            flex-wrap: nowrap !important;
            padding: 0 !important;
          }

          .customizer__type-tab {
            flex-shrink: 0 !important;
            min-width: auto !important;
            padding: 0.5rem 1rem !important;
            font-size: 14px !important;
          }

          /* Add preview button - smaller on mobile */
          .add-preview {
            width: 60px !important;
            height: 60px !important;
            font-size: 20px !important;
          }

          /* Birthstone preview - smaller on mobile */
          .preview-birthstone-image {
            width: 60px !important;
            height: 60px !important;
          }

          .preview-birthstone-image img {
            width: 60px !important;
            height: 60px !important;
            max-width: 60px !important;
            max-height: 60px !important;
          }

          /* Price breakdown - stack on mobile */
          .customizer__price-breakdown {
            white-space: normal !important;
            font-size: 12px !important;
          }

          .customizer__price-total {
            font-size: 18px !important;
          }

          /* Close button - larger touch target */
          .customizer__close {
            min-width: 44px !important;
            min-height: 44px !important;
            padding: 0.5rem !important;
          }

          /* Special request toggle - better spacing */
          .customizer__toggles {
            padding: 0.75rem 1rem 0.5rem !important;
          }

          .customizer__special-request,
          .customizer__gift-wrap {
            padding: 0 !important;
            margin-bottom: 0 !important;
          }

          .customizer__special-request {
            margin-bottom: 0.25rem !important;
          }

          .customizer__toggle-wrapper {
            display: flex !important;
            align-items: center !important;
            gap: 0.75rem !important;
            padding: 0.25rem 0 !important;
          }

          /* Grid for addon selection - single column */
          .customizer__add-addon-view {
            padding: 1rem !important;
          }

          .customizer__add-addon-view > div[style*="grid"] {
            grid-template-columns: 1fr !important;
            gap: 0.75rem !important;
          }
        }

        .customizer__options {
          padding: 0px 1rem 1rem 1rem;
        }

        .customizer__header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem;
          border-bottom: 1px solid #eee;
          color: #000;
          font-weight: 600;
          font-size: 16px;
        }

        /* Product Header */
        .customizer__product-header {
          display: flex;
          background: #fafafa;
        }

        .customizer__product-image {
          flex-shrink: 0;
          width: 130px;
          height: 130px;
          overflow: hidden;
          background: #fff;
        }

        .customizer__product-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .customizer__product-info {
          flex: 1;
          padding: 1rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .customizer__product-title {
          font-size: 18px;
          font-weight: 600;
          color: #221a18;
          margin: 0 0 0.5rem 0;
          line-height: 1.3;
        }

        .customizer__product-variants {
          font-size: 14px;
          color: #666;
        }

        .customizer__price-breakdown {
          font-size: 14px;
          color: #999;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .customizer__price-total {
          font-size: 20px;
          font-weight: 600;
          color: #221a18;
        }

        /* Preview circles */
        .customizer__previews {
          display: flex;
          gap: 0.75rem;
          padding: 2rem 1rem;
          background: #fff;
          justify-content: center;
          align-items: center;
        }

        .preview-circle {
          width: 80px !important;
          height: 80px !important;
          max-width: 80px !important;
          max-height: 80px !important;
          min-width: 80px !important;
          min-height: 80px !important;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

        .preview-circle.active {
          border-color: #000000;
          opacity: 1 !important;
        }

        .preview-circle:hover {
          opacity: 1 !important;
        }

        .preview-circle:hover .preview-image {
          border-color: #000000;
          box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);
        }

        .preview-image {
          width: 80px !important;
          height: 80px !important;
          max-width: 80px !important;
          max-height: 80px !important;
          min-width: 80px !important;
          min-height: 80px !important;
          background: #fef7f7;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          border: 1px #e6c0c2 solid;
          overflow: visible;
        }

        /* Material-based background colors */
        .preview-image.preview-gold {
          background: #fef7f7;
          border-color: #e6c0c2;
        }

        .preview-image.preview-silver {
          background: #f5f5f5;
          border-color: #d0d0d0;
        }

        /* Shape-based border radius */
        .preview-image.preview-circle {
          border-radius: 50%;
        }

        .preview-image.preview-oval {
          width: 70px !important;
          height: 85px !important;
          max-width: 70px !important;
          max-height: 85px !important;
          min-width: 70px !important;
          min-height: 85px !important;
          border-radius: 50% !important;
          overflow: hidden;
        }
        .preview-image.preview-oval::before {
          display: none;
        }

        .preview-image.preview-rectangle {
          border-radius: 8px;
          width: 85px;
          height: 85px;
        }
        .preview-image.preview-rectangle::before { 
          display: none;
        }

        .preview-image:before {
          top: 4px;
          height: 8px;
          width: 8px;
          border-radius: 50%;
          background: #fff;
          position: absolute;
          z-index: 2;
          content: "";
          border: 1px #e6c0c2 solid;
        }

        .preview-image.preview-silver:before {
          border-color: #d0d0d0;
        }

        .preview-image img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          position: relative;
          z-index: 1;
        }

        .preview-image.preview-circle img {
          border-radius: 50%;
        }

        .preview-image.preview-oval img {
          border-radius: 30%;
        }

        .preview-image.preview-baby-bloom.preview-oval img {
          transform: scale(1.55);
        }

        /* Baby Bloom on bracelet: round chip, same bloom zoom as oval */
        .preview-image.preview-bloom-circle {
          width: 70px !important;
          height: 70px !important;
          max-width: 70px !important;
          max-height: 70px !important;
          min-width: 70px !important;
          min-height: 70px !important;
          border-radius: 50% !important;
          overflow: hidden;
        }

        .preview-image.preview-bloom-circle::before {
          display: none;
        }

        .preview-image.preview-bloom-circle img {
          width: 100%;
          height: 100%;
          max-width: none !important;
          max-height: none !important;
          object-fit: contain;
          object-position: center;
          transform: scale(1.45);
          border-radius: 50%;
        }

        .preview-image.preview-rectangle img {
          border-radius: 8px;
        }

        .preview-image.birthstone-preview {
          background: transparent;
          border: none;
          border-radius: 0;
        }

        .preview-image.birthstone-preview:before {
          display: none;
        }

        .preview-image.birthstone-preview img {
          border-radius: 0;
          object-fit: contain;
        }

        .preview-count-badge {
          position: absolute;
          top: -10px;
          right: -10px;
          background: #007cba;
          color: white;
          border-radius: 50%;
          min-width: 28px;
          height: 28px;
          padding: 0 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: bold;
          border: 3px solid white;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
          z-index: 10;
          line-height: 1;
        }

        .preview-image {
          position: relative;
        }

        .add-preview {
          background: #aeaeae;
          color: white;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          font-size: 32px;
          font-weight: bold;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .add-preview:hover {
          background: #000;
        }

        .preview-remove {
          position: absolute;
          top: -8px;
          right: -8px;
          width: 20px;
          height: 20px;
          border: 1px solid #e6c0c2;
          border-radius: 50%;
          background: white;
          color: #666;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          transition: all 0.2s ease;
        }

        .preview-remove:hover {
          background: #ff4444;
          color: white;
          border-color: #ff4444;
        }

        /* Family Birth Flower Bouquet Preview */
        .customizer__family-bouquet-preview {
          display: flex;
          gap: 0.75rem;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          padding: 0.5rem;
        }

        .family-bouquet-flower {
          position: relative;
          background: #fff;
        }

        .family-bouquet-flower-image {
          width: 80px;
          height: 80px;
          border-radius: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .family-bouquet-flower-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .family-bouquet-flower-remove {
          position: absolute;
          top: -4px;
          right: -4px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.7);
          color: #fff;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          line-height: 1;
          padding: 0;
          z-index: 10;
          transition: all 0.2s ease;
        }

        .family-bouquet-flower-remove:hover {
          background: rgba(0, 0, 0, 0.9);
          transform: scale(1.1);
        }

        .family-bouquet-empty {
          color: #999;
          font-size: 14px;
          padding: 1rem;
          text-align: center;
        }

        /* Birthstone Preview - Just the image, no circle/oval */
        .preview-birthstone-image {
          cursor: pointer;
          transition: opacity 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 80px !important;
          height: 80px !important;
          max-width: 80px !important;
          max-height: 80px !important;
        }

        .preview-birthstone-image:hover {
          opacity: 0.8;
        }

        .preview-birthstone-image.active {
          border: 2px solid #000000;
          opacity: 1 !important;
        }

        .preview-birthstone-image img {
          width: 80px;
          height: 80px;
          object-fit: contain;
          object-position: center;
          overflow: hidden;
          border-radius: 100px;
          max-width: 80px;
          max-height: 80px;
        }

        .preview-birthstone-image .preview-remove {
          position: absolute;
          top: -8px;
          right: -8px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.7);
          color: #fff;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          line-height: 1;
          padding: 0;
          z-index: 10;
          transition: all 0.2s ease;
        }

        .preview-birthstone-image .preview-remove:hover {
          background: #ff4444;
        }

        .preview-birthstone-image .preview-count-badge {
          position: absolute;
          top: -8px;
          right: -8px;
          background: #221a18;
          color: #fff;
          border-radius: 50%;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: bold;
        }

        /* Type tabs */
        .customizer__type-tabs-wrapper {
          padding: 0 1rem 0 1rem;
        }

        .customizer__type-tabs {
          display: flex;
          gap: 0;
          flex-wrap: wrap;
          justify-content: flex-start;
          border-bottom: 1px solid #f7f7f7;
        }

        .type-tab {
          padding: 1rem 1.5rem;
          border: none;
          background: transparent;
          color: #666;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          transition: all 0.2s;
          text-transform: uppercase;
          letter-spacing: 0.2em;
        }

        .type-tab:hover {
          color: #221a18;
          background: #f9f9f9;
        }

        .type-tab.active {
          color: #221a18;
          background: #f9f9f9;
        }

        /* Type and Option Display */
        .customizer__type-option-display {
          padding: 1rem;
        }

        /* Options grid */
        .options-grid {
          display: grid;
          justify-content: center;
          grid-template-columns: repeat(6, fit-content(50px));
          gap: 1rem;
        }

        .customizer__options .option {
          width: 60px;
          height: 60px;
          border: 2px solid transparent;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
          position: relative;
        }

        .customizer__options .option:hover {
          border-color: #000;
        }

        .customizer__options .option.selected {
          border-color: #000 !important;
          border-width: 2px !important;
        }

        .option-checkmark {
          position: absolute;
          top: -6px;
          right: -6px;
          background: #007cba;
          color: white;
          border-radius: 50%;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: bold;
          border: 3px solid white;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
          z-index: 10;
          line-height: 1;
        }

        .customizer__options .option img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }

        .customizer__options .option span {
          font-size: 12px;
          color: #666;
          text-align: center;
        }

        /* Manual input */
        .customizer__manual {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
        }

        .customizer__manual .manual-field input {
          width: 220px;
          text-align: center;
        }

        .customizer__manual .manual-fonts {
          display: flex;
          gap: 8px;
          justify-content: center;
        }

        .customizer__manual .font-btn {
          width: 50px;
          height: 50px;
          border: 1px #e6c0c2 solid;
          border-radius: 50%;
          background: #fff;
          color: #221a18;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
          position: relative;
          padding: 0;
        }

        .customizer__manual .font-btn:hover {
          border-color: #000;
        }

        .customizer__manual .font-btn.is-active {
          background: #221a18;
          color: #fff;
          border-color: #221a18;
        }

        .customizer__manual .manual-counter {
          font-size: 12px;
          color: #666;
        }

        /* Scrollable content area */
        .customizer__content-scrollable {
          flex: 1;
          overflow-y: auto;
          padding-bottom: 1rem;
        }

        /* Actions - Sticky at bottom */
        .customizer__actions {
          position: sticky;
          bottom: 0;
          background: white;
          padding: 1rem;
          z-index: 10;
          flex-shrink: 0;
        }

        .customizer__add-cart {
          width: 100%;
          background: #221a18;
          transition: all 0.3s ease;
          color: #fff;
          padding: 1rem;
          border: none;
          cursor: pointer;
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }

        .customizer__add-cart:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          pointer-events: auto; /* Ensure button is still clickable for visual feedback */
        }
        
        /* Ensure actions section is always visible */
        .customizer__actions {
          display: flex !important;
          visibility: visible !important;
        }
        
        .customizer__add-cart {
          display: block !important;
          visibility: visible !important;
        }

        /* Special Request Toggle Switch */
        .customizer__toggle-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          cursor: pointer;
          font-size: 14px;
        }

        .customizer__special-request-toggle,
        .customizer__gift-wrap-toggle {
          position: absolute;
          opacity: 0;
          width: 0;
          height: 0;
        }

        .customizer__toggle-switch {
          position: relative;
          display: inline-block;
          width: 36px;
          height: 20px;
          background-color: #ccc;
          border-radius: 20px;
          transition: background-color 0.3s;
          flex-shrink: 0;
        }

        .customizer__special-request-toggle:checked + .customizer__toggle-switch,
        .customizer__gift-wrap-toggle:checked + .customizer__toggle-switch {
          background-color: #221a18;
        }

        .customizer__toggle-slider {
          position: absolute;
          top: 2px;
          left: 2px;
          width: 16px;
          height: 16px;
          background-color: white;
          border-radius: 50%;
          transition: transform 0.3s;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }

        .customizer__special-request-toggle:checked + .customizer__toggle-switch .customizer__toggle-slider,
        .customizer__gift-wrap-toggle:checked + .customizer__toggle-switch .customizer__toggle-slider {
          transform: translateX(16px);
        }

        /* Special Request Textarea Animation */
        .customizer__special-request-input {
          max-height: 0;
          opacity: 0;
          overflow: hidden;
          margin-top: 0;
          padding-top: 0;
          padding-bottom: 0;
          transition: max-height 0.6s ease-in-out, opacity 0.6s ease-in-out, margin-top 0.6s ease-in-out;
          will-change: max-height, opacity, margin-top;
        }

        .customizer__special-request-input.is-visible {
          max-height: 200px;
          opacity: 1;
          margin-top: 0.75rem;
        }

        .customizer__special-request-textarea {
          width: 100%;
          padding: 0.75rem;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-family: inherit;
          font-size: 14px;
          resize: vertical;
        }

        .customizer__pricing {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
          font-size: 0.875rem;
        }

        .base-price {
          color: #666;
        }

        .addon-price {
          color: #666;
        }

        .total-price {
          font-weight: 600;
          color: #333;
          font-size: 1rem;
          border-top: 1px solid #eee;
          padding-top: 0.5rem;
          margin-top: 0.25rem;
        }

        /* Drawer close button */
        .modal__close {
          position: absolute;
          top: 1.5rem;
          right: 1.5rem;
          background: white;
          border: none;
          cursor: pointer;
          font-size: 1.5rem;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          z-index: 100;
        }
      </style>

      <button
        class="btn btn--primary btn--customize"
        type="button"
        @click="${this._toggleModal}"
      >
        ${this.personalizeButtonText || 'Personalize'}
      </button>
    `;
  }
}

customElements.define("customizer-app", CustomizerApp);